export function QueenHearts(done: boolean) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 1458 2048"
      width="fit-content"
      height="200"
      xmlns="http://www.w3.org/2000/svg"
    >
      {done ? (
        <>
          <path
            transform="translate(0)"
            d="m0 0h1458v2048h-1458z"
            fill="#fff"
          />
          <path
            transform="translate(805,275)"
            d="m0 0h34l6 1 50 1 7 1v1l-9 1 1 4 4 5 5 2h11l5-5 2-6-1-2 7-1h16l10 1-2 10-2 5-7 7v9l-4 5h-5l-3-6-1-7h-7l-6 5-2 5v10l5 8 8 4 7 1 9-4 4-4 2-4 1-8 4 1 4 7v7l-4 9-2 5h14l6 4 4 5v4h-6l-5-2h-7l-6 3-4 5-2 5 1 10 4 6 7 4 4 1h8l6-3 3-4v-2l-9-3-1-4 5-5 7 1 5 2 7-4 8-1 7 3 5 6 1 2v9l-7 8-5 3-2 11-3 2h-6l-2-1v-6l1-5-5-1-6 2-2 4-3 9 1 7 5 5 6 3h11l8-5 6-9 1-2 3 1 2 5v9l-2 8 11-1 7 4 5 5v2l-16 1-7 2-7 6-3 8 2 10 5 5 6 3h9l7-3 1-5-10-4-1-5 3-4 4-1 8 3 7-1h10l7 3 5 6v10l-6 7-4 3-3 10-2 2h-6l-3-6-1-7h-7l-6 5-2 4v8l4 8 9 5 6 1h9l7-4 7-9 3-1 1 2v9l-7 11-4 2v2h15l12-2 9-5 5 1 2 5 4 1-6-16-8-20-8-25-6-26-4-26-2-21v-57l4-38 4-22 1-1h8l-2 10-6 27-4 30-1 11v28l2 13 2 20v14h2l3 19 6 23 10 30 8 20 6 17h-54l-4 1-13 1-13 4-9 3-5 2-3 3h-2v4h2l12 20 15 23 12 19 42 66 6 10v3l-58 20h-3l10 14 9 10v2l4 1-2-7v-12l7 1 21 8 13 8 12 9 10 8 2 1-1-11v-68l-5-2-7-8-2-6-7 1-10 2 1-14-9-5-7-8-2-4v-14l4-8 7-6 5-3h2l-2-19 10 3 4 1 5-9 6-5 6-3 4-1h11l10 5 9 9 2 3 12-3 5-1-1 12-1 6 8 2 8 6 6 8 1 3v12l-4 8-7 7-10 5 1 7 2 7-3 1-11-4-4-3-2 6-4 6-8 6-5 3-1 2v25l1 17 2 12 4-4 12-17 13-16 16-16 2 4 2 14v22l-3 16-3 9h-2v-4l-4 10h-2l-1 5-8 14-3 6-12 12-12 4-3-1h2l-5-50-2-28-1-37-6-1v27l2 47 4 31 3 11h2v3l-7 1h-2v8l-8 7-7 7-11 14-8 11-9 16-7 15-4 13-1 13 3 10 4 5 10 6 13 4h15l15-4 16-8 8-6 7-2 13-2 11-7 5-7v-6l-4-3 1-7 1-5h2v-7l6-3h5l1 54 1 147v161l-7 8-12 10-17 13-11 9-8 7-13 10h-2v2l-6 4h-2v2l-34 24-20 14-5 5-15 10-16 10-24 14-15 9-27 14-22 12-21 10-12 5-7 42-7 26-9 26-12 26-10 19-12 19-14 19-13 16-11 12-20 20-8 7-11 9-4-1-5-64v-18l5-5 11-13 13-18 9-15 12-23 7-16 11-30 5-13-13 4-6-1-14-7-2 8 7 5-1 2-3 1h-8l-16-8-23-9-7-1-11-3-11-1-25-5-15-2-37-2h-13l-35 2-41 7-24 6-29 10-19 9-5 4-7 16-5 8 2 5 5 10 6 10v2l9 2 14 6 14 9 8 8 8 13 5 15 1 8v12l-3 16-2 7 16 30 10 18 6 10 5 10 6 10 6 12 6 10 5 10 9 15 8 16 2 5-3 1h-92l-172 1-28 1-1-1 1-9 5-22 4-28 2-23 1-9-1-10h-2v-9l-2-17-2-18-6-32-6-23-8-25-7-19-4-11 1-1h34l23-2 17-3 11-4 12-3 7-3-4-6v-3h-2l-16-26-15-23-12-20-14-22-15-24-12-19-2-4 31-10 27-9-2-6-6-11-9-10-5-3 2 12v12l-3 1-13-5-18-10-14-10-11-9-4-4v41l2 35 8 6 7 11h18l-3 9v4l10 5 8 8 3 7v10l-5 10-7 6-10 4 2 20-10-3-6-2-1 6-5 7-10 5h-16l-9-4-6-5-6-9-17 1 2-11 1-6-10-6-7-8-3-10 1-9 4-7 8-7 5-2-4-15h7l14 2 2-7 8-8 5-3h2l-2-47-1-4-13 17-10 13-8 9-8 7-8 4-2-1-2-15v-31l3-14 5-15 8-15 9-11 4-6-2-6-4-8-1-6-4-2-6-4 1-5 2-1 4 4 5-1 11-7 10-7 6-4v-3l-9-1-4-3v-2h-8l2-3 8 1v-4l-8 1-2-2 12-6h2v-2l-7-2-4-3-3-2v-2l-1-3-4-2 5-1-2-5-5-6-4-2 8-2v-6l1-2h4l1 4h7v1l-10 3 2 5 3 2 6-1 2-2v-5h3v2h2l2-2 2 9 5 2 3 5 1 3v7h2l1-5 8-18 4-5 3-2 3 1-7 15-2 9v25l-7 8-4 5-23 14-5 3 4 1 5-1h8l5 3 6 5 4-1 11-8 8-8 11-16 10-17 8-19 4-14v-16l-5-10-6-5-12-5-6-1h-18l-16 4-16 7-9 5h-3v2l-9 2-8 2-8 5-3 5v9l3 4-2 9-2 3-9 1-1-53v-298l10-10 9-6 14-12 14-11 11-9 26-20 16-12 18-13 19-13 12-8 16-10 7-4 4 1 10 8 20 14 28 19 20 13 25 15 16 10-5-5-21-12-24-15-15-11-17-12-18-14-13-11-2-4 16-10 5-3 7-3 4-1v-2l7-5 9-3 4-5 11-5v3l-7 4 4 4 12 9 15 11 5 2 4-6 11-14 7-10 2-5-5-2-11-9-1-1-7 1-3 2 9 6 3 6v6l-7 8-5 2-9-1-6-5-2-4v-9l-7 3 1-3 5-3h2l1-4 28-14 9-4h2l2-23 5-25 7-25 10-26 12-25 12-21 15-22 9-12 11-13 9-11 17-17 5-6 8-7 9-9 4-1 2 9 3 35v41l-4 2-2 4-10 11-12 17-12 21-8 16-10 23-7 21-4 13 10-2 11-5 12-3 9 1v2l-8-1-6 3 3 3 5 2-1 4-5 6-7-2-12-7-11 1v2l5 2 18 10 25 12 26 10 24 7 36 7 25 3 17 1h26l30-2 29-4 26-6 23-7 16-6 16-7h2v-5l-5-3-5-8v-2l10-5h2l1-8-28 12-28 9-24 6-28 5-18 2h-9v-1l23-4 7-2 25-5 26-7 33-11 24-10 4-10 5-13-2-9-9-15-16-8-11-7-10-9-9-12-7-14-4-15v-25l2-8-1-7-10-18-8-16-9-16-8-16-5-9-6-11-7-12-3-7-9-15-3-7-8-14-5-4z"
            fill="#13226A"
          />
          <path
            transform="translate(212,266)"
            d="m0 0h344l364 1 266 1 32 1v284l1 822 1 117 2 190v83h-217l-674-1-118-1-1-359zm593 9-10 2 5 4 10 17 3 7 9 15 3 8 7 11 4 8 6 11 5 10 18 33 6 12 6 11-1 8-1 5v25l4 15 7 14 9 12 7 7 15 10 16 8 5 9 4 7 1 7-8 22-10 5-29 11-33 10-25 6-18 3-1 1-23 4v1h9l31-4 28-6 24-7 20-7 14-6 9-4-1 8-6 2-6 3 2 5 4 6 4 2v5l-9 3-19 8-22 7-23 6-30 5-21 2-18 1h-26l-28-2-36-6-25-6-24-8-24-10-24-12-13-8h-2v-2l11-1 12 7 7 2 6-7-1-4-7-3 1-2 5-2 8 1v-2l-9-1-12 3-11 5-10 2 5-16 6-18 10-23 8-16 10-18 12-17 11-13 3-3v-2l4-2v-41l-3-35-2-9-5 2-14 14-6 5-7 8-13 13-9 11-11 13-14 20-11 17-12 22-10 21-9 24-7 25-5 25-2 23-6 2-25 12-8 4-1 4-5 2-3 2 1 2 6-3v9l4 6 4 3 9 1 6-3 6-7-1-9-4-5-7-4 5-3h5l8 7 7 5h2l-5 10-13 16-6 9-5-2-16-12-15-11 5-4 3-2-1-2-12 6-5 5-8 3-6 4v2l-6 2-10 5-16 10 2 4 10 9 13 10 16 12 12 8 18 13 15 9 19 11 8 5 1 2-19-11-32-20-24-16-20-14-17-12-7-6-5 1-20 12-10 7-16 11-17 12-32 24-15 12-12 9-13 11-14 11-7 6-6 4-8 8v298l1 53 9-1 3-6 1-6-3-4v-9l3-5 10-6 13-2 2-1v-2l5-1 15-8 18-6 6-1h18l12 3 9 5 5 6 3 7v16l-5 17-9 20-13 21-9 11-7 7-10 7-5-1-6-6-3-1h-8l-8 1-1-1 22-13 9-7 4-6 4-4v-25l3-12 6-13-4 1-5 5-8 16-2 5v3h-2v-7l-3-7-2-2-4-1-2-9-4 2v-2h-3v5l-5 3-5-1-3-4v-2l10-3v-1h-7l-1-4h-4l-1 3v5l-8 2 4 2 6 7 1 4-5 1 4 2 2 4-1 2 12 6h2v2l-6 2-8 4 4 2 6-1v4l-8-1-2 3h8l2 4 2 1 9 1-1 4-11 7-13 9-4 2-4-1-3-3-3 2 1 5 7 5h2l2 9 5 9-2 6-8 9-7 11-7 16-4 15-1 6v31l2 15 2 1 8-4 12-11 9-11 18-24 1 4 2 47-5 2-8 7-3 4-1 5-14-2h-7l4 15-5 2-9 8-3 6-1 9 3 10 8 9 9 5-2 10-1 7 17-1 8 11 7 5 6 2h16l10-5 5-7 1-6 14 5h2l-2-20 10-4 8-7 4-9v-10l-4-8-7-7-10-5 1-6 2-7h-18l-7-11-5-4-3-2-2-35v-41l7 7 16 12 13 8 15 8 10 3 2-1v-12l-2-12 6 4 8 9 8 15v2l-33 11-25 8 8 14 11 17 30 48 24 38 13 21h2l1 4 3 5-9 4-17 4-8 3-21 3-15 1h-34l-1 2 9 23 8 24 7 26 5 24 3 19 2 23 1 11v3h2l1 14-2 14-2 21-4 27-4 16-1 9 1 1 28-1 194-1h70l3-1-2-5-8-16-10-17-9-17-6-10-6-12-5-8-4-8-13-23-16-30 4-15 1-8v-12l-2-12-6-15-8-11-7-7-17-10-16-6h-3l-2-5-8-14-3-6 2-5 11-22 10-6 18-8 31-10 27-6 31-5 35-2h13l37 2 26 4 19 4h8l12 4 7 1 27 11 9 5h8l4-2-4-4-3-2 2-8 16 8 7-1 10-3-6 16-11 30-16 33-11 18-14 19-12 14-3 3v18l5 64 4 1 14-12 13-12 20-20 9-11 14-18 7-10 13-21 14-27 8-19 11-33 5-21 4-25 2-12 27-12 27-14 19-10 18-10 13-8 17-10 19-12 12-8 5-5 17-12 20-14 17-12v-2l5-2 3-2v-2l4-2 12-9 9-8 9-7 28-22 7-7 1-2v-183l-1-125-1-54-8 1-3 2v7h-2l-2 7v5l4 3v6l-6 8-10 6-18 3-9 6-10 6-13 5-9 2h-15l-13-4-10-6-5-7-2-8 1-13 6-18 12-23 10-14 9-11 9-10 5-4 3-3v-8h7l2-1v-3h-2l-4-17-3-25-2-47v-27l6 1 1 37 4 50 3 28-2 1 9-2 7-3 12-12 5-10 6-11v-3h2l4-10v4h2l4-13 2-12v-22l-3-18-7 6-13 13-10 13-13 18-3 3-2-12-1-17v-25l4-4 9-6 4-5 3-6v-2l8 5 9 2 1-2-3-9v-4l11-6 8-9 2-5v-12l-4-8-9-8-8-3h-2l2-12v-6l-12 3-5 1-9-10-9-6-3-1h-11l-8 3-6 4-4 5-3 6-12-4-2 1 2 18-5 2-6 4-5 6-2 5v14l5 8 7 6 6 3-1 14 10-2 7-1 4 9 8 7h2v68l1 11-6-4-12-10-17-11-20-8-6-2h-4v12l2 7-4-1-2-4-8-9-9-13 9-2 37-13 15-5-1-5-15-24-15-23-11-18-13-20-12-19-14-22-6-10h-2v-4l4-1 3-3 5-2 7-2 13-4 13-1 4-1h54l-6-17-10-26-9-27-6-24-2-15h-2v-14l-3-30-1-3v-28l4-35 5-24 4-16v-3h-8l-2 5-4 25-3 31v57l3 29 5 28 6 23 10 29 8 19 2 6-4-1-3-6-6 1-7 4-12 2h-15v-2l4-2 7-11v-9l-1-2-4 2-7 9-6 3h-9l-9-2-7-5-3-7v-8l4-6 4-3h7l2 10 2 3h6l3-4 3-9 7-6 2-3v-10l-6-7-6-2h-10l-7 1-9-3-5 3-1 5 3 3 8 3-2 6-6 2h-9l-8-4-4-7-1-7 3-8 7-6 7-2 16-1-2-5-7-5-8-1-6 1 2-8v-9l-3-6h-2l-6 10-5 4-4 2h-11l-9-5-2-3-1-7 3-9 2-4 9-2 2 1-1 11 2 1h6l3-2 2-11 8-6 4-5v-9l-4-6-5-4-7-1-9 3-5 2-5-3h-5l-5 5 1 4 9 3-2 5-4 3-3 1h-8l-8-3-5-5-3-7 1-9 4-6 4-3 3-1h7l5 2h6l-1-6-7-6-2-1h-14l5-11 1-3v-7l-4-7-4-1-1 8-4 6-5 4-6 2-7-1-8-4-5-8v-10l3-6 5-4h7l2 10 2 3h5l4-5v-9l8-8 2-12 1-2-12-1h-17l-4 2 1 2-4 8-3 2h-11l-6-3-4-5v-3l9-1v-1l-7-1-50-1-6-1z"
            fill="#13236B"
          />
          <path
            transform="translate(0)"
            d="m0 0h1458v2048h-1458zm83 45-11 2-14 7-8 7-7 10-5 11-2 11v1846l2 10 7 14 10 11 14 8 11 3h1273l12-3 10-5 10-9 7-9 5-12 1-5 1-14v-1813l-1-27-4-13-7-11-8-8-10-6-10-4-6-1z"
            fill="#fff"
          />
          <path
            transform="translate(1132,574)"
            d="m0 0h11l10 5 9 9 2 3 12-3 5-1-1 12-1 6 8 2 8 6 6 8 1 3v12l-4 8-7 7-10 5 1 7 2 7-3 1-11-4-4-3-2 6-4 6-8 6-5 3-1 2v25l1 17 2 12 4-4 12-17 13-16 16-16 2 4 2 14v22l-3 16-3 9h-2v-4l-4 10h-2l-1 5-8 14-3 6-12 12-12 4-3-1h2l-5-50-2-28-1-37-6-1v27l2 47 4 31 3 11h2v3l-7 1h-2v8l-8 7-7 7-11 14-8 11-9 16-7 15-4 13-1 13 3 10 4 5 10 6 13 4h15l15-4 16-8 8-6 7-2 13-2 11-7 5-7v-6l-4-3 1-7 1-5h2v-7l6-3h5l1 54 1 147v161l-7 8-12 10-17 13-11 9-8 7-13 10h-2v2l-6 4h-2v2l-34 24-20 14-5 5-15 10-16 10-24 14-8 5-2-1 3-3 4-1-1-4-10-6-12-10-19-14-17-11-18-11-24-13-32-16-30-12-27-10-28-8-3-1-1 4-1-6-6-2 3 16v4l-10-2-18-4h-6l31 7 26 7 33 11 27 11 12 5 16 8 20 11 9 5 13 8 27 18 11 8 16 12-4 4-9 5-5-1-16-12-27-18-21-13-17-9-20-11-22-9-11-5-31-11-19-6-34-8-30-5-39-4-16-1h-41l-37 3-32 5-33 7-37 11-32 11-31 13-16 8-11 5-3-1-5-8 1-4 20-9 10-5 15-6 12-5 24-9 22-7 17-5 19-5 22-5 52-7 27-2h36l37 2 26 3-4-1-13-2-18-1-10-2-1-13 2-6 16 8 9 5 9 6 9 2-1-4-6-2-28-15-9-5v-18l6 2 29 16 7 4 6 2-2-6-42-21-5-3-1-22 1-16 5 2 30 15h4l-1-4-16-8-21-10-1-1v-14l6 2 17 9 9 3 2 1v-6l-5-2-26-13-3-1-1-2v-14l16 8 15 7v-5l-30-15-1-1v-15l17 8 9 3-1-5-3-1v-2l-9-3-13-7v-14l4 1 15 8 4 1-1-5-3-1v-2l-5-1-14-7-1-3v-10l5 2 11 7 14 5-1-3-5-3-3-3-11-6-17-11-18-10-20-9-33-11-20-4-3-3v-9h19l19 3 15 5 21 9 23 12 19 12 21 13 23 12 33 11 23 5 24 3 12 1h10l-2-13-3-14-3-26v-2h-11l-28-6-20-6-29-11-19-10-20-12-18-10-25-12-21-8-25-7-21-3-24-1-5-11 1-3 8-1h22l30 4 25 7 28 10 30 14 24 14 29 15 21 9 15 5 8 2 1-10 5-18 1-7 3-8 8-30 30-120 3-9h1v7l-16 65-20 82-11 46h11l1 2 7 2 4 1 6-20 9-21 9-14 10-13 7-7 8-7 9-7 3-2v-9l10-6 28-10 25-8h2l2-9 6-22 6-17 15-30 7-12 11-17 11-15 6-8 7-9 7-10 3-3-1-5-6-9-6-8v-3h2l10 14 9 10v2l4 1-2-7v-12l7 1 21 8 13 8 12 9 10 8 2 1-1-11v-68l-5-2-7-8-2-6-7 1-10 2 1-14-9-5-7-8-2-4v-14l4-8 7-6 5-3h2l-2-19 10 3 4 1 5-9 6-5 6-3z"
            fill="#13236A"
          />
          <path
            transform="translate(590,1024)"
            d="m0 0 20 2 1 2-11 43-14 54-13 52-11 42-4 4h-11l-11 3-1 5-7 1-1 1v16h4l17-2 9-3-1 12-1 7 18-1-4 2-16 3-25 6-24 7-36 12-21 8-13 6-12 5-16 8-5 2 1 4 4 7 6-2 25-12 37-15 40-13 25-7 40-8 31-4 27-2h41l38 3 37 5 36 8 17 5 36 12 15 6 13 6 18 8 19 11 12 6 19 12 15 10 19 13 10 8 6-1 10-6-5-5-11-8-20-14-17-11-9-6-9-5-22-12-17-8-8-4-27-11-28-10-28-8-34-8-8-2v-1h9l23 5 5 2-3-13v-7l6 1 2 3 9 2 25 7 24 9 32 13 40 20 23 13 27 18 19 14 11 9 11 7v4l-4 1-1 2-5 5-29 15-22 12-21 10-12 5-7 42-7 26-9 26-12 26-10 19-12 19-14 19-13 16-11 12-20 20-8 7-11 9-4-1-5-64v-18l5-5 11-13 13-18 9-15 12-23 7-16 11-30 5-13-13 4-6-1-14-7-2 8 7 5-1 2-3 1h-8l-16-8-23-9-7-1-11-3-11-1-25-5-15-2-37-2h-13l-35 2-41 7-24 6-29 10-19 9-5 4-7 16-5 8 2 5 5 10 6 10v2l9 2 14 6 14 9 8 8 8 13 5 15 1 8v12l-3 16-2 7 16 30 10 18 6 10 5 10 6 10 6 12 6 10 5 10 9 15 8 16 2 5-3 1h-92l-172 1-28 1-1-1 1-9 5-22 4-28 2-23 1-9-1-10h-2v-9l-2-17-2-18-6-32-6-23-8-25-7-19-4-11 1-1h34l23-2 17-3 11-4 12-3 7-3-4-6v-3h-2l-16-26-15-23-12-20-14-22-15-24-12-19-2-4 31-10 27-9h6l-6-11-7-12v-4l5-5 9-11 9-12 10-14 11-18 11-20 10-23 12-36 4-14 4-3 30-11 21-8h2l2-5 5-4 15-8 17-17 11-14 8-14 7-15 6-17z"
            fill="#030203"
          />
          <path
            transform="translate(805,275)"
            d="m0 0h34l6 1 50 1 7 1v1l-9 1 1 4 4 5 5 2h11l5-5 2-6-1-2 7-1h16l10 1-2 10-2 5-7 7v9l-4 5h-5l-3-6-1-7h-7l-6 5-2 5v10l5 8 8 4 7 1 9-4 4-4 2-4 1-8 4 1 4 7v7l-4 9-2 5h14l6 4 4 5v4h-6l-5-2h-7l-6 3-4 5-2 5 1 10 4 6 7 4 4 1h8l6-3 3-4v-2l-9-3-1-4 5-5 7 1 5 2 7-4 8-1 7 3 5 6 1 2v9l-7 8-5 3-2 11-3 2h-6l-2-1v-6l1-5-5-1-6 2-2 4-3 9 1 7 5 5 6 3h11l8-5 6-9 1-2 3 1 2 5v9l-2 8 11-1 7 4 5 5v2l-16 1-7 2-7 6-3 8 2 10 5 5 6 3h9l7-3 1-5-10-4-1-5 3-4 4-1 8 3 7-1h10l7 3 5 6v10l-6 7-4 3-3 10-2 2h-6l-3-6-1-7h-7l-6 5-2 4v8l4 8 9 5 6 1h9l7-4 7-9 3-1 1 2v9l-7 11-4 2v2h15l12-2 9-5 5 1 2 5 4 1-6-16-8-20-8-25-6-26-4-26-2-21v-57l4-38 4-22 1-1h8l-2 10-6 27-4 30-1 11v28l2 13 2 20v14h2l3 19 6 23 10 30 8 20 6 17h-54l-4 1-13 1-13 4-9 3-5 2-3 3h-2v4h2l12 20 15 23 12 19 42 66 6 10v3l-58 20h-5l3 6 7 9 4 6-1 5-6 7-4 6-15 20-12 17-7 11-7 12-12 24-4 10-7 19-6 22-1 3-36 12-21 8-6 4h-2l1 9-8 6h-2l-1 3-4 3h-2l-2 4-8 7-8 10-9 14-8 16-7 21-3 8-4-1-7-2-4-2-8-1 1-9 15-62 14-57 18-73 24-6h8v-20l-9 1-3-1v2h-4v2l-11 4h-4l1-10 2-11-16 3h-16l4-2 30-5 38-9 30-9 29-11 20-8 32-16 5-3-2-4-2-1h-7l-12 5-22 11-29 11-23 8-27 8-26 6-24 4-31 4-27 2h-51l-36-3-35-5-32-7-31-9-20-7-14-6-14-5-15-7-16-8-15-9-11-6-18-11-19-14-8-6-9-7-7-6 4-4 10-4-1 3-7 4 4 4 12 9 15 11 5 2 4-6 11-14 7-10 2-5-5-2-11-9-1-1-7 1-3 2 9 6 3 6v6l-7 8-5 2-9-1-6-5-2-4v-9l-7 3 1-3 5-3h2l1-4 28-14 9-4h2l2-23 5-25 7-25 10-26 12-25 12-21 15-22 9-12 11-13 9-11 17-17 5-6 8-7 9-9 4-1 2 9 3 35v41l-4 2-2 4-10 11-12 17-12 21-8 16-10 23-7 21-4 13 10-2 11-5 12-3 9 1v2l-8-1-6 3 3 3 5 2-1 4-5 6-7-2-12-7-11 1v2l5 2 18 10 25 12 26 10 24 7 36 7 25 3 17 1h26l30-2 29-4 26-6 23-7 16-6 16-7h2v-5l-5-3-5-8v-2l10-5h2l1-8-28 12-28 9-24 6-28 5-18 2h-9v-1l23-4 7-2 25-5 26-7 33-11 24-10 4-10 5-13-2-9-9-15-16-8-11-7-10-9-9-12-7-14-4-15v-25l2-8-1-7-10-18-8-16-9-16-8-16-5-9-6-11-7-12-3-7-9-15-3-7-8-14-5-4z"
            fill="#040203"
          />
          <path
            transform="translate(229,278)"
            d="m0 0h122l296 1v30l-1 51-1 15-16 16-5 4-7 8-13 13-9 11-11 13-14 20-11 17-12 22-10 21-9 24-7 25-5 25-2 19-1 4-25 12-28 14-19 10-22 12-22 13-20 12-45 30-17 12-13 10-10 8-16 13-14 11-16 13-14 12h-2v2h-2l-1-99v-227l1-196z"
            fill="#fff"
          />
          <path
            transform="translate(1203,1239)"
            d="m0 0 2 1v510l-3 1h-414l-1-1v-58l1-32 14-11 16-15 18-18 9-11 14-18 7-10 13-21 14-27 8-19 11-33 5-21 4-25 2-12 10-5 20-9 25-13 19-10 18-10 13-8 17-10 19-12 34-22 16-11 18-13 13-10 12-9 13-10 16-13 12-11z"
            fill="#fff"
          />
          <path
            transform="translate(1087,748)"
            d="m0 0 8 4v2l5 2 5 4 5 5 9 8 5 5 8 7-3-11-6-8-1-4 6 3 3-1 1-5h2l1 7 1 1 3 21 3 11h2v3l-7 1h-2v8l-8 7-7 7-11 14-8 11-9 16-7 15-4 13-1 13 3 10 4 5 10 6 13 4h15l15-4 16-8 8-6 7-2 13-2 11-7 5-7v-6l-4-3 1-7 1-5h2v-7l6-3h5l1 54 1 147v161l-7 8-12 10-17 13-11 9-8 7-13 10h-2v2l-6 4h-2v2l-34 24-20 14-5 5-15 10-15 9-6-1-8-7-12-11-12-9-11-8-13-9-14-9-24-14-18-10-8-4-2-2v-3l14-11 8-6h21l1-16 2-7 8-8 8-7 8-8 11-14 10-15 12-21 9-20 9-25 8-31 6-32 4-33 9-77 4-30 5-19 6-16 8-16 9-15 11-14 11-13 7-8h2l-2-7 2-1-1-4-8-10-7-7v-2l-4-2-10-10-8-7-4-4z"
            fill="#030103"
          />
          <path
            transform="translate(392,685)"
            d="m0 0 4 1 10 8 20 14 28 19 20 13 25 15 16 10 3 4-21 14-14 11-13 12-8 7-11 12-9 11-12 15-11 17-12 22-10 23-7 22-6 24-6 35-3 32-2 45-3 26-6 28-7 24-10 25-12 23-10 14-13 13-11 8-6-1-1-3 14-10 9-9 11-16 10-17 8-19 4-14v-16l-5-10-6-5-12-5-6-1h-18l-16 4-16 7-9 5h-3v2l-9 2-8 2-8 5-3 5v9l3 4-2 9-2 3-9 1-1-53v-298l10-10 9-6 14-12 14-11 11-9 26-20 16-12 18-13 19-13 12-8 16-10z"
            fill="#030103"
          />
          <path
            transform="translate(513,762)"
            d="m0 0 5 1 29 14 32 13 37 12 25 6-1 3-9-1-12-2-32 16-24 14-11 8-13 11-11 10-7 8-10 11-14 20-9 15-9 20-7 22-6 27-4 29-7 79-5 34-6 26-10 30-11 24-12 22-13 19-13 17-11 13 1 4 3 2 13-16 14-19 12-19 9-16 8-16 7-16 9-25 7-28 2-1v7l-2 11v7l-11 33-8 18-8 16-10 18-11 16-14 19-11 13-2 3h-2l3 7 9 16 1 4h-5l-9-17-9-10-5-3 2 12v12l-3 1-13-5-18-10-14-10-11-9-4-4v41l2 35 8 6 7 11h18l-3 9v4l10 5 8 8 3 7v10l-5 10-7 6-10 4 2 20-10-3-6-2-1 6-5 7-10 5h-16l-9-4-6-5-6-9-17 1 2-11 1-6-10-6-7-8-3-10 1-9 4-7 8-7 5-2-4-15h7l14 2 2-7 8-8 5-3h2l-2-47-1-4-13 17-10 13-8 9-8 7-8 4-2-1-2-15v-31l3-14 5-15 8-15 9-11 4-6-2-6-4-8-1-6-4-2-6-4 1-5 2-1 4 4 5-1 11-7 10-7 6-4v-3l-9-1-4-3v-2h-8l2-3 8 1v-4l-8 1-2-2 12-6h2v-2l-7-2-4-3-3-2v-2l-1-3-4-2 5-1-2-5-5-6-4-2 8-2v-6l1-2h4l1 4h7v1l-10 3 2 5 3 2 6-1 2-2v-5h3v2h2l2-2 2 9 5 2 3 5 1 3v7h2l1-5 8-18 4-5 3-2 3 1-7 15-2 9v25l-7 8-4 5-23 14-5 3 4 1 5-1h8l5 3 6 5 2 2h-2l3 3 5-1 11-8 12-12 10-15 12-23 9-23 7-24 6-28 3-26 2-45 3-32 6-35 7-28 8-23 9-20 12-22 11-16 11-14 12-14 14-15 10-9 11-9 13-10 13-8 3-3-2-4z"
            fill="#13226A"
          />
          <path
            transform="translate(1056,748)"
            d="m0 0 4 2 3 5-8 8-9 11-10 13-11 16-15 25-12 25-10 30-7 33-4 29-9 86-5 32-6 25-6 18-5 12-8 14-12 17-10 11-7 8-8 8-14 11-18 12-23 13-23 12-8 4-8-1-5-2 1-2 23-11 8-4h2l3-6 6-3 10-6 3-1-1-3 10-6 14-10 13-11 7-7-2-4-11-8-11-11-11-14-5-6h-35l-25-3-23-5-1-2-21-8-15-6 7 26 7 24 11 37 7 25 9 30 10-2 38 10 30 10 27 11 27 12 26 14 18 11 19 12 18 13 16 12 11 9 11 8 2 1-2 4-12 8-3 1-8-7-9-8-20-15-17-12-26-16-25-13-16-8-22-10-32-13-40-13-6-1-8 1 3 16v4l-10-2-18-4h-6l31 7 26 7 33 11 27 11 12 5 16 8 20 11 9 5 13 8 27 18 11 8 16 12-4 4-9 5-5-1-16-12-27-18-21-13-17-9-20-11-22-9-11-5-31-11-19-6-34-8-30-5-39-4-16-1h-41l-37 3-32 5-33 7-37 11-32 11-31 13-16 8-11 5-3-1-5-8 1-4 20-9 10-5 15-6 12-5 24-9 22-7 17-5 19-5 22-5 52-7 27-2h36l37 2 26 3-4-1-13-2-18-1-10-2-1-13 2-6 16 8 9 5 9 6 9 2-1-4-6-2-28-15-9-5v-18l6 2 29 16 7 4 6 2-2-6-42-21-5-3-1-22 1-16 5 2 30 15h4l-1-4-16-8-21-10-1-1v-14l6 2 17 9 9 3 2 1v-6l-5-2-26-13-3-1-1-2v-14l16 8 15 7v-5l-30-15-1-1v-15l17 8 9 3-1-5-3-1v-2l-9-3-13-7v-14l4 1 15 8 4 1-1-5-3-1v-2l-5-1-14-7-1-3v-10l5 2 11 7 14 5-1-3-5-3-3-3-11-6-17-11-18-10-20-9-33-11-20-4-3-3v-9h19l19 3 15 5 21 9 23 12 19 12 21 13 23 12 33 11 23 5 24 3 12 1h10l-2-13-3-14-3-26v-2h-11l-28-6-20-6-29-11-19-10-20-12-18-10-25-12-21-8-25-7-21-3-24-1-5-11 1-3 8-1h22l30 4 25 7 28 10 30 14 24 14 29 15 21 9 15 5 8 2 1-10 5-18 1-7 3-8 8-30 30-120 3-9h1v7l-16 65-20 82-11 46h11l1 2 7 2 4 1 6-20 9-21 9-14 10-13 7-7 8-7 9-7 3-2v-9l10-6 28-10 25-8h2l2-9 2 2 9-29 10-24 8-16 11-20 13-19 9-11 9-10 7-8z"
            fill="#13226A"
          />
          <path
            transform="translate(1100,280)"
            d="m0 0 104 1 2 1v120l-2 455h-5l-1-1-2-15-3-7-8-10-6-7-4-1v5l6 3 1 2-1 9-7 9-8 4-5 1 1 7 6-2 16-11 7-2 3 4-1 7-6 10-7 6-8 3-6-1-1-1h-5l-1 2 5 1v2h2l1 4 8-3 11-6 7-4 5 1 1 1v8l-2 7v5l4 3v6l-7 9-10 6-18 3-9 6-10 6-13 5-9 2h-15l-13-4-10-6-6-8-2-8 1-13 6-18 12-23 10-14 9-11 9-10 4-4h2l1-3h2l-1-8 3-1h7v-3h-2l-4-11-4-31-2-47v-17l1-10h6l1 1 1 37 4 50 2 16v12l13-4 12-12 12-24h2l3-10 2-2-1 6h2l2-9 3-16v-22l-3-17-18 18-10 13-13 18-4 4-2-7-1-6-1-17v-25l5-5 9-6 5-8 2-4 4 2 11 4 2-1-3-9 1-5 11-6 7-8 2-5v-12l-4-8-8-7-10-4 1-12 1-6-15 5-4-2-7-8-9-6-3-1h-11l-8 3-6 4-5 8-3 3-12-4 1 7v11l-10 6-5 6-2 5v14l5 8 6 5 7 4-2 14 13-4 5 1 4 9 7 6 2 1 1 79-5-2-13-11-17-11-20-8-10-3 2 19-4-1-9-11-10-13v-2l44-15 14-5h3l-5-10-28-44-16-25-12-19-16-25-11-18v-3l12-5 19-5 10-2 33-2h12l20 2 3 1-3-9-11-28-9-29-6-24-6-35-3-28-1-18v-17l2-26 5-29 5-19z"
            fill="#fff"
          />
          <path
            transform="translate(230,1199)"
            d="m0 0 5 2 6 9 4 8 9 6 4 10 4 8-2 6-8 9-7 11-7 16-4 15-1 6v31l2 15 8-3 7-7 5-4 9-11 15-20 5-5 1 5 1 25v22l-9 6-6 7-2 5h-10l-10-1 3 9v5l-10 7-5 6-2 7 1 10 4 8 8 7 6 3 1 4-4 14 17-2 4 5 6 8 8 4 3 1h16l10-5 4-6 2-6 6 1 10 4-3-15v-5l14-7 5-6 3-7v-10l-4-8-9-8-8-4 1-6 3-7-18 1-8-12-8-6-2-35v-42l7 6 17 13 13 8 15 8 10 3h2l-2-16v-8l5 2 8 8 8 14 2 6-6 3-51 16v2l9 15 24 38 15 24 24 38 13 21-4 3-18 6-22 5-18 2h-45l-3-1 8 16 10 25 7 23 7 30 4 26 2 21 1 20v22l-2 28-4 27-4 18-1 1-104 1-1-1v-308z"
            fill="#fff"
          />
          <path
            transform="translate(735,279)"
            d="m0 0 5 5 11 18 11 14 5 6 8 7 10 8 13 9 16 9 27 12 8 4 5 8 12 22 1 5-6 16-4 20v21l4 17 7 16 8 12 7 9-6 8-19 19-11 9-12 10-17 12-17 11-10 6-16 6-12 3-13 1-15-2-14-5-13-9-12-12-7-10-7-12-9-20-6-18-5-22-3-25v-41l1-2 8 1 13 2h12l18-6h3l-1 4-7 8-10 10h-2v2l5-1 8-6 8-7h2l-1 10-10 40v6l5 6 12 7 9 7 1-1v-12l5-1 15 6 10 1 8-3 4-5 1-8-4-9-1-3-11-3 4 5 5 4 1 7-5 5-6 1-16-7h-11l-5 5-3 1-9-6-2-2v-7l12-49 2-12v-18l-3-10-6-10-8-7-12-6-8-2h-20l-13 4-5 1v-16l1-2 19-8 12-7 12-9 10-9 8-8 14-19z"
            fill="#fff"
          />
          <path
            transform="translate(682,1438)"
            d="m0 0h14l10 3 11 7 10 9 12 14 10 15 8 16 7 19 6 24 4 26 2 24v15h-10l-18-1-19 2h-6l2-4 12-14 5-8-2-1-5 4-8 11-3 4h-2v-9l9-29 1-9-3-6-9-8-14-9-6-4 3 8-1 5-1 1-8-1-13-5h-10l-6 3-4 5-1 5 3 8 8 6 3 1-2-5-4-5-1-6 3-3 8-1 10 4 7 3h8l4-6 6 1 9 6 4 5-1 11-9 31-5 25v18l4 9 4 6 5 5 5 4 11 5 10 2h12l18-4 1 2v12l-5 3-19 10-13 10-11 10-8 7-11 14-8 12h-15l-4-5-10-15-8-10-14-14-14-11-15-10-26-13-10-4-8-14-12-22 10-20 4-13 1-6v-24l-4-17-8-17-9-12-6-6 1-4 14-14 8-7 15-13 19-13 18-11 16-8 17-6z"
            fill="#fff"
          />
          <path
            transform="translate(591,1006)"
            d="m0 0h19l19 3 15 5 21 9 23 12 19 12 21 13 23 12 33 11 23 5 24 3 21 2 3 5 3 7-1 1h-21l-27-2-24-5-27-9h-4l5 3-3 1-15-6 7 26 7 24 11 37 7 25 9 30 10-2 38 10 30 10 27 11 27 12 26 14 18 11 19 12 18 13 16 12 11 9 11 8 2 1-2 4-12 8-3 1-8-7-9-8-20-15-17-12-26-16-25-13-16-8-22-10-32-13-40-13-6-1-8 1 3 16v4l-10-2-18-4h-6l31 7 26 7 33 11 27 11 12 5 16 8 20 11 9 5 13 8 27 18 11 8 16 12-4 4-9 5-5-1-16-12-27-18-21-13-17-9-20-11-22-9-11-5-31-11-19-6-34-8-30-5-39-4-16-1h-41l-37 3-32 5-33 7-37 11-32 11-31 13-16 8-11 5-3-1-5-8 1-4 20-9 10-5 15-6 12-5 24-9 22-7 17-5 19-5 22-5 52-7 27-2h36l37 2 26 3-4-1-13-2-18-1-10-2-1-13 2-6 16 8 9 5 9 6 9 2-1-4-6-2-28-15-9-5v-18l6 2 29 16 7 4 6 2-2-6-42-21-5-3-1-22 1-16 5 2 30 15h4l-1-4-16-8-21-10-1-1v-14l6 2 17 9 9 3 2 1v-6l-5-2-26-13-3-1-1-2v-14l16 8 15 7v-5l-30-15-1-1v-15l17 8 9 3-1-5-3-1v-2l-9-3-13-7v-14l4 1 15 8 4 1-1-5-3-1v-2l-5-1-14-7-1-3v-10l5 2 11 7 14 5-1-3-5-3-3-3-11-6-17-11-18-10-20-9-33-11-20-4-3-3z"
            fill="#13226A"
          />
          <path
            transform="translate(317,321)"
            d="m0 0h16l12 4 13 9 9 10 9 14 3 3 1-6 7-11 10-11 8-6 12-5 5-1h16l14 5 11 8 7 7 10 16 4 10 3 15v8l-4 16-7 12-9 11-46 46-9 12-10 13-10 15-8 15-7 11-4-5-9-17-7-12-10-13-8-11-11-12-7-8-15-15-8-7-7-7-9-11-6-8-7-14-2-9v-14l5-17 7-13 11-13 10-8 8-4z"
            fill="#EB392A"
          />
          <path
            transform="translate(1057,1490)"
            d="m0 0 3 1 10 20 12 18 14 19 12 13 7 8 11 11 8 7 12 12 7 9 4 5 5 8 5 13v22l-7 19-7 11-8 9-10 8-11 5-10 2h-8l-12-3-8-4-8-6-10-10-9-14-2-3-7 13-11 13-11 8-10 4-9 2h-8l-12-3-10-5-11-9-7-9-8-14-4-14-1-6v-12l3-12 7-13 11-13 45-45 18-24 8-11 9-17z"
            fill="#EB392A"
          />
          <path
            transform="translate(392,1499)"
            d="m0 0h4l6 9v3l-6-2-2-1h-14l-7 2-8 6-3 6v8l3 5h2l2-7 6-7 8-3 10 1 6 3 6 7 2 9-4 8-5 3-8 1-2-1v-11h-6l-4 3v8l-10 9-1 3v8l4 6 5 2h10l8-3 10 1 3-1-1-5-5-4 1-5 4-3h11l7 4 4 5 2 4v8l-5 6-10 4h-14l-1 4 12 6h10l10-5 7-9 4-9 4 4 10 16 1 4-7-2h-15l-8 3-7 6-2 4v8l1 2h2l4-6 8-7 3-1h10l10 4 6 7 1 3v8l-4 7-4 3-3 1h-7l-2-9-4-2-4 4-2 7-8 7-3 5v6l2 5h2v2l4 1h18l7 2 6-1 1-1v-6l-8-2 1-5 6-5 4-1h8l8 4 5 6 2 5v10l-3 6-5 5-2 1-19 1 1 3 7 4h16l8-4 5-5 4-8 1-6h2l12 20 3 4-1 3-8-4-5-1h-9l-10 5-4 4-3 7v7h4l6-8 6-4h13l8 5 3 4 2 7-1 7-4 6-4 4-9 1-3-8-5-3-2 1-2 10-8 7-3 5-1 4-10 1h-120l1-13 4-27 2-24v-53l-4-36-5-26-6-22-6-18-10-24v-3h24l3 2h12l9-2 11-5z"
            fill="#DFD23E"
          />
          <path
            transform="translate(1006,279)"
            d="m0 0h78l-3 21-4 38v57l3 29 5 28 6 23 10 29 8 19 1 6-5-1-2-5-6 1-7 4-12 2h-16l1-3 5-5 5-8v-11l-5 4-6 8-6 3h-9l-9-2-8-6-3-7v-8l4-6 5-4h7l1 1 2 10 1 2h6l3-7 2-5 7-6 2-3v-10l-5-6-6-2h-10l-7 1-9-3-4 2-1 7 9 2 2 4-3 5-6 2h-9l-8-4-4-5-2-10 3-8 8-7 7-2h16l-2-4-7-5-8-1h-6l1-8v-9l-2-5-2-1-2 6-7 8-6 3h-11l-9-5-3-4-1-7 3-9 5-5 4-2 5 1 1 4-2 8h8l2-1 2-11 9-7 3-4v-9l-4-6-4-3-7-1-9 3-5 2-5-3h-5l-3 1-1 6 9 3 1 3-5 6-5 2h-8l-8-3-5-4-3-5-1-10 4-8 6-5 3-1h7l5 2 6 1-3-7-5-4-2-1-14-1 1-5 4-9v-7l-4-7-3-1v8l-4 6-6 5-6 2-7-1-8-4-6-9v-10l3-6 6-5h7l1 1 2 10 1 2h5l3-4v-9l8-8 2-12z"
            fill="#DFD33E"
          />
          <path
            transform="translate(582,951)"
            d="m0 0h26l21 3 25 7 21 8 29 14 23 13 13 8 17 9 29 11 20 6 28 6 11 1 1 2 3 26 5 25-1 3h-10l-23-2-23-4-23-6-25-9-23-12-19-12-21-13-27-14-20-8-15-4-14-2-22-1-1-1-4-33-2-12v-8z"
            fill="#040304"
          />
          <path
            transform="translate(1082,774)"
            d="m0 0 4 2 3 3v2l-5 5-6 10 5 5 15 10 5 2 11-9 4-4 6 1 4 2-2 4-9 10-11 14-11 15-10 18-8 20-4 13-3 16-9 73-6 52-6 36-7 28-9 27-10 23-10 18-11 17-10 13-11 12-7 7-8 7-2 2-2 21-1 2h-21l-14 11-8 6-5-2-9-5 4-8-11-14-11-13-3-4 1-3 19-14 8-6 4 1 5 6-1 4-11 9 2 4 8 8 7 8 4 1 12-11 8-7 20-18 5-4-2-4-13-12-11-9-3-3 1-5 13-23 5-1 7 4-3 9-3 7v3l23 13 2-5 17-32 10-17-3-2-28-12-6-3 1-8 7-27 1-2h11l1 4-3 24 10 1 19 4 1-9 10-51 1-3-38-6-5-2v-9l3-26 2-1 10 1 1 2-1 17 30 4 1-17 4-38-17-2-25-4 1-13 4-29 2-1 7 1 1 1v13l-1 13 12 1 19 3 2-16 6-30 2-11-38-13-1-2 13-33 5-1 5 2-1 5-5 13v2l26 10h3l16-30 7-12-1-4-16-10-15-10v-4l7-11 9-11z"
            fill="#fff"
          />
          <path
            transform="translate(1132,574)"
            d="m0 0h11l10 5 9 9 2 3 12-3 5-1-1 12-1 6 8 2 8 6 6 8 1 3v12l-4 8-7 7-10 5 1 7 2 7-3 1-11-4-4-3-2 6-4 6-8 6-5 3-1 2v25l1 17 2 12 4-4 12-17 13-16 16-16 2 4 2 14v22l-3 16-3 9h-2v-4l-4 10h-2l-1 5-8 14-3 6-12 12-12 4-3-1h2l-5-50-2-28-1-37-6-1v27l2 47v9h-1v-7h-2v6l-4 1-5-3 2 4 6 9 1 9-4-2-9-8-5-5-9-8v-2l-4-2-6-4v-2l-5-2-2-1 2 4 7 6v2l4 2 23 23 6 8-1 4-6-2-15-10-12-9-7-4-10-8-9-14-4-9-1-4v-12l7 1 21 8 13 8 12 9 10 8 2 1-1-11v-68l-5-2-7-8-2-6-7 1-10 2 1-14-9-5-7-8-2-4v-14l4-8 7-6 5-3h2l-2-19 10 3 4 1 5-9 6-5 6-3z"
            fill="#132266"
          />
          <path
            transform="translate(83,45)"
            d="m0 0h1270l12 3 11 6 10 9 7 10 4 11 1 4 1 27v1813l-1 14-4 13-7 11-9 9-10 6-9 3-6 1h-1273l-11-3-11-6-10-9-7-11-4-10-1-7v-1846l2-11 8-16 6-7 8-6 12-6zm2 2-11 2-10 4-9 7-8 9-6 12-2 7-1 10v1830l1 14 3 10 5 9 9 10 8 6 12 5 6 1h1270l12-3 13-7 8-8 8-14 3-11 1-28v-228l-1-1592-3-13-8-13-10-10-14-7-13-2z"
            fill="#252129"
          />
          <path
            transform="translate(876,773)"
            d="m0 0 2 1-2 11-2 10 12-4h3v-2h4v-2h12l1 3v126h-1v-109l-16 3-13 3h-3l-1 4-1-2-25 100-11 43-6 22-1 4-5 19-3 13 2 1-10-2-18-6-10-5-2-2v-3h2v-3h-2l1-4-1-1v-9l1-3 16-7h2v-2l3-2 1-4-22 8v-13l4-3 17-8 4-4 1-4-24 12h-2v-15l26-13h2l1-6-25 11-3 1-1-1v-11l1-3 24-11 5-2 3-5-13 5-17 8h-3v-14l6-4 23-10h2v-2l5-2v-5l-34 16-2-1v-9l2-4 30-15 5-1v-2h2v-4l-6 1-30 14-3-1 1-14 33-16 6-3h3l1-5-9 3-32 16h-2v-17l38-20 8-4 3-7-16 8-29 15-3 1v-15l16-8 15-8 16-8-6-1-10 4-19 10-8 3-3 1-1-16h-3l1-4 20-1 11 1 19-3 9-1v-2h19l13-2z"
            fill="#13236A"
          />
          <path
            transform="translate(1245,1776)"
            d="m0 0h23l7 12 1 3 4-1 6-4 11-2h11l10 3 9 6 5 4 10 14 7 15 5 21v25l-2 14-6 20-6 10-4 6-7 8-14 9-9 2h-8l-11-2-8-5-8-6-10-14-5-10-5-16-2-11-1-11 1-22 6-22 5-10-1-7-8-15-6-12z"
            fill="#EB3D2A"
          />
          <path
            transform="translate(130,89)"
            d="m0 0 12 1 11 4 10 8 8 10 8 16 4 12 3 20v15l-1 13-5 20-4 8-2 3 1 5 14 28v2l-22 1-6-10-2-7-9 5-3 2-7 1h-15l-11-4-9-7-9-10-7-12-5-14-3-13-1-22 2-17 4-15 4-10 8-13 8-9 14-9z"
            fill="#EB3C2A"
          />
          <path
            transform="translate(517,769)"
            d="m0 0h5l8 5-2 4-3 3 1 4 14 18 7 10-4 5-12 9-13 10-5-1-4-6 14-13-2-4-15-14-2-2-5 1-10 10-8 7-16 15-9 8 5 5 11 10 14 11v3l-7 11-10 13h-4l-3-2 2-6 7-13-6-2-22-11h-2l-15 26-15 25-2 4 27 12 14 6-1 8-7 25-3 3-7-1-1-1 1-14 1-12-29-5-2-1-1 10-9 52v2l37 5 3 1v27l-1 10h-11v-12l1-9h-16l-16-1-3 53 38 5 1 1v10l-3 31-1 1-9-1-1-1 1-27-28-3-2 3-10 56 28 8 12 3-1 6-12 30-4 1-6-4 3-11 2-8-9-3-20-8-2 6-14 25-8 14 1 3 26 16 5 3-1 5-8 14-11 17-5-2-3-2 1-4 11-15v-3l-20-11-5-3-4 1-12 16-3 2-8-6-4-2 1-3 11-8 12-12 10-15 12-23 9-23 7-24 6-28 3-26 2-45 3-32 6-35 7-28 8-23 9-20 12-22 11-16 11-14 12-14 14-15 10-9 11-9 13-10 13-8z"
            fill="#fff"
          />
          <path
            transform="translate(543,781)"
            d="m0 0 10 3 12 6 17 17 12-7 5 1 9 3-4 4-16 8-23 13-16 11-13 10-12 11-4 2-2 4-12 12-13 18-11 19-7 16-7 21-6 26-4 25-3 28-4 48-5 37-6 29-8 27-10 25-10 20-14 22-14 19-13 16-2 3-5-1-5-5 7-11 13-18 10-15 1-3-26-16-9-6 5-10 8-13 3-5 7 1 1 5-4 11v2l28 14 4-8 20-52-10-2-29-8-3-2 1-10 5-26 1-1h10v12l-2 16 12 1 18 3 7-51 2-13-24-3-15-2-2-1v-12l1-21h9l1 1 1 19 15 1h16l3-57-37-3-3-1 1-13 4-28 11 1v9l-2 15 30 4 5-16 9-32v-5l-36-15-2-1 2-6 13-21 5-9 7 1 3 1-1 7-6 12v3l25 11h2l11-16 10-14 6-8-1-4-14-13-11-9-3-3 2-4 19-19 8-7h4l5 5-2 4-13 13v3l11 9 9 8 4-1 15-12 13-10 14-11-7-11-13-18-1-3z"
            fill="#fff"
          />
          <path
            transform="translate(649,810)"
            d="m0 0 4 2 15 56 10 39 9 35 1 9-4 1-5-4-28-9-27-6-8-1h-41l-8-11-8-10-16-16-11-9 3-5 17-17 15-11 19-12 22-11 22-9 15-5 2-5z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(1068,759)"
            d="m0 0 7 6-6 8-16 21-10 13-2 4 13 9 14 9 5 3-1 7-11 23-3 1-8-3 1-5 6-16-10-3-15-6-5-1-1 5-12 31-9 22 5 1 34 10 2 1-2 14-4 21-2 3-7-2-1-3v-22l-30-7-3 25-5 38-1 3 42 5 3 1-1 16-2 18h-10l-1-1-1-19-31-2-1 12-6 45 11 1 32 5 1 1-1 10-6 29-3 1-7-2v-12l1-14-29-3-17 54 6 2 25 12 5 2-1 6-12 23-4 6-5-1-3-2 1-5 8-17-6-2-21-10-5 5-9 15-11 17-4 7 10 10 8 7 11 10-1 4-12 11-15 14-4-1-4-7 14-14-6-7-12-11-5-2-20 15-18 13-7 5 1 4 12 14 9 12-1 4-7-1-19-7-7-8-5-7-12 4h-7l-7-3 4-3 25-13 18-11 16-11 10-8 14-12 13-13 13-17 9-15 8-16 8-24 6-27 5-34 8-75 6-43 6-27 9-26 14-29 13-21 12-16 9-11 11-13z"
            fill="#fff"
          />
          <path
            transform="translate(1133,683)"
            d="m0 0h6l1 1 1 37 4 50 2 16v12l13-4 12-12 5-10 6-11h3l1 2-7 14-9 15-1 7 3 13 4 3h-2v5l6 3 1 2-1 9-7 9-8 4-5 1 1 7 6-2 16-11 7-2 3 4-1 7-6 10-7 6-8 3-6-1-1-1h-5l-1 2 5 1v2h2l1 4 8-3 11-6 7-4 5 1 1 1v8l-2 7v5l4 3v6l-7 9-10 6-18 3-9 6-10 6-13 5-9 2h-15l-13-4-10-6-6-8-2-8 1-13 6-18 12-23 10-14 9-11 9-10 4-4h2l1-3h2l-1-8 3-1h7v-3h-2l-4-11-4-31-2-47v-17z"
            fill="#12226B"
          />
          <path
            transform="translate(748,1096)"
            d="m0 0 17 4 41 9 20 2h35l7 8 8 10 9 10 9 8 8 6-2 4-10 10-9 7-14 10-21 13-15 8-36 16-5 2h-4l-9-29-19-62-10-33z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(284,1234)"
            d="m0 0 11 2 1 1 4 95v23l-9 2-10 5-5 5-1 7 5-8 8-6 3-1h11l8 4 3 3 4 1 3 5 2 19 7-2 10 1 8 4 6 2 4 8v10l-5 10-7 6-10 4 2 20-10-3-6-2-1 6-5 7-10 5h-16l-9-4-6-5-6-9-17 1 2-11 1-6-10-6-7-8-3-10 1-9 4-7 8-7 5-2-4-15h7l14 2 2-7 8-8 5-3h2l-2-47-1-7 5-5v-31l-1-27h-3z"
            fill="#0C080B"
          />
          <path
            transform="translate(618,578)"
            d="m0 0 6 1 27 12 30 10 29 7 25 4 24 2h30l26-2 26-4 27-6 29-9 16-6 12-5 6-2-1 8-10 5h-2l6 10 5 3-1 5-28 12-22 7-23 6-30 5-21 2-18 1h-26l-28-2-36-6-25-6-24-8-24-10-24-12-15-9v-2l11-2 12 7 7 2 5-6v-3l-7-3v-3z"
            fill="#E0D340"
          />
          <path
            transform="translate(656,1424)"
            d="m0 0h13l37 2 26 4 27 6 18 6 21 9 12 6-1 2-24 8-32 8-5-1-9-11-9-10-7-7-10-7-8-4-10-2h-16l-21 5-16 6-16 8-18 10-18 13-14 12-10 9-12 11-3 3-5-1-20-9-21-5-12-1-3-5 2-5 11-22 9-6 15-7 36-12 27-6 31-5z"
            fill="#fff"
          />
          <path
            transform="translate(641,1255)"
            d="m0 0h36l37 2 26 3 27 5 30 7 28 8 31 11 24 10 23 11 20 11 9 5 13 8 27 18 11 8 16 12-4 4-9 5-5-1-16-12-27-18-21-13-17-9-20-11-22-9-11-5-31-11-19-6-34-8-30-5-39-4-16-1h-41l-37 3-32 5-33 7-37 11-32 11-31 13-16 8-11 5-3-1-5-8 1-4 20-9 10-5 15-6 12-5 24-9 22-7 17-5 19-5 22-5 52-7z"
            fill="#E0D340"
          />
          <path
            transform="translate(642,1394)"
            d="m0 0h43l25 2 28 5 36 9 21 7 15 6 15 7 15 8 9 4-1 3-7 3-6-1-14-7-2 8 7 5-1 2-3 1h-8l-16-8-26-10-15-5-36-8-26-3-15-1h-30l-31 2-25 4-36 9-23 7-15 6-8 4h-4l1-5 8-4-1-9h-6l-1-11 9-4 36-12 23-6 30-5z"
            fill="#DFD23F"
          />
          <path
            transform="translate(887,522)"
            d="m0 0 4 1 15 10 16 7 21 7 1 4-8 22-6 4-26 10-30 10-36 9-27 4-17 1h-44l-26-3-33-7-14-4-17-6-29-12-4-1v-3l48-17h4l7 11 11 13 11 9 13 8 10 4 10 2h23l21-6 21-10 23-14 14-10 15-13 17-16 10-11z"
            fill="#fff"
          />
          <path
            transform="translate(590,1024)"
            d="m0 0 20 2 1 2-11 43-14 54-13 52-11 42-4 4h-11l-17 4-4-1-2-72v-38l13-12 10-9 10-10 11-14 8-14 7-15 6-17z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(789,1249)"
            d="m0 0 6 1 2 3 9 2 25 7 24 9 32 13 40 20 23 13 27 18 19 14 11 9 11 7v4l-4 1-1 2-5 5-29 15-22 12-21 10-7 3-3-1 8-5 5-5h3v-3l-5-2-4-5-1-8 5-8 7-3 9 1 5 4 3 6v6l11-6 6-2-5-5-12-9-2-1v-2l-5-2-9-7h-3l-2 4-10 14-4 5-7 9-4-1-14-8-17-10h-4l1-4 12-21 8-13v-3l-16-8-23-11-4-2 3-1 25 11 21 12 12 6 19 12 15 10 19 13 10 8 6-1 10-6-5-5-11-8-20-14-17-11-9-6-9-5-22-12-17-8-8-4-27-11-28-10-28-8-34-8-8-2v-1h9l23 5 5 2-3-13z"
            fill="#0B080B"
          />
          <path
            transform="translate(449,653)"
            d="m0 0 4 1 10 8 12 9 15 11 21 13 16 9 14 8 22 11 13 5 28 11 25 8 26 7 24 5 35 5 36 3h51l37-3 40-6 27-6 28-8 20-7 25-9 18-8 23-11 3-1h7l5 4-2 4-32 16-24 10-18 7-24 8-29 8-36 8-36 5-27 2-20 1h-22l-41-2-17-2-36-6-23-5-33-9-29-10-29-12-27-13-22-12-11-7-17-11-10-7-14-10-13-10v-2l-4-2 4-4z"
            fill="#DFD33F"
          />
          <path
            transform="translate(897,807)"
            d="m0 0h8l1 111-1 3-9 7-15 15-14 19-11 20-8 19-4 12-2 1h-17l1-9 15-62 14-57 18-73z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(1298,1630)"
            d="m0 0 3 1 6 11 8 11 12 14 3 3v2h2l4 5 2 1v2l3 1v2h2l8 10 3 7v12l-4 11-7 9-9 6-12 1-9-3-10-9-4-6-2 1-1 5-11 9-8 3-13-1-3-3-4-1-9-12-3-9v-14l5-10 24-24 1-2h2l2-4 9-12 9-14z"
            fill="#EB3A2A"
          />
          <path
            transform="translate(102,292)"
            d="m0 0h12l10 4 8 8 3 5h2l3-7 3-1v-2l7-5 5-2h13l11 6 7 10 4 12v10l-5 10-9 10-18 18-12 16-10 16-2 1-6-12-10-14-10-11-7-8-15-15-5-10v-14l3-9 7-9 9-6z"
            fill="#EB3A2A"
          />
          <path
            transform="translate(1058,1098)"
            d="m0 0 5 1 10 5 23 6 8 4 8 6 7 11 2 7 14-2h11l12 3 10 6 7 8 5 10 2 10v9l-3 13v8l8 9-1 5-8 7-3 1h-9l-7-3-6-7-2-6-13-4-5-5-3-4-1-3v-7l3-6 6-5 5-2 6-1-2-5-3-4-4-2h-9l-10 5-5 4-4 6-1 4-5-1-15-8 3-10 2-7v-7l-4-8-4-1-4 9-4 5-7 3h-9l-8-3-7-7-2-5v-7l5-12-2-6v-8l6-8z"
            fill="#DFD13F"
          />
          <path
            transform="translate(259,812)"
            d="m0 0 10 1 8 7 4 10v2h9l7 4 4 5 1 7-5 10-6 5-7 2 4 5 7 3h11l6-3 6-5 6-8 5 1 10 5 5 2-3 9-1 4v9l2 7 3 3h2l7-9 8-4h10l5 3 4 7v12l-3 7 1 7v14l-3 4h-5l-16-8-23-7-10-5-7-9-5-9-16 1-14-3-10-4-8-5-7-8-3-5-2-7v-17l1-7v-9l-3-7-3-4 1-5 6-5z"
            fill="#DFD03F"
          />
          <path
            transform="translate(420,1489)"
            d="m0 0 4 2 12 19 14 22 12 19 28 44 36 57 14 22 12 19 14 22 15 24 7 11v1h-24l-3-1-9-15-10-15-13-21-15-23-13-21-14-22-9-14-10-16-13-20-14-22-10-16-14-22-12-19-2-4 1-4z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(1124,577)"
            d="m0 0h18l8 4 9 8 2 6-1 8-1 4 12 1 10 2 6 3 6 8 2 6-1 8-3 5-7 6-10 3-11-2-2 6h-2l1 2v7l-3 8-9 7-9 2-9-1-8-5-5-6-1-3v-12l-5-2h-13l-8-5-5-7-1-4v-9l4-7 7-6 7-4h10v-18l5-8 5-4z"
            fill="#0D080A"
          />
          <path
            transform="translate(303,1105)"
            d="m0 0h18l12 3 9 5 6 7 3 7v16l-5 17-9 20-13 21-9 11-8 8-10 7-5-1-6-6-3-1h-8l-8 1-2-2 16-10 14-9 6-8 3-3v-25l3-12 6-12-5 2-6 10-7 17h-2l-2-10-3-5-5-2-1-6-4-1v-2h-3l1 5-3 3-6 1-5-4-1-4 6-3-3-3v-2l-9 1-2 4-16 7-5 2-2-2v-9l4-6 10-6 15-2v-2l16-8 15-6z"
            fill="#fff"
          />
          <path
            transform="translate(744,785)"
            d="m0 0 32 1 1 1v52l-1 92-1 62h-7l-1-1-1-7-13-1-8-5-1-11-1-128v-54z"
            fill="#E0D442"
          />
          <path
            transform="translate(439,657)"
            d="m0 0 3 1-3 3 3 2v2l4 2 13 10 11 8 15 10 11 7 13 8 16 9 16 8 24 11 31 12 28 9 22 6-3 1 5 21v4h-10l-22-6-42-15-24-10-26-12-23-12-23-14-17-12-14-10-14-11-14-12-4-3 2-4 9-4 6-2v-2z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(655,1044)"
            d="m0 0 6 2 19 10 4 2 1 2 2 99 1 41v50l-3 1-29-1-1-1z"
            fill="#DFD240"
          />
          <path
            transform="translate(843,280)"
            d="m0 0h19l6 5 9 15 14 22 16 24 10 16 10 15 13 20 11 18 7 10 9 14 16 25 14 21 11 18 7 10 11 17 4 8-1 2-10 4-9 3-10-16-12-19-15-24-14-22-15-24-12-19-15-24-14-22-15-24-12-19-15-24-14-22-4-6z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(1135,810)"
            d="m0 0 7 6 4 2 15 1 1 4-4 5-20 8-6 9-3 4h-2l-1 5 3 6v10l-3 12-2 5v4l7-10 6-16h2l2 12 3 4v2l5 2 2 3 2 9 8 7 1 8v4l-11 8-13 6-13 3h-15l-13-4-10-6-6-8-2-8 1-13 6-18 12-23 10-14 9-11 9-10 4-4h2l1-3z"
            fill="#fff"
          />
          <path
            transform="translate(1058,760)"
            d="m0 0h6l-4 7-7 7-1 5-11 13-13 19-8 13-12 23-8 20-6 19-6 29-6 45-8 75-4 26-6 27-8 24-8 16-9 15-10 13-11 12-9 9-22 18-23 15-18 10-19 10 2 2 3 1h7l10-4 4 2 9 12 9 4 13 5 7 4 1 4-3 1-21-9-28-10-36-10-12-3-10 2-3-8-11-37-14-48-6-21-7-25v-4l10 3 28 11v1l-9-1-20-5-2-1 13 42 17 56 8 27v2l16-6 35-16 19-11h2v2l-10 6-6 4h-3l-2 4-3 3-28 14-3 2 8 2 6-1 16-8 26-14 18-11 14-10 14-12 9-9 7-8 10-13 10-16 7-14 7-19 6-24 5-29 6-57 6-53 5-28 5-21 9-27 12-25 13-22 11-16 9-12 11-13z"
            fill="#12226B"
          />
          <path
            transform="translate(600,965)"
            d="m0 0 9 2 14 8 4 2h3l1-5 5 1 14 8 13 8h3l2-4 6 1v2l5 2 11 10 4 3h3l3-4 4 1 2 1v2l4 2 2 4 4 2 8 8 5 2 2-4 5 1 10 9 11 9 4 2 2-6 1-2 4 2 17 12 6 4 4 1 2-5 8 2 13 8 10 6h3l2-6 9 3 3 10 1 10-12-1-2 6-5-1-15-8-11-6-4-1-1 6-5-1-17-12-7-4-2 6-6-1-8-6-13-10-5 1-1 2h-5l-15-14-9-7-3-1-1 3-4-1-10-8-7-5v-2l-4-2-3-2h-3l-1 4-6-2-10-7-12-7-4-1-2 5-5-1-24-12h-5l-6 2-1-1-3-19 1-2z"
            fill="#DFD13E"
          />
          <path
            transform="translate(833,777)"
            d="m0 0h9v1l-19 4-13 1-8-1-19 1-1 3h3l1 2v14l7-4 10-4 13-7 10-4 7 1-3 3-17 9-16 8-11 5v14l20-10 20-11 4-2h3l-1 6-7 5-40 20-1 17 38-19h5l-1 5-23 11-17 8h-2v14l6-2 28-13 5 1-1 4h-2v2l-25 12-10 5-1 3v9l20-9 13-6h2v5l-5 2v2l-29 13-1 1-1 14 29-13h4l-2 5-2 2-10 4-16 7h-2v14l23-10 5-1-1 6-16 8-11 5-1 15 17-8 7-4h2l-1 6-10 6-14 7v12l17-7h4l-1 5-3 1v2l-16 7h-2l-1 12 3 1-2 1-1 3 4-1-2 4h-2l2 5-6-2-24-12-22-13 2-1 6 3-1-3-8-5 2-1 4 2v-14l-4-4h5v-2l-3-1 2-1-1-15-4-3 6 1v-3l-2-1v-16l-3-1 3-2v-17l-3-3h3l2-10v-28l-1-13-1-39v-15h-5v-2l-6-2-1-2h16l24 1h22l36-2zm-89 8-1 1v54l1 128 1 11 8 5 13 1 1 7 1 1h7l1-62 1-92v-52l-1-1z"
            fill="#12226B"
          />
          <path
            transform="translate(1396,90)"
            d="m0 0h1l2 25v1813l-1 14-4 13-7 11-9 9-10 6-9 3-6 1h-247l-18-1v-1l264-1 12-3 13-7 7-7 8-14 3-11 1-28z"
            fill="#1B2558"
          />
          <path
            transform="translate(560,600)"
            d="m0 0 4 1 17 9 10 6 22 10 12 5 24 9 29 9 22 5 27 4 34 3h44l33-4 25-5 34-9 17-5 13-5h5l3 8v5l-19 7-28 8-35 8-26 4-25 2h-52l-23-2-32-5-36-9-35-12-25-11-23-12-14-9-11-6-2-1 1-4z"
            fill="#DFD23E"
          />
          <path
            transform="translate(1077,934)"
            d="m0 0 5 1 7 3 17 1 17 3 10 5 6-1 12-5h13l11 4 5 4 6 10 4 16 3 9 2 5-1 5-4 3-11 1-9-4-6-5-13-4-5-3-2 6-2 11h-19l-1-1-3-23-2-5-4 2-7 6-6 2-8-1-6-3-4-6-4-10-7-10-1-7 3-6z"
            fill="#DFD03E"
          />
          <path
            transform="translate(645,1360)"
            d="m0 0h38l23 2 27 4 37 8 19 6 23 8 37 17 17 9 9 6 12 6v4l-9 4h-6l-15-9-18-10-20-9-23-9-30-9-23-6-27-5-18-2-15-1h-50l-20 2-32 5-34 8-27 9-12 5h-4l-4-9 1-3 39-13 36-9 21-4 23-3z"
            fill="#DFD23F"
          />
          <path
            transform="translate(287,927)"
            d="m0 0 4 1 8 14 1 3h15l1 13 16 12 7 5-5 5-11 7-4 3-1 11-1 2-17 2-13 20-7-6-6-8-4-4-12-1-2-2-1-17-4-2-11-7-6-4 5-5 14-10 2-15h17l11-12z"
            fill="#DFD33F"
          />
          <path
            transform="translate(359,760)"
            d="m0 0h2l4 8 6 9 3 5v2h19l2 14 8 6 12 7-1 3-19 10-1 1-1 14-16 2-5 4-7 9-4 6-5-5-11-13h-17v-13l1-2-4-2-19-12 3-3 19-10h2v-18l18-2 5-10z"
            fill="#DFD23F"
          />
          <path
            transform="translate(1071,1178)"
            d="m0 0h2l4 6 8 11 15 2 1 1 2 14 21 13v2l-18 10-1 14-9 2-9 1-5 5-9 11-3 3-4-2-9-12-2-2-14-1-3-12v-4l-5-2-19-10v-2l22-11h2v-18l17-1 5-6h2l2-4z"
            fill="#DFD33F"
          />
          <path
            transform="translate(788,1228)"
            d="m0 0 8 1 37 10 27 9 27 11 27 12 26 14 18 11 19 12 18 13 16 12 11 9 11 8 2 1-2 4-12 8-3 1-8-7-9-8-20-15-17-12-26-16-25-13-16-8-22-10-32-13-40-13-10-3-3-4-2-10z"
            fill="#fff"
          />
          <path
            transform="translate(588,936)"
            d="m0 0h22l30 4 25 7 28 10 30 14 24 14 29 15 21 9 15 5 23 6 6 1v15h-10l-25-5-20-6-29-11-19-10-20-12-18-10-25-12-21-8-25-7-21-3-24-1-5-11 1-3z"
            fill="#fff"
          />
          <path
            transform="translate(1056,748)"
            d="m0 0 4 2 3 5-8 8-9 11-10 13-11 16-15 25-12 25-10 30-7 33-4 29-9 86-5 32-6 25-6 18-5 12-8 14-12 17-10 11-7 8-8 8-14 11-18 12-23 13-23 12-8 4-8-1-5-2 1-2 23-11 21-11 21-13 17-12 13-11 4-4h2l2-4 9-9 11-15 10-18 7-16 6-18 7-31 6-38 2-21 2-36 4-30 7-34 10-32 10-24 8-16 11-20 13-19 9-11 9-10 7-8z"
            fill="#fff"
          />
          <path
            transform="translate(1143,1015)"
            d="m0 0 4 1 12 14 5 2 10 2 3 11 9 8 10 7v3l-18 12-3 14-1 1-14 2-12 17-2 3-4-2-10-15-3-3-13-1-1-15-17-12-4-4 20-12 1-15 18-1 2-5z"
            fill="#DFD23F"
          />
          <path
            transform="translate(619,807)"
            d="m0 0 12 2 6 2v2l-24 10-16 8-17 9-19 12-13 10-11 9-9 9-5 4-9 11-11 15-9 16-8 19-8 26-5 26-3 25-8 84-3 22-5 23-8 26-10 24-8 16-8 15-14 22-9 12-14 18-5 6-5-4 1-4 12-14 14-19 11-17 12-22 10-22 10-30 6-26 5-34 7-79 4-29 6-27 9-27 8-16 10-17 13-18 11-12 12-13 8-7 15-12 18-11 22-12z"
            fill="#fff"
          />
          <path
            transform="translate(130,117)"
            d="m0 0 12 1 9 6 6 8 7 16 2 15v13l-1 9-4 11h-2l-7-14-23-1 14 27 3 5v3l-6 2h-12l-7-3-8-6-6-8-5-13-2-9v-22l4-15 6-12 7-8 8-4z"
            fill="#fff"
          />
          <path
            transform="translate(1296,1812)"
            d="m0 0h9l9 3 10 8 8 17 3 17-1 19-5 16-5 9-7 8-10 4h-11l-8-3-9-9-8-17-2-9-1-9v-9l2-13 4-10h2l7 15 23 1-7-14-11-19 1-3z"
            fill="#fff"
          />
          <path
            transform="translate(413,673)"
            d="m0 0 4 2 11 9 16 13 17 12 20 14 24 14 29 15 32 14 42 15 18 6 15 4 3 3 2 15-10-1-30-8-35-12-28-12-33-16-21-12-24-15-15-11-17-12-18-14-13-11-2-4z"
            fill="#fff"
          />
          <path
            transform="translate(247,1038)"
            d="m0 0 8 1 8 4 5 8 12 3 3 5v10l3-1 6-12 1-14h16l2 16 4 9 3-1 7-8 5-2h9l6 4 4 4 1 3v12l6 7 2 8-3 6-1 1h-7l-8-2-25-2-7-2-8-7-5 2-8 4-8 2h-7l-13-4-7-6-5-12-3-16-6-7 1-7 6-5z"
            fill="#DFD03E"
          />
          <path
            transform="translate(513,762)"
            d="m0 0 5 1 29 14 32 13 37 12 25 6-1 3-9-1-12-2-32 16-24 14-11 8-13 11-11 10-7 8-10 11-14 20-9 15-9 20-7 22-6 27-4 29-7 79-5 34-6 26-10 30-11 24-5 9-5 5-6 11-8 11-7 10-5 5-6 8-5 4h-3l1-5 10-12 13-18 12-19 12-23 10-25 8-27 6-29 5-37 5-60 5-36 6-27 6-20 7-16 7-14 11-17 10-13 25-25 17-13 18-12 23-13 17-9-10-4-5 1-11 6-14-15-5-4-17-7-9-5-11-5-8-4-2-4z"
            fill="#12226C"
          />
          <path
            transform="translate(284,1234)"
            d="m0 0 11 2 1 1 4 95v23l-9 2-10 5-5 5-1 7 5-8 8-6 3-1h11l8 4 5 6 2 4v11l-7 10-1 2-4-2-8-6-5 1-7 6-4-1-4-7-2-6-1 7-3 1v2l5 2 3 3-1 5-9 8 4 8 4 2 1 4-8 5-4 1h-10l-6-4-5-5-3-4-1-8 2-8-4 4v-3l-3-1 1-4 7-8 6-4h2l-4-15h7l14 2 2-7 8-8 5-3h2l-2-47-1-7 5-5v-31l-1-27h-3z"
            fill="#1B2767"
          />
          <path
            transform="translate(867,405)"
            d="m0 0 3 4 8 15-1 8-1 5v25l4 15 7 14 9 12 10 9 15 9 12 6 6 10 4 7v3l-12-3-19-7-14-8-8-6h-3l-9 11-12 12-8 7-11 10-15 11-16 10-18 10-16 7-18 5h-23l-16-4-14-8-13-10-6-6-2-6h3v2h2l6 7 11 7 9 6 14 5 18 2 14-2 17-5 14-7 20-13 18-13 11-9 14-12 15-15 6-8-10-13-8-14-5-13-3-14v-21l4-20 6-16z"
            fill="#081580"
          />
          <path
            transform="translate(591,1006)"
            d="m0 0h19l19 3 15 5 21 9 23 12 19 12 21 13 23 12 33 11 23 5 24 3 21 2 3 5 3 7-1 1h-21l-27-2-24-5-27-9-28-12-25-13-20-13-18-10-20-9-33-11-20-4-3-3z"
            fill="#fff"
          />
          <path
            transform="translate(643,1378)"
            d="m0 0h48l32 4 29 6 26 7 19 6 25 10 25 12 18 10 4 2-3 3-8 3h-6l-18-10-10-5-16-7-12-5-16-6-23-7-40-8-27-3h-52l-30 3-30 5-27 6-23 7-17 6h-3l-1-9 15-6 28-9 23-6 27-5 27-3z"
            fill="#DFD23F"
          />
          <path
            transform="translate(652,1040)"
            d="m0 0 4 1 12 6 22 12 2 3 1 12 1 3 18 8v2l4 1v5l-6-1-14-8-3-1 1 14 21 10v2l4 1v5l-9-2-16-8v14l26 13 4 3v5l-5-1-25-13v15l5 1 26 13 3 2v6l-11-3-23-12 1 14 29 14 9 5 1 5-7-1-30-15-3-2v20l1 18 16 8 17 8 13 7 2 2v5l-8-2-27-15-13-7 1 18 31 16 11 6 1 4-9-1-9-6-22-12-3-1-1 11v7l10 1 28 2 11 2 1 2-12-1-34-3-22-1-38-1v-1l10-2 1-5 1-13 2-22h1l1 36 1 1 31 1v-50l-2-85-1-55-1-2-28-14-1 4z"
            fill="#090406"
          />
          <path
            transform="translate(1194,688)"
            d="m0 0 2 4 2 14v22l-3 16-3 9h-2v-4l-4 10h-2l-1 5-8 14-3 6-12 12-12 4-3-1h2l-4-39v-20l2 2 1 5 2-3h2l1-4 11-16 11-14 9-10z"
            fill="#0E070A"
          />
          <path
            transform="translate(797,1253)"
            d="m0 0 9 2 25 7 24 9 32 13 40 20 23 13 27 18 19 14 11 9 6 5-1 5-7 4-5-1-10-9-19-14-16-11-21-13-32-17-22-11-22-9-23-8-28-9-7-2-3-9z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(576,593)"
            d="m0 0 5 1 32 16 16 7 11 5 22 8 21 6 27 6 21 3 20 2h46l37-4 29-5 19-5 35-12 11-4h2v8l-9 4-33 11-36 9-35 5-27 2h-40l-24-2-26-4-29-7-25-8-26-10-31-15-10-6-9-5-1-3z"
            fill="#DFD240"
          />
          <path
            transform="translate(780,382)"
            d="m0 0h21l14 3 13 6 14 8 3 3v3l-5-2-22-11-13-4-5-1h-15l-10 3-6 4h-2v3l15-4h19l19 5 21 10 6 4 2 5-3 1-15 1-16 8-9 2-17-1-15-3-4-2 5 5 10 7 12 8 4 3v3l-5-1-20-12-19-10-3-3 1-5 3-4v-9l-5-8v-3l8-3 9-6z"
            fill="#12226B"
          />
          <path
            transform="translate(628,1586)"
            d="m0 0 9 1 15 8 18 12 10 5-1 4-5 5 1 6 7 12-1 3-8 2-9 5-4 2-6 1h-21l-14-4-16-8-15-9-4-4v-3l6 2 21 12 14 6 12 3h10l16-5 6-4-7 1-9 3-7 1h-8l-13-3-21-9-12-7-6-5 2-5h7l6 2 7-1 11-5 9-2h20l8 2 4-1-15-10-16-10z"
            fill="#12226A"
          />
          <path
            transform="translate(741,1088)"
            d="m0 0 10 3 28 11v1l-9-1-20-5-2-1 13 42 17 56 8 27v2l16-6 35-16 19-11h2v2l-10 6-6 4h-3l-2 4-3 3-28 14-3 2 8 2 6-1 16-8 26-14 18-11 14-10 11-9 3-1h4l-4 5-3 5-15 12-23 15-18 10-19 10 2 2 3 1h7l10-4 4 2 9 12 9 4 13 5 7 4 1 4-3 1-21-9-28-10-36-10-12-3-10 2-3-8-11-37-14-48-6-21-7-25z"
            fill="#12226B"
          />
          <path
            transform="translate(1061,1111)"
            d="m0 0 9 1 21 5 10 6 8 9 5 10 2 7 9-3 10-2h9l8 2 8 4 5 5 6 11 2 10v9l-3 10v7l4 8 1 1v5l-1 1h-6l-6-3-2-4-1-11h-12l-6-4-2-4v-5l4-5 2-1h11l1-2v-10l-3-6-8-6-7-2h-10l-10 3-8 6-4 6-5 1 1-7 2-8v-10l-3-7-4-5-9-4h-8l-3 2-2 11-4 4h-9l-5-5-1-9 4-7 3-2-1-4-3-5z"
            fill="#050305"
          />
          <path
            transform="translate(944,1359)"
            d="m0 0 15 10v2l5 2 10 8 4 3v2l-14 8h-3l-2-9-4-5-6-2-8 1-5 3-3 6 1 8 4 5 4 2v3l-5 2-4-1-14-11-4 1-7 10-11 16-2 2-4-1-20-11-11-7-1-3 18-27 4-4 5 1 17 10 13 8 4-1 8-11 10-13 4-6z"
            fill="#DECF3E"
          />
          <path
            transform="translate(138,45)"
            d="m0 0h1215l12 3 11 6 10 9 7 10 4 11 1 4v11h-1l-1-7h-1l-3-13-8-13-9-9-14-7-13-2-1255-1v-1z"
            fill="#2D2935"
          />
          <path
            transform="translate(264,822)"
            d="m0 0 6 2 3 5v7l-1 4h11l6 3 2 4-1 5-2 3-8 1h-6l-2 5 3 8 8 8 12 5h7l13-5 8-7 4-4 6 1-1 9-1 3v14l3 6 5 4 5 2 9-1 3-3 3-6 5-3h7l3 4v7l-6 8-3 2 2 4 4 5 1 4-10-2-18-4-13-7-7-8-6-16-5-1-5 2-8 1h-10l-12-3-10-6-6-9-3-8v-18l2-8v-9l-2-2 1-5z"
            fill="#060305"
          />
          <path
            transform="translate(439,657)"
            d="m0 0 3 1-3 3 3 2v2l4 2 13 10 11 8 15 10 11 7 13 8 16 9 16 8 24 11 31 12 28 9 22 6-3 1 5 21v4h-10l-22-6-42-15-24-10-26-12-23-12-23-14-17-12-14-10-14-11-14-12-4-3 2-4 6-2-1 2h-2l5 5 13 11 20 15 17 12 20 12 24 14 16 8 27 12 30 11 47 15-2-17-10-2-29-9-21-8-26-11-29-14-23-13-22-14-17-12-16-13-9-8-3-2z"
            fill="#0B0A10"
          />
          <path
            transform="translate(494,629)"
            d="m0 0h5l8 7 9 6-1 5-8 11-11 14-4 6-5-2-32-24 3-3 5-4-12 6v2l-7 4-6 2-4 3h-2v2l-7 4-8 3-10 7-5 3h-2l6 7 14 11 18 14 15 10 18 13 15 9 19 11 9 5 2 5-14-8-15-9-13-8-17-11-28-19-20-14-13-10-4-1-22 13-10 7-16 11-17 12-32 24-15 12-12 9-13 11-11 9-5 2-6 3 2-4 11-9 13-11 28-22 12-10 12-9 18-13 36-24 17-11 15-9 26-15 22-12 27-14 2 1-3 3-5 4 6-2 1 9 4 6 6 3 9-1 6-5 2-3-1-9-5-5-6-3 4-4z"
            fill="#09177C"
          />
          <path
            transform="translate(497,1499)"
            d="m0 0 16 2 15 4 11 5 11 7 11 10 9 13 6 13 3 11 2 13v9l-3 17-7 17-3 6-3-1-8-16 4-14 1-8v-12l-2-12-6-15-8-11-9-8-16-9-17-6-7-12z"
            fill="#fff"
          />
          <path
            transform="translate(947,556)"
            d="m0 0h2l7 13-1 7-4 18-1 16 2 17 4 13 7 14 9 11 15 12 19 10 15 5 6 9v3h-12l-15-4-19-9-13-10-7-7-10-13-8-15-5-14-2-9-1-10 1-21 5-21z"
            fill="#fff"
          />
          <path
            transform="translate(860,1310)"
            d="m0 0 24 10 22 12 18 10 14 9 15 10 19 13 10 8 4 2-5 3-1 1h-5l1-2h2l-5-5-12-9-2-1v-2l-5-2-9-7h-3l-2 4-10 14-4 5-7 9-4-1-14-8-17-10h-4l1-4 12-21 8-13v-3l-16-8-23-11-4-2z"
            fill="#030204"
          />
          <path
            transform="translate(679,1432)"
            d="m0 0h16l12 3 12 7 10 9 2 5 9 10-3 2-9-8-7-8-13-9-7-3-5-1h-14l-21 4-22 9-19 11-12 8-14 10-15 13-16 15-5 5 1 4 7 7 9 14 6 13 4 17v24l-4 16-5 12-6 9-3-1-1-3h2l1-5 6-12 4-15 1-8v-9l-3-18-5-13-6-11-9-11-11-9-11-6-13-5-14-3-9-1-2-1-1 2-3-7h12l21 5 20 9 5 1 11-11 8-7 10-9 14-11 16-11 16-9 16-8 16-6z"
            fill="#08167F"
          />
          <path
            transform="translate(423,738)"
            d="m0 0h9l8 4 4 5 3 12 1 1 23 1 6 1 1 2v17l-36 1-5 10-5 3-4 1h-9l-8-7-2-9 3-9 3-6-3-10v-6l4-6 5-4z"
            fill="#DFD03E"
          />
          <path
            transform="translate(833,777)"
            d="m0 0h9v1l-19 4-13 1-8-1-19 1-1 3-2 85 1 127h-5l-2-2-5-1v-2h6v-62l1-92v-52l-32-1v54l1 119-1 19-3-2-1-27-1-40v-21l-1-2v-34l-1-13-1-39v-15h-5v-2l-6-2-1-2h16l24 1h22l36-2z"
            fill="#090506"
          />
          <path
            transform="translate(296,1237)"
            d="m0 0h6l16 11 1 2-5-2-10-5 1 5 17 13 10 9 9 9 7 10v3l-4-2-12-11-20-16-7-3h-3l1 7 7 8 11 10 21 14 16 8 3 1-4-13-7-14-2-5 7 6 6 8 3 3v6h2l1 4v12l-3 1-13-5-18-10-14-10-11-9-4-4v41l2 35 8 6 7 11h18l-3 9v4l10 5 5 6-5-1-7-3-10-1-8 2-2-20-2-5-5-1-5-4-5-2h-11l-6 3-6 5-4 7h-1l1-8 7-7 11-5h7l-4-99z"
            fill="#0B080F"
          />
          <path
            transform="translate(858,1312)"
            d="m0 0 6 1 25 12 13 7-1 5-15 25-6 9-23-10-10-5-7-4-1-2 11-23 7-14z"
            fill="#DFD340"
          />
          <path
            transform="translate(758,1282)"
            d="m0 0 11 2 32 8 6 1-1 5-7 19-5 12-3 6-10-1-32-9-2-1 4-17 5-22z"
            fill="#E0D340"
          />
          <path
            transform="translate(866,713)"
            d="m0 0h6l3 6 9 30-1 5-46 7-4-1-7-37v-3l5-2 22-3z"
            fill="#DFD23F"
          />
          <path
            transform="translate(554,668)"
            d="m0 0 7 1 29 14 6 3-1 6-16 29-2 3-6-1-38-19 1-5 14-22z"
            fill="#DFD03E"
          />
          <path
            transform="translate(734,719)"
            d="m0 0 31 1 15 1 1 1v42h-14l-35-2-1-3z"
            fill="#E0D340"
          />
          <path
            transform="translate(642,703)"
            d="m0 0 10 1 33 8 1 2-8 35-2 5-10-1-37-9-2-2 13-34z"
            fill="#DFD33F"
          />
          <path
            transform="translate(654,1273)"
            d="m0 0h35l14 1-1 26-2 17h-17l-24-1-5-2z"
            fill="#E0D440"
          />
          <path
            transform="translate(281,1240)"
            d="m0 0h2l-1 6-9 15-7 10-11 18-6 18-2 10v7l8-23 11-20 12-18 3-4h3v19l-5 16-8 14-11 14-2 3h-2l-2 4-9 9-3 2h-3v-32l5-20 7-16 6-11 8-10 11-9z"
            fill="#DFD03E"
          />
          <path
            transform="translate(999,1241)"
            d="m0 0h10l6 3 4 5 2 5-1 8-4 5 1 6 2 4v7l-4 6-4 3-3 1h-12l-6-5-2-5-1-8-32-2v-17h35l1-9 4-5z"
            fill="#DFD13F"
          />
          <path
            transform="translate(850,1449)"
            d="m0 0h1l-1 8-9 25-9 21-10 20-11 18-14 19-12 14-1 2h-2l-1-6v-16l11-13 10-15 14-27 11-27 5-14 8-5z"
            fill="#fff"
          />
          <path
            transform="translate(1079,944)"
            d="m0 0 31 2 10 3 11 7v2h5l11-7 7-2h10l6 3 6 8 3 9 2 11v9l-5-1-6-8-15-3-3-3v-6l3-8-9 3-5 5-4 9-1 11-1 1h-6l-1-15-4-9-5-3-4-1h-8l-3 11-3 2-7-1-4-5-1-13-5-2-5-6z"
            fill="#060405"
          />
          <path
            transform="translate(591,1277)"
            d="m0 0h9l6 35v5l-7 2-36 6-3-9-7-24-2-8 7-2z"
            fill="#DFD33F"
          />
          <path
            transform="translate(496,1299)"
            d="m0 0 5 1 13 36-1 3-20 8-17 6h-4l-4-9-11-27 1-4 28-10z"
            fill="#DFD13E"
          />
          <path
            transform="translate(960,685)"
            d="m0 0 4 1 13 33v5l-9 4-23 8-10 3-4-8-6-16-5-13v-3l28-10z"
            fill="#DFD03E"
          />
          <path
            transform="translate(869,410)"
            d="m0 0 4 4 5 10-1 8-1 5v25l4 15 7 14 9 12 10 9 15 9 12 6 6 10-1 3-21-7-16-8-9-7-11-10-7-10-7-14-4-14-1-7v-24l4-20z"
            fill="#fff"
          />
          <path
            transform="translate(615,650)"
            d="m0 0 9 1 32 11-1 8-12 31-1 2-9-2-21-8-13-5-1-3 8-17 8-15z"
            fill="#DFD13F"
          />
          <path
            transform="translate(407,1337)"
            d="m0 0 11 1 20 6 16 8 11 7 14 14 10 14 7 16 4 16 1 7v14l-3 17-7 16-4 6-3-1-4-9 5-10 3-11 1-16-2-16-6-18-7-13-8-10-7-7-14-9-14-6-17-4-6-9z"
            fill="#fff"
          />
          <path
            transform="translate(250,1046)"
            d="m0 0 6 1 5 6 4 4 7 3 3 3v7l-1 6 1 1h9l6-4 6-8 4-13 3 1 3 12 5 8 2 1h6l9-7 4-2 5 1 3 3 1 3v10l4 2 3 3-1 5-28-2-9-2-10-9-3-1-2 4-8 5-6 2h-15l-10-7-4-8-1-17-2-10z"
            fill="#060405"
          />
          <path
            transform="translate(1133,683)"
            d="m0 0h6l1 1 1 37 4 50 2 16v12l13-4 12-12 5-10 6-11h3l1 2-7 14-9 15-1 7 3 13 4 3h-2v5l2 2-14 4-2-4v-3l-15-1-6-4-5-5-1-7 3-1h7v-3h-2l-4-11-4-31-2-47v-17z"
            fill="#14236A"
          />
          <path
            transform="translate(900,662)"
            d="m0 0 5 1 12 35-1 4-36 9-8 1-4-16-5-21v-4l18-4 14-4z"
            fill="#DFD13E"
          />
          <path
            transform="translate(558,1326)"
            d="m0 0 3 1 9 30 1 8-8 3-30 8-4 1-4-8-7-21-2-4v-6l31-9z"
            fill="#DFD03E"
          />
          <path
            transform="translate(543,610)"
            d="m0 0 5 1 9 6 9 5 11 7-1 6-10 14-11 16-2 1-14-8-21-13v-3l9-12 5-7h2l2-4z"
            fill="#DFCF3E"
          />
          <path
            transform="translate(696,674)"
            d="m0 0h10l25 3 5 2v11l-2 29h-12l-33-4-1-1 1-12 5-23z"
            fill="#E0D440"
          />
          <path
            transform="translate(793,1336)"
            d="m0 0 7 1 36 11 1 2-12 26-5 10-9-2-29-10-3-1v-6l6-13 5-12z"
            fill="#DFD23F"
          />
          <path
            transform="translate(1132,574)"
            d="m0 0h11l10 5 9 9 2 3 12-3 5-1-1 12-1 6 8 2 8 6 6 8 1 3v12l-4 8-7 7-10 5 1 7 2 7-3 1-11-4-4-3-2 6-4 6-8 6-5 3-1 2v25l1 17 2 12 1 3h-2l-1 4-2-1-1-5-1 7h-1l-2-28v-38l4-4 10-4 5-6 1-5-1-2v-9h2l1-7 12 2 10-3 8-7 2-6-1-9-6-9-8-4-16-2-5-1 2-8-1-8-5-5-7-6-5-2h-14l-3-2z"
            fill="#172362"
          />
          <path
            transform="translate(649,462)"
            d="m0 0 2 3v15l-13 18-11 19-9 17-11 28-5 15-8 5-9 3 2-11 7-21 10-23 8-16 10-18 12-17 11-13z"
            fill="#fff"
          />
          <path
            transform="translate(813,679)"
            d="m0 0h6l2 6 4 30v5l-3 1-16 1h-25l-2-40 1-1z"
            fill="#E0D43F"
          />
          <path
            transform="translate(700,1318)"
            d="m0 0 15 1 30 4 1 2-10 37-4 1-37-6-1-4 3-15z"
            fill="#DFD13E"
          />
          <path
            transform="translate(642,1316)"
            d="m0 0h11l1 5 1 17v18l-2 1-36 2-2-3-6-33 1-5z"
            fill="#DFD33F"
          />
          <path
            transform="translate(1188,702)"
            d="m0 0h3l1 3v21l-4 15-11 26-9 17-6 5-3-1 1-8 7-21 8-20 5-11 2-8-2 1-7 15-10 21-5 14-4 16-2-1-3-16v-10l4-13 7-12 8-10 9-11 4-5h2l2-4z"
            fill="#DFD23E"
          />
          <path
            transform="translate(418,1355)"
            d="m0 0 12 3 16 8 12 9v2h2l9 11 7 12 6 18 1 7v16l-4 15-2 6-4-4-6-11 1-9v-12l-4-17-7-14-11-12-14-9-6-3-5-8-3-5z"
            fill="#fff"
          />
          <path
            transform="translate(391,1497)"
            d="m0 0m-4 1h4v2l-11 4-9 4-7 1h-12l-3-2-24-1 9 22 11 33 6 26 4 27 2 21v53h-1l-1-18-2-7v-6h-2v-9l-2-17-2-18-6-32-6-23-8-25-7-19-4-11 1-1h34l23-2z"
            fill="#0A0507"
          />
          <path
            transform="translate(959,578)"
            d="m0 0 4 4 6 12v21l3 13 8 16 8 11 12 9 9 5 6 10 2 6-10-3-17-9-10-8-9-9-8-12-6-16-2-11v-19z"
            fill="#fff"
          />
          <path
            transform="translate(1071,735)"
            d="m0 0 11 1 13 7 11 7 10 8 11 11 4 7 1 9-4-2-9-8-5-5-9-8v-2l-4-2-6-4v-2l-5-2-2-1 2 4 7 6v2l4 2 23 23 6 8-1 4-6-2-15-10-14-11-8-8-11-15-5-11v-5z"
            fill="#DFCF3E"
          />
          <path
            transform="translate(283,1237)"
            d="m0 0h4l1 5 1 21v32l-3 1-6 10-16 21-12 14-8 7-3 2h-4l-3-9 3-10v-14l1-10h1v33l7-4 9-9 1-2h2l2-4 10-13 8-14 5-16 1-19-3 1-12 18-12 21-7 19-3 7h-1v-8l4-17 5-12 8-14 14-21 5-10 1-3-3 1 1-3z"
            fill="#0A070A"
          />
          <path
            transform="translate(741,1088)"
            d="m0 0 10 3 28 11v1l-9-1-20-5-2-1 13 42 17 56 8 27v2l16-6 35-16 19-11h2v2l-10 6-6 4h-3l-2 4-3 3-28 14-12 3-8 5-5-1-13-44-14-48-6-21-7-25z"
            fill="#060509"
          />
          <path
            transform="translate(583,1640)"
            d="m0 0 9 3 16 8 12 4 17 3h24l14-5 5-2h7l2 3v5l-6 7-10 6-12 3h-11l-16-3-16-6-21-11-14-10z"
            fill="#13236B"
          />
          <path
            transform="translate(1193,865)"
            d="m0 0 5 1 1 1v8l-2 7v5l4 3v6l-7 9-10 6-18 3-3 1-2-3-1-8-8-7 1-4 2-1 3 3v2l10-1 3-1v-9l-8-3v-2l16-8z"
            fill="#071481"
          />
          <path
            transform="translate(744,279)"
            d="m0 0 11 1 11 16 9 10 6 7 8 7 10 8 17 11 21 10 6 9 1 5-17-6-16-8-15-9-12-9-12-11-12-13-11-16-6-11z"
            fill="#fff"
          />
          <path
            transform="translate(310,1425)"
            d="m0 0h2l6 12v13l-3 6-7 6-5 2h-12l-10-5-5-7-2-6v-8l4-7 6-5 11 10 4-2z"
            fill="#DFD33F"
          />
          <path
            transform="translate(303,1242)"
            d="m0 0 10 4 15 10v2l5 2 1 3 4 2 8 8 7 11 8 19v5l-6-1-15-8-16-11-13-11-8-8-2-5 1-5 5 1 8 4 10 9 10 8 11 10 2 1-5-9-11-12-7-7-16-12-6-5z"
            fill="#DFD03E"
          />
          <path
            transform="translate(773,359)"
            d="m0 0h19l17 4 21 10 14 10 5 6v2l-6-1-21-9-15-5-10-2h-22l-23 6-6-1-2-5 5-6 14-7z"
            fill="#13236A"
          />
          <path
            transform="translate(956,983)"
            d="m0 0 2 1v9l-2 5-7 6-8 14-4 16v14l3 13 5 10v6l-3 6-5-2-6-7-4-9-2-9-1-9v-9l2-14 5-14 6-10 9-10 8-6z"
            fill="#fff"
          />
          <path
            transform="translate(1169,609)"
            d="m0 0h10l8 4 6 8 2 6-1 8-3 5-7 6-10 3-11-2-8-7 1-5 6-7-1-4-6-5 2-4 7-5z"
            fill="#DFD33E"
          />
          <path
            transform="translate(797,1247)"
            d="m0 0 16 4 38 13 33 14 22 10 19 10 20 11 16 10 20 14 17 13 11 9 7 7 7 1h3l7-4 3 1-23 14-2-1 3-3 4-1-1-4-10-6-12-10-19-14-17-11-18-11-24-13-32-16-30-12-27-10-28-8-3-1-1 4-1-6-3-1v-2z"
            fill="#14205C"
          />
          <path
            transform="translate(1396,1567)"
            d="m0 0h1l1 19 1 342-1 14-4 13-7 11-9 9-10 6-9 3-6 1h-247l-18-1v-1l264-1 12-3 13-7 7-7 8-14 3-11 1-28z"
            fill="#2E2A33"
          />
          <path
            transform="translate(653,1497)"
            d="m0 0 5 2 8 4h13l10-3 9 1 11 3h7l10-4 5 1v9l-2 9-7-2-11 1-3 1h-8l-4-1-7 3-10-1-4-1h-10l-4 3h-2l-3-17-3-6z"
            fill="#12226B"
          />
          <path
            transform="translate(513,762)"
            d="m0 0 5 1 29 14 32 13 37 12 25 6-1 3-9-1-12-2-32 16-7 4-9 3-3 2h-3v2l-7 4h-2v2l-5 3h-4l-1-3 21-14 23-13 17-9-10-4-5 1-11 6-14-15-5-4-17-7-9-5-11-5-8-4-2-4z"
            fill="#071580"
          />
          <path
            transform="translate(612,546)"
            d="m0 0 4 2-7 21-2 5 7-1 7-2 3-10 3-7h4l1 3-5 12 6-1 1 2 11-3 4-1 1 2-20 7h-3v3l6 1 32 13 14 5 25 6 26 5 20 2h44l25-1v1l-30 5h-30l-32-3-26-5-27-7-17-6-18-7-13-6v-3h-9l-12 3-11 5-10 1 1-4v2l16-8 9-26z"
            fill="#152266"
          />
          <path
            transform="translate(706,514)"
            d="m0 0 5 2 4 3 8-1h10l9 1 11-2 13 3 8-3h3l5 21-2 1-16-6-9 1-4 1h-16l-9-2h-8l-6 3h-5l-1-1z"
            fill="#13226A"
          />
          <path
            transform="translate(329,1389)"
            d="m0 0 10 1 8 4 5 7 1 3v10l-6 8-6 5-7 2-9-1-8-4-2-4 7-6h2l-3-5-8-8 1-4 8-6z"
            fill="#DFD23E"
          />
          <path
            transform="translate(1131,577)"
            d="m0 0h11l8 4 6 7 1 5v7l-3 7-3 5-4 1-9-7-4-1-8 8-4-1-6-9-1-3v-9l6-9z"
            fill="#DFD33E"
          />
          <path
            transform="translate(291,1359)"
            d="m0 0h11l8 4 5 6 2 4v11l-7 10-1 2-4-2-8-6-5 1-7 6-4-1-4-7-2-6v-7l5-8 8-6z"
            fill="#DFD23E"
          />
          <path
            transform="translate(593,1674)"
            d="m0 0 9 3 19 10 14 9 12 9 10 9 13 13 12 17 2 6h-10l-5-5-10-13-17-17-19-14-18-10-5-3-7-12z"
            fill="#fff"
          />
          <path
            transform="translate(243,1398)"
            d="m0 0 2 1-2 3-1 7 2 9 5 5 5 4 4 4 16 1 2 3-1 3v8l4 9 5 5 7 3h12l8-4 4-4 2-5 1-11h1l2-6 1-1h8l5 1 1 11 1 10-10-3-6-2-1 6-5 7-10 5h-16l-9-4-6-5-6-9-17 1 2-11 1-6-10-6-7-8-3-10 1-9 5 2z"
            fill="#142266"
          />
          <path
            transform="translate(651,486)"
            d="m0 0 2 1 3 15-7 10-12 23-10 21-6 15-10 4h-5l9-26 14-29 11-18 9-13z"
            fill="#fff"
          />
          <path
            transform="translate(259,1388)"
            d="m0 0h8l9 5 3 3-1 5-9 8 4 8 4 2 1 4-8 5-4 1h-10l-6-4-5-5-3-4-1-8 2-8 7-8z"
            fill="#DFD33F"
          />
          <path
            transform="translate(1099,610)"
            d="m0 0h13l8 4 1 4-10 10 2 4 9 9-1 4-10 5h-13l-8-5-5-7-1-4v-9l4-7 7-6z"
            fill="#DFD23E"
          />
          <path
            transform="translate(679,1432)"
            d="m0 0h16l12 3 12 7 10 9 2 5 9 10-3 2-9-8-7-8-13-9-7-3-5-1h-14l-21 4-22 9-3 2-9 3-16 9-17 12-11 10-9 7-12 12-1-4 2-1v-2l5-4 9-11 14-12 19-13 16-9 16-8 16-6z"
            fill="#08157F"
          />
          <path
            transform="translate(1141,1041)"
            d="m0 0 6 1 13 10 10 7-1 3h-2l-2 4-15 16-1 2-5-1-16-13-5-4 1-4 9-11z"
            fill="#080507"
          />
          <path
            transform="translate(1150,642)"
            d="m0 0 5 3 5 10v7l-3 8-9 7-9 2-9-1-8-5-3-5-1-4v-8l4-8 3-3 4 2 7 6 4-1z"
            fill="#DFD23E"
          />
          <path
            transform="translate(489,957)"
            d="m0 0 4 1 7 10 5 11 3 13v10l-3 14-6 12-7 9-10 9-6 2v-12l7-8 6-7 5-11 1-6v-11l-4-16-5-10z"
            fill="#fff"
          />
          <path
            transform="translate(1064,1205)"
            d="m0 0 7 4 15 11 6 4-6 8-12 14-3 3-9-6-17-13 2-5 14-17z"
            fill="#070406"
          />
          <path
            transform="translate(458,1133)"
            d="m0 0h1v7l-2 11v7l-11 33-8 18-8 16-10 18-11 16-14 19-11 13-2 3h-2l3 7 9 16 1 4h-5l-9-17-4-5-3-6 6-2 3-6 10-12 14-19 12-19 9-16 8-16 7-16 9-25 7-28z"
            fill="#09177D"
          />
          <path
            transform="translate(824,1459)"
            d="m0 0h3l-1 5-13 32-12 23-20 30h-2l-2-10v-5l11-17 10-18 13-30 3-6z"
            fill="#fff"
          />
          <path
            transform="translate(83,45)"
            d="m0 0h55v1l-45 1-16 2-13 5-9 7-7 8-6 12-2 7-1 10-1 386-2 1v-392l2-11 8-16 6-7 8-6 12-6z"
            fill="#2A293A"
          />
          <path
            transform="translate(867,405)"
            d="m0 0 3 4-6 23-1 7v24l3 15 6 15 7 11 9 10 10 8 14 8 19 7 7 2 2-1 3 6v3l-12-3-19-7-14-8-8-6h-3l-4 4 1-5h-3l-1 3-4 3-2-1 8-9-3-5-9-12-8-16-4-12-2-10v-21l4-20 6-16z"
            fill="#09167D"
          />
          <path
            transform="translate(414,1349)"
            d="m0 0 10 1 15 5 13 7 10 8 8 8 9 14 5 11 4 13 2 16-1 16-4 14-4 7h-2l-3-7 5-16 1-5v-16l-3-14-6-15-8-12-5-5v-2h-2l-5-5-10-7-16-7-9-3-1 2-3-6z"
            fill="#13236B"
          />
          <path
            transform="translate(283,954)"
            d="m0 0 4 2 10 9 10 10-6 7-8 8-5 6-4-1-13-11-9-8v-2l8-7z"
            fill="#080608"
          />
          <path
            transform="translate(359,791)"
            d="m0 0 4 2 17 13 5 5-9 9-8 10h-2l-1 3-4-1-13-11-8-6 1-4 11-12z"
            fill="#080507"
          />
          <path
            transform="translate(650,1420)"
            d="m0 0h30l34 3 25 5 21 5 12 4-2 2-11-4h-8l-30-6-15-2-37-2h-13l-35 2-41 7-24 6-29 10-5 1v-4l22-8 37-10 24-5 14-2z"
            fill="#120E1E"
          />
          <path
            transform="translate(284,1234)"
            d="m0 0 11 2 1 1 4 95v23h-6l-2-2-5-111v-6h-3z"
            fill="#E0D443"
          />
          <path
            transform="translate(606,1026)"
            d="m0 0 5 1-16 63-22 87-11 42-4 4h-9l2-2 5-2 11-42 14-55 17-66z"
            fill="#060506"
          />
          <path
            transform="translate(494,629)"
            d="m0 0h5l8 7 9 6-1 5-8 11-11 14-4 6-5-2-32-24 3-3 12-7h2l1 9 4 6 6 3 9-1 6-5 2-3-1-9-5-5-6-3 4-4z"
            fill="#DFCF3E"
          />
          <path
            transform="translate(421,668)"
            d="m0 0 2 1-3 1 5 5 13 11 20 15 17 12 20 12 24 14 16 8 27 12 13 5v2l5 2 5 5-5-1-21-8-33-15-25-13-23-14-17-12-14-10-14-11-14-12-4-3 2-4z"
            fill="#0A0A13"
          />
          <path
            transform="translate(882,435)"
            d="m0 0h2l8 16 2 16 4 12 7 11 10 9 6 5 8 15-1 2-16-9-13-11-9-12-6-13-3-15v-18z"
            fill="#fff"
          />
          <path
            transform="translate(1129,682)"
            d="m0 0 2 1 1 4 2 53 1 26h-1v-7h-2v6l-4 1-5-3h-3l-7-7-13-9-14-8-9-3h-6l1 8 6 11 11 14 6 7-4-2-11-8-8-11-5-10-2-7v-12l7 1 21 8 13 8 12 9 10 8 2 1-1-11z"
            fill="#152364"
          />
          <path
            transform="translate(443,1140)"
            d="m0 0 2 1-1 5 1 2-1 10-10 30-11 24-5 9-5 5-6 11-8 11-7 10-5 5-6 8-5 4h-3l1-5 10-12 13-18 12-19 12-23 10-25 8-27 3-3z"
            fill="#071481"
          />
          <path
            transform="translate(1133,683)"
            d="m0 0h6l1 1 1 37 4 50 2 16v12l-3 1-3-3-3-9-4-31-2-47v-17z"
            fill="#E0D444"
          />
          <path
            transform="translate(508,1519)"
            d="m0 0 10 4 14 8 10 9 7 9 5 10 3 11 1 16-3 15-2 2-5-9v-13l-3-14-8-16-9-10-13-7-7-12z"
            fill="#fff"
          />
          <path
            transform="translate(776,1691)"
            d="m0 0h4v10l-19 11-16 13-10 10-11 15h-12l1-4 10-14 12-13 13-12 13-8z"
            fill="#fff"
          />
          <path
            transform="translate(695,1212)"
            d="m0 0 6 2 29 16 10 6 3 1 2 10v9l-5-2-25-13-20-11z"
            fill="#fff"
          />
          <path
            transform="translate(649,810)"
            d="m0 0 4 2 15 56 10 39 9 35 1 9-4 1-4-4-1-9-18-69-13-51v-3l-3-1 2-4z"
            fill="#050405"
          />
          <path
            transform="translate(956,570)"
            d="m0 0 2 3 2 5-4 20v19l3 14 5 13 9 13 10 10 14 9 15 7 5 2 1-2 3 9-9-2-12-5-14-8-14-11-7-8-8-13-5-13-2-10-1-14 2-20 3-12z"
            fill="#09177D"
          />
          <path
            transform="translate(295,1393)"
            d="m0 0 4 1 15 13 1 6-12 11-7 5-5-2-6-5-9-9 1-5 12-11z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(687,781)"
            d="m0 0 6 2 25 12 17 8v18l-20-9-25-12-2-9z"
            fill="#fff"
          />
          <path
            transform="translate(576,828)"
            d="m0 0 2 1-18 11-13 10-11 10-8 7-7 8-10 11-14 20-9 15-4 9-2-3 3-7 1-4h2l1-6v-3l-2 3-2-1 11-18 11-14 25-25 13-10 5 2 3-3h3v-2l6-4h3v-2z"
            fill="#12226B"
          />
          <path
            transform="translate(530,929)"
            d="m0 0 10 1 5 5v7l-4 5-16 8-11 5h-5l1-9-7-1-2-4 12-9 11-6z"
            fill="#fff"
          />
          <path
            transform="translate(944,548)"
            d="m0 0 3 4v3l2 1h-2l-1 5-5 13-4 18-1 21 2 14 4 14 8 16 7 11 13 14 13 9 17 8 15 4 12 1 1-2v4h-11l-17-4-14-6-14-9-13-12-8-7-9-14-6-13-4-15-2-1v-26l3-22-3-1 5-3z"
            fill="#1D2B6E"
          />
          <path
            transform="translate(715,280)"
            d="m0 0h10l-2 5-8 12-6 8h-2l-2 4-9 9-16 12-12 7-15 6-1-7 8-5 12-7 17-13 12-12 11-14z"
            fill="#fff"
          />
          <path
            transform="translate(827,809)"
            d="m0 0h3l-3 19-25 12-16 8h-2v-17l38-20z"
            fill="#fff"
          />
          <path
            transform="translate(695,1189)"
            d="m0 0 16 8 19 10 8 4 4 16-2 2-35-17-10-5-1-1v-16z"
            fill="#fff"
          />
          <path
            transform="translate(761,280)"
            d="m0 0h9l13 14 7 8 9 8 14 10 13 8 7 11v2l-6-2-21-11-14-11-15-14-11-14z"
            fill="#fff"
          />
          <path
            transform="translate(264,1120)"
            d="m0 0 4 3 3 11 9 4 1 7-3-1v-2h-3l1 5-3 3-6 1-5-4-1-4 6-3-3-3v-2l-9 1-2 4-16 7-5 2-2-2v-9l4-6 10-6 15-2v-2z"
            fill="#08167E"
          />
          <path
            transform="translate(1134,612)"
            d="m0 0 5 1 15 12 1 4-14 16-5 3-8-7-10-9 1-5 6-7h2l2-4z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(548,952)"
            d="m0 0 6 1 4 5 1 6-4 5-9 4-18 5h-8v-6l-1-3-6-1v-3l12-6 13-5z"
            fill="#fff"
          />
          <path
            transform="translate(898,1262)"
            d="m0 0 11 1 9 5 5 5 14 7 18 10 23 14 15 10 24 18 14 12 7 7 7 3-3 3-13 5-5 3-3-1 1-3 12-8 1-2-5-2-25-20-34-24-18-11-15-9-30-16-8-4z"
            fill="#09167E"
          />
          <path
            transform="translate(604,1695)"
            d="m0 0 6 2 16 10 13 10 7 7 5 4 13 17 2 4-1 1h-10l-9-10-7-8-10-9-12-9-5-4-8-14z"
            fill="#fff"
          />
          <path
            transform="translate(881,990)"
            d="m0 0h11l14 5 12 7 2 4-5 3-1 7-3 1-16-4-15-8-4-6 1-7z"
            fill="#fff"
          />
          <path
            transform="translate(451,1350)"
            d="m0 0 6 2 10 7 10 8 12 11 7 11 6 15 2 13 1 1 1 20-1 10-2 10-1 8-8 16-3 5-3-1-3-7h2l2-5 7-14 3-12 1-8v-14l-3-17-6-16-7-12-9-11-10-10-11-7z"
            fill="#37447F"
          />
          <path
            transform="translate(777,1707)"
            d="m0 0 3 1v12l-3 3-11 7-10 8-7 8-3 4-9 1-7-1 6-9 9-10 9-9 11-8z"
            fill="#fff"
          />
          <path
            transform="translate(876,1014)"
            d="m0 0 17 2 18 6 1 4-4 2 1 8h-14l-19-2-6-4-2-3v-6l4-5z"
            fill="#fff"
          />
          <path
            transform="translate(805,1467)"
            d="m0 0h2l-1 5-11 24-10 18-9 13h-2l-4-10 1-5 6-10 9-17 6-13z"
            fill="#fff"
          />
          <path
            transform="translate(832,785)"
            d="m0 0h3v9l-2 6-16 8-29 15-3 1v-15l16-8 15-8z"
            fill="#fff"
          />
          <path
            transform="translate(545,979)"
            d="m0 0h12l6 3 3 4v5l-6 6-4 1h-27l-5-1 1-7-5-3-1-3 5-2z"
            fill="#fff"
          />
          <path
            transform="translate(520,1019)"
            d="m0 0 6 1 17 6 9 6 4 5-1 6-4 4h-9l-12-5-15-8-2-2 1-4 4-2z"
            fill="#fff"
          />
          <path
            transform="translate(898,967)"
            d="m0 0 7 1 12 6 8 7 4 6-2 5-3 7-2 1-16-8-9-7-5-6-1-7 4-4z"
            fill="#fff"
          />
          <path
            transform="translate(697,280)"
            d="m0 0h12l-3 5-8 10-9 10-7 7-15 11-14 7-1-5 2-7 13-9 13-11 13-13z"
            fill="#fff"
          />
          <path
            transform="translate(915,948)"
            d="m0 0 7 1 9 6 11 11 6 8-1 4-7 1-2 4-5-1-12-9-7-7-4-7v-6z"
            fill="#fff"
          />
          <path
            transform="translate(944,1377)"
            d="m0 0 9 1 5 4 3 6v6l6-2-3 5-16 8-5 4-3 3-11 5-3-1 8-5 5-5h3v-3l-5-2-4-5-1-8 5-8z"
            fill="#0C0608"
          />
          <path
            transform="translate(1132,574)"
            d="m0 0h11l10 5 9 9 2 3 12-3 5-1-1 12-1 6 8 2 5 3 1 5 3 5 1 15-5 8-2 2h-3v2l-4 2-14 1-6-2 3-1 8 1 10-3 8-7 2-6-1-9-6-9-8-4-16-2-5-1 2-8-1-8-5-5-7-6-5-2h-14l-3-2z"
            fill="#132368"
          />
          <path
            transform="translate(657,510)"
            d="m0 0h2l3 9v5l-5 8-9 19-5 12-5 3-8 3h-3l3-9 9-21 9-16 8-12z"
            fill="#fff"
          />
          <path
            transform="translate(920,1077)"
            d="m0 0 3 1 1 6 5 2-1 4-11 9-8 6-6 2h-7l-5-5-1-6 5-8 10-6 10-4z"
            fill="#fff"
          />
          <path
            transform="translate(880,1041)"
            d="m0 0h28l-1 9h2v5l-8 3-10 2h-14l-7-3-4-6 1-5 4-3z"
            fill="#fff"
          />
          <path
            transform="translate(523 1e3)"
            d="m0 0 27 1 10 3 5 6-1 5-5 4-2 1h-14l-17-5-6-2v-3h2v-9z"
            fill="#fff"
          />
          <path
            transform="translate(691,1064)"
            d="m0 0h1l2 13 18 8v2l4 1v5l-6-1-14-8-3-1 1 14 21 10v2l4 1v5l-9-2-16-8v14l26 13 4 3v5l-5-1-25-13-1 13h-2v-13l-1-11v-47z"
            fill="#13236B"
          />
          <path
            transform="translate(494,1048)"
            d="m0 0 4 1 9 9 10 13 2 4v7l-6 4-6-1-6-4-7-8-10-16 1-2 7-2z"
            fill="#fff"
          />
          <path
            transform="translate(644,1215)"
            d="m0 0h2v16l-25 12-18 8h-2l2-14 3-3z"
            fill="#fff"
          />
          <path
            transform="translate(644,1190)"
            d="m0 0h2v17l-36 18-5 1 3-17 19-10z"
            fill="#fff"
          />
          <path
            transform="translate(510,1035)"
            d="m0 0 9 5 14 11 7 8-1 5-5 4-9-1-9-6-12-11-5-5 1-4 6 1z"
            fill="#fff"
          />
          <path
            transform="translate(741,285)"
            d="m0 0 3 2v2h2v2h4l9 13 12 14 9 9 13 10 18 11 16 8 16 6 2-1 3 9-9-3-25-11-18-10-16-12-10-9-5-5-10-11-10-15-4-7z"
            fill="#09177D"
          />
          <path
            transform="translate(909,1059)"
            d="m0 0 4 1v9l2 4-14 7-15 5-6-1-5-5 1-7 5-5 18-6z"
            fill="#fff"
          />
          <path
            transform="translate(428,748)"
            d="m0 0h5l3 3-1 7-1 5 4 3 3 1 29 2v5l-3 1-33-1-3 12-2 2h-5l-3-2-1-3v-8l3-5h2l-1-6-2-5v-6l3-4z"
            fill="#080508"
          />
          <path
            transform="translate(871,814)"
            d="m0 0h1v7l-16 65-30 123-2 7h-4l1-10 5-18 1-7 3-8 8-30 30-120z"
            fill="#070608"
          />
          <path
            transform="translate(693,807)"
            d="m0 0 5 1 23 12 14 7v16l-5-2-20-10-15-8-1-2z"
            fill="#fff"
          />
          <path
            transform="translate(546,623)"
            d="m0 0 9 1 5 3 3 4 1 10-7 8-5 2-9-1-6-5-3-6 1-7 6-7z"
            fill="#0D0709"
          />
          <path
            transform="translate(653,716)"
            d="m0 0h10l6 4 3 5 1 2-1 9-7 6-2 1h-10l-6-4-3-5v-9l4-6z"
            fill="#10080B"
          />
          <path
            transform="translate(750,728)"
            d="m0 0h12l6 4 3 6v7l-4 6-6 4h-9l-6-4-3-4-1-3v-7l4-6z"
            fill="#0D080B"
          />
          <path
            transform="translate(694,1168)"
            d="m0 0 5 2 34 17 3 8 1 10-42-21-1-1z"
            fill="#fff"
          />
          <path
            transform="translate(944,697)"
            d="m0 0h10l5 3 4 6v9l-4 6-5 3h-11l-7-6-2-5 1-8 5-6z"
            fill="#0E070A"
          />
          <path
            transform="translate(884,674)"
            d="m0 0h11l6 4 3 7v6l-4 6-7 4h-8l-5-3-4-5-1-2v-8l4-6z"
            fill="#10090B"
          />
          <path
            transform="translate(644,1166)"
            d="m0 0h2v18l-34 16h-3l1-12 1-5z"
            fill="#fff"
          />
          <path
            transform="translate(848,724)"
            d="m0 0h9l6 4 3 4 1 9-3 5-5 4-2 1h-10l-7-6-2-4v-7l3-6z"
            fill="#0A0709"
          />
          <path
            transform="translate(623,663)"
            d="m0 0h10l6 5 3 6-1 7-3 5-7 4h-8l-7-4-3-6v-8l4-6 2-2z"
            fill="#0F090C"
          />
          <path
            transform="translate(558,679)"
            d="m0 0h10l7 4 3 6v7l-4 6-5 4h-10l-6-4-4-6 1-9 6-7z"
            fill="#0B0709"
          />
          <path
            transform="translate(709,685)"
            d="m0 0h9l6 4 4 6v8l-6 7-4 2h-9l-6-4-4-6v-7l3-5 5-4z"
            fill="#0F090C"
          />
          <path
            transform="translate(505,1514)"
            d="m0 0 8 2 14 6 14 9 8 8 8 13 5 15 1 8v12l-3 16-2 6h-2l-3-6 3-10 1-7-1-16-4-13-6-11-9-10-8-6-17-9-6-3z"
            fill="#08167E"
          />
          <path
            transform="translate(797,688)"
            d="m0 0h9l6 4 4 6v8l-6 7-4 2h-9l-6-4-3-4-1-9 6-8z"
            fill="#10090C"
          />
          <path
            transform="translate(576,1286)"
            d="m0 0h8l6 4 3 4 1 3v7l-6 7-4 2h-9l-6-4-4-7v-6l4-6 4-3z"
            fill="#0D090C"
          />
          <path
            transform="translate(538,1337)"
            d="m0 0h10l6 4 3 5v9l-6 7-4 2h-8l-6-4-3-3-1-3v-9l5-6z"
            fill="#090608"
          />
          <path
            transform="translate(628,1324)"
            d="m0 0h9l6 4 4 7-1 8-4 5-6 3h-8l-6-4-4-6v-8l6-7z"
            fill="#130A0D"
          />
          <path
            transform="translate(822,835)"
            d="m0 0h3l-2 15-15 8-22 10-3-1 1-14 33-16z"
            fill="#fff"
          />
          <path
            transform="translate(480,1314)"
            d="m0 0h9l5 3 5 6v7l-4 7-5 3-7 1-8-3-5-8v-6l4-6 3-3z"
            fill="#10080B"
          />
          <path
            transform="translate(802,1349)"
            d="m0 0h9l5 3 4 4 1 3v7l-5 7-8 3-7-1-5-3-4-7 1-9 6-6z"
            fill="#0F0709"
          />
          <path
            transform="translate(476,1060)"
            d="m0 0 4 1 7 9 8 14 1 8-5 6h-7l-5-3-4-5-3-10v-11l2-7z"
            fill="#fff"
          />
          <path
            transform="translate(878,425)"
            d="m0 0 2 3 4 7h-2v26l3 15 8 16 9 11 13 10 13 7 2-1 2 7-9-3-14-8-10-8-9-10-8-13-5-14-2-8v-25z"
            fill="#09177D"
          />
          <path
            transform="translate(882,1389)"
            d="m0 0h9l8 6 2 5v6l-7 8-4 2-10-1-5-5-3-4v-7l4-6 3-3z"
            fill="#0E080A"
          />
          <path
            transform="translate(774,1296)"
            d="m0 0 8 1 7 6 1 3v8l-6 7-4 2h-8l-6-3-4-6v-9l3-5 5-3z"
            fill="#0B080B"
          />
          <path
            transform="translate(866,1331)"
            d="m0 0h9l6 4 3 4 1 8-3 5-5 4-2 1h-10l-5-3-4-7 1-9 4-5z"
            fill="#0E0709"
          />
          <path
            transform="translate(715,1326)"
            d="m0 0h6l6 3 5 6v8l-3 6-7 4h-8l-7-4-3-5v-9l6-7z"
            fill="#0A080B"
          />
          <path
            transform="translate(673,1282)"
            d="m0 0h10l6 4 3 5v8l-4 6-5 3h-10l-5-3-3-4-1-3v-8l5-6z"
            fill="#0D090D"
          />
          <path
            transform="translate(257,1166)"
            d="m0 0 8 1 6 4 5 2v2l-16 8-9 7-10 8-4-2-1-3v-7l5-9 9-8z"
            fill="#fff"
          />
          <path
            transform="translate(1e3 1248)"
            d="m0 0h7l3 4v8l-5 5-3 2 2 5 3 3 1 7-4 4-6 1-3-2v-16h-17l-14-1-4-2 1-3h25l11 1v-10l2-5z"
            fill="#0D0708"
          />
          <path
            transform="translate(265,1187)"
            d="m0 0 5 1 4 4 9 1 1 4-10 7-16 11-4 2-4-1-2-3v-8l5-10 9-7z"
            fill="#fff"
          />
          <path
            transform="translate(1189,841)"
            d="m0 0 4 2 1 6-6 12-8 7-8 3-6-1-5-4-6-2 2-4 13-7 14-10z"
            fill="#fff"
          />
          <path
            transform="translate(737,886)"
            d="m0 0h2l1 5v18l1 50 1 17 1 1 1-9h1l1 11 7 4 13 1 1 1 1 7 1 3h5l2 2 5 1v-2l5-1-2 4h-2l2 5-6-2-24-12-22-13 2-1 6 3-1-3-8-5 2-1 4 2v-14l-4-4h5v-2l-3-1 2-1-1-15-4-3 6 1v-3l-2-1v-16l-3-1 3-2v-17l-3-3h3z"
            fill="#132268"
          />
          <path
            transform="translate(1058,760)"
            d="m0 0h6l-4 7-7 7-1 5-11 13-10 14-5 4-7 12-8 15-2 1v-4l-5 10h-2l2-6 10-19 12-19 12-17 9-11 9-10z"
            fill="#11206E"
          />
          <path
            transform="translate(489,906)"
            d="m0 0 2 2-3 8h-2l1 3-3 4-1 9-6 15-6 20-6 29-1 7-2 1-2-5 1-4v3h2l-2-12v-7l6-26 8-24 8-16 2-3h2z"
            fill="#071580"
          />
          <path
            transform="translate(693,1139)"
            d="m0 0 1 2 5 1 26 13 3 2v6l-11-3-23-12 1 14 29 14 9 5 1 5-7-1-30-15-3-2v13h-1l-1-41z"
            fill="#08157E"
          />
          <path
            transform="translate(516,1535)"
            d="m0 0 5 1 9 6 8 9 8 16 3 14v8l-2 3-3-4-8-16-13-23v-2h-2l-3-7z"
            fill="#0B187C"
          />
          <path
            transform="translate(726,285)"
            d="m0 0 2 1-1 5-10 13-9 10-9 9-15 11-14 8-12 5h-6l1-4 22-11 13-9 11-9 7-7 1-2h2l2-4 8-11z"
            fill="#071580"
          />
          <path
            transform="translate(694,1206)"
            d="m0 0 19 9 27 13 3 3v5l-8-2-27-15-13-7 1 18 31 16 11 6 1 4-9-1-9-6-22-12-4-1-1-3z"
            fill="#071580"
          />
          <path
            transform="translate(938,936)"
            d="m0 0h6l6 4 5 6 4 9v8l-5 6-1 2-4-2-10-12-5-10v-7z"
            fill="#fff"
          />
          <path
            transform="translate(719,1643)"
            d="m0 0 7 1 11 5 8 2h14l16-4 5 1-1 5-6 4-13 4h-19l-12-5-8-6-2-2z"
            fill="#fff"
          />
          <path
            transform="translate(698,831)"
            d="m0 0 36 17 2 2v14l-4-1-30-15-2-3z"
            fill="#fff"
          />
          <path
            transform="translate(1358,1981)"
            d="m0 0h7l-3 2-9 2h-247l-18-1v-1l264-1z"
            fill="#152365"
          />
          <path
            transform="translate(953 1e3)"
            d="m0 0h3l-1 12-4 27-2 18-4-1-3-5-2-7v-18l4-13 7-11z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(703,855)"
            d="m0 0 4 1 29 13 1 6v11l-9-3-21-10-2-3z"
            fill="#fff"
          />
          <path
            transform="translate(668,374)"
            d="m0 0h13l15 2 11 4 8 6 2 3-1 3-8-4-11-3-7-1h-17l-18 4-2-7 4-4z"
            fill="#fff"
          />
          <path
            transform="translate(814,881)"
            d="m0 0h3v8l-1 7-30 14h-3v-14l6-4z"
            fill="#fff"
          />
          <path
            transform="translate(515,911)"
            d="m0 0h7l5 4-1 7-4 5-21 14-6 1 1-7 7-14 6-8z"
            fill="#fff"
          />
          <path
            transform="translate(756,280)"
            d="m0 0h4l1 2v6l6 1 11 14 8 8 11 9 11 8 23 12 5 4 1 5-9-3-17-9-16-11-12-11-6-5-7-8-8-10-6-9z"
            fill="#08167E"
          />
          <path
            transform="translate(1177,822)"
            d="m0 0 4 2 1 2-1 9-7 9-8 4-7-3-10-4 2-4 10-9 8-4z"
            fill="#fff"
          />
          <path
            transform="translate(828,1462)"
            d="m0 0 2 4-10 26-12 25-10 17-11 14-4 5h-2v-6l12-17 12-20 11-23 9-23z"
            fill="#081580"
          />
          <path
            transform="translate(431,1379)"
            d="m0 0 7 4 10 9 7 9 5 11 3 12 1 14h-2l-15-28-10-18-6-11z"
            fill="#fff"
          />
          <path
            transform="translate(820,858)"
            d="m0 0h1l-1 13-3 3-32 15-2-1v-9l2-4 30-15z"
            fill="#fff"
          />
          <path
            transform="translate(694,1148)"
            d="m0 0 6 2 19 10 9 4 3 10v5l-5-1-32-16z"
            fill="#fff"
          />
          <path
            transform="translate(927,577)"
            d="m0 0h3l1 3-28 12-28 9-24 6-28 5-18 2h-9v-1l23-4 7-2 25-5 26-7 33-11z"
            fill="#0B0C18"
          />
          <path
            transform="translate(567,1535)"
            d="m0 0 4 1 2-1 8 17 4 17v24l-4 16-5 12-6 9-3-1-1-3h2l1-5 6-12 4-15 1-8v-9l-3-18-5-13-5-9z"
            fill="#11206E"
          />
          <path
            transform="translate(414,1349)"
            d="m0 0 10 1 15 5 13 7 10 8 8 8 3 4 4 11v4h-2l-4-7-11-11v-2h-2l-5-5-10-7-16-7-9-3-1 2-3-6z"
            fill="#09167E"
          />
          <path
            transform="translate(1209,45)"
            d="m0 0h144l12 3 11 6 10 9 7 10 4 11 1 4v11h-1l-1-7h-1l-3-13-8-13-9-9-14-7-13-2-139-1z"
            fill="#2E2A33"
          />
          <path
            transform="translate(1193,865)"
            d="m0 0 5 1 1 1v8l-4 7-6 5-4 2h-7l-9-4-6-2v-2l16-8z"
            fill="#fff"
          />
          <path
            transform="translate(693,1125)"
            d="m0 0 16 8 15 8 3 12v3l-6-2-24-12-3-1-1-2z"
            fill="#fff"
          />
          <path
            transform="translate(584,1624)"
            d="m0 0 6 2 21 12 14 6 12 3h10l16-5 6-2h4l-2 5-7 4-4 2-6 1h-21l-14-4-16-8-15-9-4-4z"
            fill="#09177D"
          />
          <path
            transform="translate(427,1372)"
            d="m0 0 9 3 11 8 8 8 8 13 5 16 1 6v12l-2 8-3-4-1-4-1-14-3-12-7-14-9-10-11-8h-2l-3-6z"
            fill="#09177D"
          />
          <path
            transform="translate(1175,816)"
            d="m0 0 5 1 7 8 7 9 3 7v12h-4v-8l-2-3-9 3-15 11h-5l-2-8 9-2 7-5 4-6 1-9-3-3-4-2z"
            fill="#12226C"
          />
          <path
            transform="translate(547,867)"
            d="m0 0 2 1-15 15-1 3 14 12 16 16 10 14 2 3h36v1l-8 1 1 2-27 2-8-7-8-10-9-10-15-14-9-7 1-5 13-12z"
            fill="#060507"
          />
          <path
            transform="translate(775,1686)"
            d="m0 0h4l1 3-10 6-16 9-9 7-13 12-10 11-10 14-3 1-2-1 1-4 8-11 11-13 12-11 17-13z"
            fill="#071481"
          />
          <path
            transform="translate(644,1146)"
            d="m0 0h2v13l-16 8-17 8 1-13 4-4z"
            fill="#fff"
          />
          <path
            transform="translate(973,604)"
            d="m0 0 4 4 13 25 12 21 2 6-4-2-11-8-7-10-5-10-3-10z"
            fill="#fff"
          />
          <path
            transform="translate(590,1669)"
            d="m0 0 9 2 16 8 15 8 14 10 14 12 14 14 4 6-1 2-5-2-7-8-4-4v-2l-4-2-10-9-19-13-18-10-13-6h-3z"
            fill="#08167E"
          />
          <path
            transform="translate(948,1121)"
            d="m0 0h1l-1 7-9 15-10 13-11 12-9 9-5 3 2-4 2-3-2 1h-3l6-7 13-14 13-18 6-9 3-1 1-3z"
            fill="#11216D"
          />
          <path
            transform="translate(932,1095)"
            d="m0 0 4 1-2 10-6 11-5 6-6 2-7-4-1-6 4-7 11-9z"
            fill="#fff"
          />
          <path
            transform="translate(645,1124)"
            d="m0 0h2v15l-30 14h-1l1-11 2-5z"
            fill="#fff"
          />
          <path
            transform="translate(305,1354)"
            d="m0 0 8 5 7 10 1 2h18l-3 9v4l10 5 5 6-5-1-7-3-10-1-8 2-2-20-2-5-5-1-3-3v-3l-3-1z"
            fill="#13226A"
          />
          <path
            transform="translate(675,279)"
            d="m0 0h12l-2 5-11 12-10 9-9 6h-2v-12l16-15z"
            fill="#fff"
          />
          <path
            transform="translate(708,879)"
            d="m0 0 4 1 23 11 2 2v15l-5-2-22-12-1-2z"
            fill="#fff"
          />
          <path
            transform="translate(399,681)"
            d="m0 0 5 5 13 11 16 12 17 12 18 13 18 11 19 11 9 5 2 5-14-8-15-9-13-8-17-11-28-19-20-14-13-10-4-3z"
            fill="#12226B"
          />
          <path
            transform="translate(693,1104)"
            d="m0 0 17 8 10 6 3 13v3l-5-2-24-12-1-1z"
            fill="#fff"
          />
          <path
            transform="translate(1054,746)"
            d="m0 0h2l-1 5-11 12-7 8-10 13-11 17-14 25-10 23-9 25-5 16h-1v-8l5-18 6-17 15-30 7-12 11-17 11-15 6-8 7-9 4-6 4-2z"
            fill="#0C1B77"
          />
          <path
            transform="translate(38,1945)"
            d="m0 0 3 1 4 10 6 9 7 7 10 6 8 3 6 1 132 1 3 2h-137l-11-3-11-6-10-9-7-11-3-7z"
            fill="#13205E"
          />
          <path
            transform="translate(849,1229)"
            d="m0 0 4 2 9 12 9 4 13 5 7 4 1 4-3 1-21-9-28-10v-3l-2-1v-2l-5-1v-1l9-2z"
            fill="#12226B"
          />
          <path
            transform="translate(878,290)"
            d="m0 0 5 1 10 5 16 3-3 9-3 10-1 7h-3l-9-15-12-18z"
            fill="#DFD03F"
          />
          <path
            transform="translate(483,978)"
            d="m0 0 3 1 4 9 1 7v8l-4 13-3 6-4 5-4-1 2-17 4-28z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(812,903)"
            d="m0 0h1l-1 14-16 8-12 5-1-1v-11l1-3 24-11z"
            fill="#fff"
          />
          <path
            transform="translate(969,596)"
            d="m0 0 3 4v2h2l1 18 4 12 5 10 7 9 11 8 3 1 3 8-6-2-13-9-7-8-8-14-5-14-1-6v-18z"
            fill="#08157F"
          />
          <path
            transform="translate(251,1146)"
            d="m0 0 5 1 6 7v4l-11 5-14 7h-4l-1-9 3-5 7-6z"
            fill="#fff"
          />
          <path
            transform="translate(808,925)"
            d="m0 0h2l-1 14-5 4-19 9h-2v-15l16-8z"
            fill="#fff"
          />
          <path
            transform="translate(780,382)"
            d="m0 0h21l14 3 13 6 14 8 3 3v3l-5-2-22-11-13-4-5-1h-15l-10 3-10 4-4-1v-2l9-6z"
            fill="#08167E"
          />
          <path
            transform="translate(645,1102)"
            d="m0 0h2v15l-26 13h-1l1-12 2-5 19-9z"
            fill="#fff"
          />
          <path
            transform="translate(867,405)"
            d="m0 0 3 4-6 23-1 7v30l-1 2 1 14-2-2-4-15-1-5v-21l4-20 6-16z"
            fill="#12226B"
          />
          <path
            transform="translate(662,525)"
            d="m0 0 2 4-8 16-6 16 9-3 5-2 2-2 3 1v5h-2v2l-14 5h-6l-11 4-3-1v-3l9-4 5-12 10-21z"
            fill="#08167F"
          />
          <path
            transform="translate(778,279)"
            d="m0 0 9 1 12 13 14 11 8 13 1 4-8-6-10-7-14-12-9-10-3-4z"
            fill="#fff"
          />
          <path
            transform="translate(912,342)"
            d="m0 0 11 3h23l-6 7-8 13-2 4-3-1-9-15-6-9z"
            fill="#DFD03E"
          />
          <path
            transform="translate(708,281)"
            d="m0 0 6 1-4 7-12 14-11 11-18 13-11 6h-5l1-4 13-7 12-9 10-9 11-12z"
            fill="#071580"
          />
          <path
            transform="translate(1188,1250)"
            d="m0 0 2 1-7 7-14 11-13 10-24 18-18 13-16 11-17 11-5 2 5-5 17-12 20-14 15-11h2v-2l6-4h2v-2l16-12 9-8 9-7 6-5z"
            fill="#10206F"
          />
          <path
            transform="translate(551,1227)"
            d="m0 0h3l-2 12-2 3-18 3h-5l-1-12 2-2z"
            fill="#fff"
          />
          <path
            transform="translate(1121,533)"
            d="m0 0 3 1 3 7-1 3-13-2-10-1h-12l-33 2-22 5-15 5-4 1-1 3v-4l4-1 1-3 7-3 7-2 13-4 13-1 4-1h55l1-1z"
            fill="#19286D"
          />
          <path
            transform="translate(713,902)"
            d="m0 0 16 8 7 3 1 2v14l-6-2-16-8-2-7z"
            fill="#fff"
          />
          <path
            transform="translate(809,1466)"
            d="m0 0h3l-1 6-15 33-10 17-7 10h-3v-7l8-11 10-18 12-26z"
            fill="#071580"
          />
          <path
            transform="translate(901,770)"
            d="m0 0 3 1 1 2v12l-7 2-12 2h-5l1-11 1-3 12-4z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(733,557)"
            d="m0 0h20l10 4 4 5 1 4-2 1-11-5-3-1h-18l-12 3h-4l1-5 9-5z"
            fill="#09177D"
          />
          <path
            transform="translate(772,279)"
            d="m0 0 4 1 3 4v2l4 1 10 11 11 9 12 9 6 4 2 4 1 3-6-2-12-8-16-13-8-8-7-8-5-6z"
            fill="#08167E"
          />
          <path
            transform="translate(693,1083)"
            d="m0 0 4 1 19 10 1 2 1 12-5-1-19-9-1-1z"
            fill="#fff"
          />
          <path
            transform="translate(777,1702)"
            d="m0 0h3v4l-18 11-11 9-12 12-8 11-4 1-1-4 10-13 12-12 13-10z"
            fill="#071580"
          />
          <path
            transform="translate(892,452)"
            d="m0 0 3 4 13 24 5 9v2h2l3 10-5-3-10-9-7-12-4-14z"
            fill="#0A177C"
          />
          <path
            transform="translate(650,480)"
            d="m0 0h2l-1 7-7 11-10 15-14 27-4 8-3-2 3-9 8-17 13-22z"
            fill="#071580"
          />
          <path
            transform="translate(804,948)"
            d="m0 0h3l-1 13-3 3-19 8h-1v-13l4-3z"
            fill="#fff"
          />
          <path
            transform="translate(971,435)"
            d="m0 0 5 1 14 3 8 1-6 15-1 8h-3l-10-16-7-10z"
            fill="#DECF3D"
          />
          <path
            transform="translate(1195,887)"
            d="m0 0 5 2 1 1v6l-7 9-9 5h-3l-3-8-3-2 2-4z"
            fill="#fff"
          />
          <path
            transform="translate(830,800)"
            d="m0 0h3l-1 6-7 5-38 19-4-1 1-4h2v-2l20-10 20-11z"
            fill="#08157F"
          />
          <path
            transform="translate(601,1689)"
            d="m0 0 10 4 15 9 18 14 18 18 2 5-1 3-4-2-7-9-4-5-8-7-11-9-14-9-12-6z"
            fill="#09177D"
          />
          <path
            transform="translate(513,762)"
            d="m0 0 5 1 29 14 32 13v4h-4l-1 2-5-1-7-6-17-7-9-5-11-5-8-4-2-4z"
            fill="#08167F"
          />
          <path
            transform="translate(631,1454)"
            d="m0 0 3 1-14 8-12 8-14 10-15 13-16 15-5 5-2 3-2-1 1-5-5 1-1-2 8-7 16-15 2 1-7 8h-2l-1 3h-2l-1 6 15-15 13-10 8-7 18-12z"
            fill="#13226A"
          />
          <path
            transform="translate(902,792)"
            d="m0 0h4l-1 10-6 2-18 4h-6l2-11 7-2z"
            fill="#fff"
          />
          <path
            transform="translate(719,1631)"
            d="m0 0 6 2 15 6 9 2h13l11-3h4l-1 4-10 4-6 1h-13l-16-4-8-4-4-3-1-4z"
            fill="#fff"
          />
          <path
            transform="translate(244,1126)"
            d="m0 0 3 1 3 7 3 4v2l-16 7-5 2-2-2v-9l4-6z"
            fill="#fff"
          />
          <path
            transform="translate(716,926)"
            d="m0 0 5 1 15 7 1 1v15l-6-2-12-6-2-6z"
            fill="#fff"
          />
          <path
            transform="translate(36,1802)"
            d="m0 0h2l1 126 1 18h-3l-1-7z"
            fill="#2E2A33"
          />
          <path
            transform="translate(282,964)"
            d="m0 0 4 1 9 8 1 3-8 10-5-1-9-7-1-4 3-4h2l2-4z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(1143,1052)"
            d="m0 0 5 1 9 7-1 5-8 8-5-1-10-7 2-4z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(663,530)"
            d="m0 0 3 1 3 8-1 5-4 11-5 4-7 3-3-1 6-16z"
            fill="#fff"
          />
          <path
            transform="translate(1097,588)"
            d="m0 0 10 3 6 1v14l-1 2-10 1-7 4-5 1-6 7-1-2 7-8 7-4h2z"
            fill="#13226A"
          />
          <path
            transform="translate(617,577)"
            d="m0 0 9 1v2l-8-1-6 3 3 3 5 2-1 4-5 6-7-2-12-7-8 1 1-3 7-2 16-6z"
            fill="#080405"
          />
          <path
            transform="translate(956,570)"
            d="m0 0 2 3 2 5-4 20v19l1 10h-6l-2-17 1-16 4-18z"
            fill="#12226B"
          />
          <path
            transform="translate(776,1727)"
            d="m0 0h4v10l-10 8-6 5-6 1-6-1 3-5 12-12z"
            fill="#fff"
          />
          <path
            transform="translate(998,1375)"
            d="m0 0 10 1-4 3-23 12-28 15-8 4-3-1 6-5 16-8 3-5 8-4h5l3-3h3v-2z"
            fill="#142265"
          />
          <path
            transform="translate(322,1432)"
            d="m0 0h8l5 1 1 11 1 10-10-3-6-2-3-10h1l2-6z"
            fill="#13236A"
          />
          <path
            transform="translate(906,1172)"
            d="m0 0 3 1-4 5-3 5-15 12-18 12-1-2h-3v-3l10-6 3-1v-3l13-9 11-9 3-1z"
            fill="#08157F"
          />
          <path
            transform="translate(358,802)"
            d="m0 0 5 1 10 7-2 5-7 8-4-1-10-8 2-5z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(294,1401)"
            d="m0 0 5 1 6 7 1 4-4 5-6 4-5-2-6-7 1-4 6-7z"
            fill="#0C0B10"
          />
          <path
            transform="translate(543,1249)"
            d="m0 0h6v7l-2 5-9 3-11 1v-13l1-1z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(668,414)"
            d="m0 0 1 2 5 2 3 3 2 1h11l6-2 5-2 2-2v2l8-1 2 3h-2v2l-18 6h-12l-13-2-3-8h3z"
            fill="#081580"
          />
          <path
            transform="translate(892,280)"
            d="m0 0h30l-3 8-5 4h-11l-6-3-5-6z"
            fill="#DFD13F"
          />
          <path
            transform="translate(944,702)"
            d="m0 0h9l5 5v8l-4 4-9 1-5-4-1-2v-7z"
            fill="#DECE3D"
          />
          <path
            transform="translate(561,683)"
            d="m0 0 7 1 4 4 1 2v6l-5 5-6 1-5-2-3-4v-6l5-6z"
            fill="#DFD13F"
          />
          <path
            transform="translate(886,678)"
            d="m0 0h7l5 5 1 6-3 5-3 2h-9l-4-5v-7l4-5z"
            fill="#DFD03E"
          />
          <path
            transform="translate(483,638)"
            d="m0 0 8 1 5 6-1 7-5 4h-9l-4-5-1-5 3-5z"
            fill="#DECD3D"
          />
          <path
            transform="translate(1135,619)"
            d="m0 0 5 2 7 7-1 4-7 7-5 1-8-8-1-3 8-9z"
            fill="#12193E"
          />
          <path
            transform="translate(754,732)"
            d="m0 0 7 1 4 4 1 6-3 5-2 2h-10l-4-5v-7l4-5z"
            fill="#DECF3D"
          />
          <path
            transform="translate(502,1439)"
            d="m0 0h1v24l-7 16-5 8-3-1-3-7h2l2-5 7-14 3-12 1-8z"
            fill="#13236A"
          />
          <path
            transform="translate(673,383)"
            d="m0 0h17l14 3 10 4 3 3v2l-6-1-15-5-6-1h-13l-12 3-7 1-2-4 7-3z"
            fill="#08167F"
          />
          <path
            transform="translate(645,1084)"
            d="m0 0h2v12l-16 8-5 3h-2v-7l2-6z"
            fill="#fff"
          />
          <path
            transform="translate(645,1064)"
            d="m0 0 3 1v10l-1 2-18 8h-3l1-11 4-4z"
            fill="#fff"
          />
          <path
            transform="translate(545,629)"
            d="m0 0h9l5 6-1 7-5 4h-8l-5-5-1-5 3-5z"
            fill="#DECD3D"
          />
          <path
            transform="translate(677,387)"
            d="m0 0h13l16 4 12 5 1 4h-6l-15-6-9-2h-10l-16 4h-6l1-3 14-5z"
            fill="#fff"
          />
          <path
            transform="translate(694,1183)"
            d="m0 0 19 9 22 11 3 3v4l-5-1-36-18-3-1-1-6z"
            fill="#071580"
          />
          <path
            transform="translate(635,1610)"
            d="m0 0 9 1 8 7 3 6v3l-6 1-6-9-4-2-6 1-3 1-2 5-2 3-4-1 1-7 6-7z"
            fill="#fff"
          />
          <path
            transform="translate(849,729)"
            d="m0 0 8 1 4 4 1 5-1 4h-2v2l-4 2-9-1-3-5v-6l4-5z"
            fill="#DECC3D"
          />
          <path
            transform="translate(654,721)"
            d="m0 0h8l5 5v8l-4 4-7 1-5-2-2-3v-8z"
            fill="#E0D43F"
          />
          <path
            transform="translate(723,1640)"
            d="m0 0 6 1 8 3 10 2h13l12-3 6-2v5l-7 3-12 3h-14l-13-4-6-3v-2l-4-2z"
            fill="#08167E"
          />
          <path
            transform="translate(721,949)"
            d="m0 0 6 2 9 5 2 2v15l-13-5-2-2-2-11z"
            fill="#fff"
          />
          <path
            transform="translate(690,801)"
            d="m0 0 6 1 36 17 4 3v4l-7-1-28-14-10-7z"
            fill="#071580"
          />
          <path
            transform="translate(942,1383)"
            d="m0 0h9l5 5v7l-4 4-9 1-6-6 1-7z"
            fill="#DFD03E"
          />
          <path
            transform="translate(539,1342)"
            d="m0 0h8l5 4v8l-4 4-2 1h-8l-4-4v-9z"
            fill="#DECF3E"
          />
          <path
            transform="translate(772,1301)"
            d="m0 0h8l2 1v2h2l1 2v7l-5 5h-9l-4-4v-9z"
            fill="#DECD3D"
          />
          <path
            transform="translate(826,783)"
            d="m0 0 7 1-3 3-17 9-22 11-5-1 2-5 5-3 10-4 13-7z"
            fill="#08157F"
          />
          <path
            transform="translate(882,1394)"
            d="m0 0h9l5 6-1 7-6 4h-6l-4-2-2-4v-6z"
            fill="#DECE3F"
          />
          <path
            transform="translate(480,1319)"
            d="m0 0h9l5 5-1 7-4 4-2 1h-6l-5-4-1-7 3-5z"
            fill="#E0D43F"
          />
          <path
            transform="translate(798,693)"
            d="m0 0h8l5 6-1 7-5 4-5 1-6-3-2-4 1-7z"
            fill="#DFD33E"
          />
          <path
            transform="translate(710,690)"
            d="m0 0 9 1 4 5-1 7-5 4h-8l-5-5v-7z"
            fill="#DFD23E"
          />
          <path
            transform="translate(670,1467)"
            d="m0 0 18 6h10l11-3h5l-2 5-11 4-13 1-9-2-8-5-2-5z"
            fill="#08167F"
          />
          <path
            transform="translate(624,668)"
            d="m0 0h7l5 5v8l-5 4h-9l-4-4v-8z"
            fill="#DFD13E"
          />
          <path
            transform="translate(714,1331)"
            d="m0 0h7l5 3 1 2v7l-4 4-2 1h-8l-4-4v-8z"
            fill="#DFD03E"
          />
          <path
            transform="translate(1050,463)"
            d="m0 0h7l5 5v7l-5 5-5 1-6-3-2-3v-7l4-4z"
            fill="#DFD03E"
          />
          <path
            transform="translate(673,1287)"
            d="m0 0h10l4 4v8l-4 4-8 1-5-4-1-2v-7z"
            fill="#DFCF3E"
          />
          <path
            transform="translate(694,1142)"
            d="m0 0 7 1 24 12 3 2v6l-11-3-21-11-3-2z"
            fill="#08157F"
          />
          <path
            transform="translate(694,1206)"
            d="m0 0 2 2v22l31 16 11 6 1 4-9-1-9-6-22-12-4-1-1-3z"
            fill="#09177D"
          />
          <path
            transform="translate(524,747)"
            d="m0 0 10 1 7 3 9 3 25 10v2l5 2 5 5-5-1-21-8-33-15z"
            fill="#13205F"
          />
          <path
            transform="translate(781,408)"
            d="m0 0 4 1 6 7 7 1 5-3 4-6h5l1 4-4 6-6 5-4 1h-7l-7-3-4-9z"
            fill="#fff"
          />
          <path
            transform="translate(531,1714)"
            d="m0 0h2l9 16 6 9v3l-5-2-12-4-6-1 2-6 3-8z"
            fill="#DECE3E"
          />
          <path
            transform="translate(682,287)"
            d="m0 0h6l-2 4-3 5-7 7-17 13-7 1 2-5 8-7 10-8z"
            fill="#071481"
          />
          <path
            transform="translate(804,1354)"
            d="m0 0 8 1 4 4v6l-4 5-8 1-5-3-2-3 1-7z"
            fill="#DECE3D"
          />
          <path
            transform="translate(628,1329)"
            d="m0 0h8l5 4v8l-6 5h-6l-5-4-1-2v-6z"
            fill="#DFD23E"
          />
          <path
            transform="translate(1066,1216)"
            d="m0 0 9 5 3 2-1 6-7 7-6-2-7-5 1-4 6-8z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(472,636)"
            d="m0 0 2 1-3 3-5 3-2 2-10 4-3 3-5 4-8 3-4 3h-2v2l-7 4-8 3-5 3v-2h2l2-4 3-3 4-3 22-12z"
            fill="#132267"
          />
          <path
            transform="translate(811,609)"
            d="m0 0h8v1l-30 5h-30l-12-1-12-3v-1h59z"
            fill="#1A245C"
          />
          <path
            transform="translate(867,1336)"
            d="m0 0h7l5 4 1 5-3 5-5 3-7-1-4-5v-6z"
            fill="#DFD23E"
          />
          <path
            transform="translate(801,971)"
            d="m0 0 2 1-1 12-16 7h-4v-9l1-3z"
            fill="#fff"
          />
          <path
            transform="translate(575,1292)"
            d="m0 0h10l3 3 1 6-3 5-3 2h-7l-5-4-1-6 3-5z"
            fill="#DFD13E"
          />
          <path
            transform="translate(877,1193)"
            d="m0 0 1 2-11 7h-2v3h3l-2 4-12 7-7 1-7 5-5 1-2-3 4-4 22-12z"
            fill="#0B1979"
          />
          <path
            transform="translate(704,781)"
            d="m0 0 19 2 12 2v14l-32-16z"
            fill="#fff"
          />
          <path
            transform="translate(878,425)"
            d="m0 0 2 3 4 7h-2v32l-3 3h-2l-2-8v-25z"
            fill="#12226A"
          />
          <path
            transform="translate(945,393)"
            d="m0 0 20 3 2 1-3 9-2 12h-2l-9-14-6-9z"
            fill="#DFCF3E"
          />
          <path
            transform="translate(780,415)"
            d="m0 0 3 4v2l9 2h12l5 1 3-1 2-3 9-2 5 1v2l-13 6-9 2-17-1-5-1v-2l-6-1 1-7z"
            fill="#08167E"
          />
          <path
            transform="translate(746,1612)"
            d="m0 0h7l6 3 6 9v3h-5l-4-5-4-2-6 1-5 7h-5l1-8 6-7z"
            fill="#fff"
          />
          <path
            transform="translate(692,1064)"
            d="m0 0 5 2 14 9 2 2 1 9-9-3-12-6-1-3z"
            fill="#fff"
          />
          <path
            transform="translate(696,826)"
            d="m0 0h7l27 14 6 4v3l-4 1-33-16z"
            fill="#08157F"
          />
          <path
            transform="translate(583,1640)"
            d="m0 0 9 3 18 9v2l5 2 2 1-1 5-5-1-14-6-14-10z"
            fill="#081580"
          />
          <path
            transform="translate(812,785)"
            d="m0 0v3l-21 12-5 2v-15l1-1z"
            fill="#fff"
          />
          <path
            transform="translate(1179,894)"
            d="m0 0 2 1-5 5 4 2 2 4v4l2 1-18 3-3 1-2-3v-8l6-2 3-2h4l2-4z"
            fill="#13236B"
          />
          <path
            transform="translate(818,852)"
            d="m0 0 5 1-1 4h-2v2l-25 12-4 2h-6v-3l8-5h2v-2z"
            fill="#071580"
          />
          <path
            transform="translate(671,406)"
            d="m0 0h5l3 8 3 3 5 1 5-3 5-8 4-1 1 3-4 8-6 5-2 1h-11l-5-3-4-8v-5z"
            fill="#fff"
          />
          <path
            transform="translate(995,372)"
            d="m0 0h6l5 4 1 6-2 4-7 3-5-1-4-5 1-8z"
            fill="#DFD03E"
          />
          <path
            transform="translate(931,279)"
            d="m0 0h8l5 3 1 6-2 4-7 3-5-1-4-3-1-6 3-5z"
            fill="#DECB3D"
          />
          <path
            transform="translate(1194,688)"
            d="m0 0 2 4 2 14v22l-3 16-3 9h-2l2-16 2-9v-13l-2-9-1-4 1-1v-8l-2-1z"
            fill="#16256B"
          />
          <path
            transform="translate(613,1711)"
            d="m0 0 8 5 11 9 12 11 9 11v2h-4v-2l-4-1-11-12-14-13-3-1-4-7z"
            fill="#09167E"
          />
          <path
            transform="translate(381,1556)"
            d="m0 0 6 1 4 5-1 6-4 4-7 1-5-4-1-7 4-5z"
            fill="#DECC3D"
          />
          <path
            transform="translate(473,1384)"
            d="m0 0 4 4 7 15 4 13 1 5v13l-1 6-2-2-1-6 1-8-1-4h-2l-1-8-3-1-6-15-4-7 4 2 2 3v3l2-1-2-6z"
            fill="#12226B"
          />
          <path
            transform="translate(822,829)"
            d="m0 0h5l-1 5-23 11-15 7h-5l1-3h2v-2z"
            fill="#071481"
          />
          <path
            transform="translate(648,512)"
            d="m0 0 4 1-2 9-6 10-12 24-1-2-3 1 1-6 17-34z"
            fill="#071580"
          />
          <path
            transform="translate(452,1102)"
            d="m0 0h1v11l-5 29-2 8-3-4 1-5-1-1-1 7-2-2 2-12 3-12 4-9h2v-8z"
            fill="#12226C"
          />
          <path
            transform="translate(871,814)"
            d="m0 0h1v7l-16 65-4 17-2-3 1-9 17-68z"
            fill="#0D0B0E"
          />
          <path
            transform="translate(684,1488)"
            d="m0 0h14l9 3 4 3v3l-9-1-4-1h-10l-6 1h-10l1-4z"
            fill="#08167E"
          />
          <path
            transform="translate(640,1209)"
            d="m0 0h6v5l-8 5-10 5-9 3-5 1-2-2 3-3 6-3 3-3z"
            fill="#071580"
          />
          <path
            transform="translate(1066,731)"
            d="m0 0 8 1 5 2v1l-8 1 1 8 6 11 11 14 6 7-4-2-11-8-8-11-5-10-1-3z"
            fill="#050407"
          />
          <path
            transform="translate(696,1235)"
            d="m0 0 16 8 8 6v2h-11l-11-1-2-1-1-5v-8z"
            fill="#fff"
          />
          <path
            transform="translate(817,873)"
            d="m0 0h2v5l-5 2v2l-27 12-4-1 2-5 27-13z"
            fill="#08157F"
          />
          <path
            transform="translate(1190,856)"
            d="m0 0 2 1 2 5-1 4-19 11-7 1-1-4h-2v-2l-5-1 1-3h5l3 2 7-1 8-4 5-6z"
            fill="#071580"
          />
          <path
            transform="translate(434,1645)"
            d="m0 0 8 1 4 6-2 6-6 4-7-2-2-3v-7z"
            fill="#DECC3D"
          />
          <path
            transform="translate(628,1608)"
            d="m0 0h20v2l9 2 1 3-6 4-8-7-9-1-7 3-4 5-3 1-3-3v-2h-5l1-3 9-3z"
            fill="#071481"
          />
          <path
            transform="translate(735,785)"
            d="m0 0h1l1 15 1 39 1 13v28l-1 6h-1l-1-17-2-1 3-3-3-1h2l-1-14-1-3h2v-3l-2-1v-17h2l-1-4z"
            fill="#132369"
          />
          <path
            transform="translate(628,1586)"
            d="m0 0 9 1 15 8 7 5 3 5-1 3-7-3-14-9-11-7z"
            fill="#08157F"
          />
          <path
            transform="translate(522,1545)"
            d="m0 0 7 4 8 10 5 12 3 15-3-3-16-29-4-7z"
            fill="#fff"
          />
          <path
            transform="translate(618,1720)"
            d="m0 0 4 2 15 14 10 11 1 3-4 1-4-2-6-7-8-7-8-14z"
            fill="#fff"
          />
          <path
            transform="translate(695,781)"
            d="m0 0 7 1 31 15 2 2v4l-9-3-28-14v-2l-3-1z"
            fill="#08157F"
          />
          <path
            transform="translate(687,1424)"
            d="m0 0h19l12 2h13l29 7 12 4-2 2-11-4h-8l-30-6-15-2-18-1z"
            fill="#111A4D"
          />
          <path
            transform="translate(83,45)"
            d="m0 0h55v1l-45 1-16 2-13 5-9 7-7 8-5 10-3 1 1-5 6-10 5-6 8-6 12-6z"
            fill="#21264D"
          />
          <path
            transform="translate(641,1185)"
            d="m0 0h5v4h-2v2l-19 10-12 4v-2l-2-1 8-5h2v-2z"
            fill="#071580"
          />
          <path
            transform="translate(1346,45)"
            d="m0 0 13 1 12 5 9 6 7 7 8 13 3 11v11h-1l-1-7h-1l-3-13-8-13-9-9-14-7-17-3z"
            fill="#27283F"
          />
          <path
            transform="translate(644,1046)"
            d="m0 0h4v10l-5 3-11 5h-2l1-10 2-3z"
            fill="#fff"
          />
          <path
            transform="translate(752,543)"
            d="m0 0h12l-2 4-9 4h-14l-10-3-2-3z"
            fill="#12216C"
          />
          <path
            transform="translate(692,1058)"
            d="m0 0 7 2 14 8 6 5 3 2v3l-9-2-10-5-11-7z"
            fill="#09167C"
          />
          <path
            transform="translate(718,619)"
            d="m0 0 14 2 1 1-1 11-11-1-5-1 1-11z"
            fill="#0A0709"
          />
          <path
            transform="translate(1173,607)"
            d="m0 0 16 1 3 2 1 5 3 5 1 15-5 8-2 2h-3v2l-4 2-14 1-6-2 3-1 8 1 10-3 8-7 2-6-1-9-6-9-10-5z"
            fill="#0C070C"
          />
          <path
            transform="translate(586,1021)"
            d="m0 0 6 1-2 1-3 11-8 19-9 17-9 11-3 2 2-5 7-10 6-10 9-21z"
            fill="#080709"
          />
          <path
            transform="translate(809,918)"
            d="m0 0h3l-1 6-16 8-13 6v-6l5-4z"
            fill="#071580"
          />
          <path
            transform="translate(693,1121)"
            d="m0 0 7 1 20 10 4 3v5l-5-1-25-13z"
            fill="#071481"
          />
          <path
            transform="translate(443,718)"
            d="m0 0 4 1 17 12 20 13 21 12 9 5 2 5-14-8-15-9-13-8-17-11-13-9z"
            fill="#101F70"
          />
          <path
            transform="translate(649,601)"
            d="m0 0 5 1 8 3-1 7-2 5-9-2-5-2 1-5z"
            fill="#0A0607"
          />
          <path
            transform="translate(957 1e3)"
            d="m0 0 3 1-2 23-2 10-1 11-3 9-2-3 1-13 4-28v-8z"
            fill="#07060A"
          />
          <path
            transform="translate(812,897)"
            d="m0 0h4l-2 5-2 2-10 4-16 7h-2l-1 10h-1v-11l1-3h3v-2z"
            fill="#071481"
          />
          <path
            transform="translate(627,593)"
            d="m0 0 7 1 6 3 1 3-4 9-5-1-8-4-1-2 3-5z"
            fill="#070609"
          />
          <path
            transform="translate(858,1243)"
            d="m0 0 10 3 16 6 7 4 1 4-3 1-21-9-11-4-2-4z"
            fill="#071580"
          />
          <path
            transform="translate(703,850)"
            d="m0 0 7 1 22 11 5 3-1 3-7-1-22-10-5-6z"
            fill="#08157F"
          />
          <path
            transform="translate(1157,802)"
            d="m0 0h6l3 4-2 5-9 3-7-1-3-2v-4l8-4z"
            fill="#fff"
          />
          <path
            transform="translate(692,1098)"
            d="m0 0 6 1 17 8v2l4 1v5l-9-2-17-9-1-1z"
            fill="#071480"
          />
          <path
            transform="translate(579,791)"
            d="m0 0 9 2-2 4 2 2 4 1-1 3-10 5-10-11 3-1 1-3 4 1z"
            fill="#13226A"
          />
          <path
            transform="translate(274,1224)"
            d="m0 0h7l4 3-2 4-10 6-5 1-3-3v-5l5-4z"
            fill="#fff"
          />
          <path
            transform="translate(779,1721)"
            d="m0 0 1 4-14 10-15 15h-4l2-5 7-8 11-9z"
            fill="#071580"
          />
          <path
            transform="translate(671,609)"
            d="m0 0 11 2 3 1-1 8-1 4-11-2-3-2 1-8z"
            fill="#070608"
          />
          <path
            transform="translate(930,577)"
            d="m0 0h3v8l-3 21-6-2-6-9v-2l10-5h2z"
            fill="#090406"
          />
          <path
            transform="translate(662,525)"
            d="m0 0 2 4-8 16-5 12-6 3 1-6 8-18 5-8z"
            fill="#071580"
          />
          <path
            transform="translate(824,373)"
            d="m0 0h6l14 10 5 6v2l-6-1-7-3-3-3-8-5-1-1z"
            fill="#071580"
          />
          <path
            transform="translate(557,1571)"
            d="m0 0 3 1 1 5 2-2v12l-3 16-2 6h-2l-3-6 3-10 1-7z"
            fill="#13236B"
          />
          <path
            transform="translate(521,1743)"
            d="m0 0h7l9 3 4 4v2h-25l1-5z"
            fill="#DFD23E"
          />
          <path
            transform="translate(474,1623)"
            d="m0 0 4 5 8 12v3l-5-1-14-3 2-5z"
            fill="#DECC3F"
          />
          <path
            transform="translate(694,615)"
            d="m0 0 9 1 5 1-1 9-2 3-13-3 1-9z"
            fill="#090607"
          />
          <path
            transform="translate(846,616)"
            d="m0 0 3 2 1 10-8 2h-6l-2-11z"
            fill="#090608"
          />
          <path
            transform="translate(778,1475)"
            d="m0 0h4l-3 10-9 16-2 3h-2l-1-7 8-15 3-5z"
            fill="#fff"
          />
          <path
            transform="translate(632,1030)"
            d="m0 0h5l1 1 9 1 4 2v3l-2 1v5l-9 6-7 1-1-3 3-1v-2l7-3h3l-3-3v-3l-6-1-4-2z"
            fill="#09167E"
          />
          <path
            transform="translate(594,1408)"
            d="m0 0h4l1 10-2 2-5 1h-8l-1-10 5-2z"
            fill="#090608"
          />
          <path
            transform="translate(705,1405)"
            d="m0 0 13 1 1 4-1 7-5 1-8-1-1-1v-10z"
            fill="#0B0709"
          />
          <path
            transform="translate(1397,1915)"
            d="m0 0h1v27l-4 13-7 11-9 9-10 6h-7l3-2 13-7 7-7 8-14 3-11 1-7z"
            fill="#28283D"
          />
          <path
            transform="translate(633,1403)"
            d="m0 0h13l1 2-1 9-2 1h-12v-11z"
            fill="#07070C"
          />
          <path
            transform="translate(613,1405)"
            d="m0 0h10l1 10-1 1-14 1-1-10z"
            fill="#090609"
          />
          <path
            transform="translate(764,624)"
            d="m0 0h13l1 1v11h-11l-3-1z"
            fill="#09070A"
          />
          <path
            transform="translate(741,622)"
            d="m0 0 12 1 1 1v11h-8l-6-1v-11z"
            fill="#0D070A"
          />
          <path
            transform="translate(417,1533)"
            d="m0 0 4 4 6 11 2 5-18-4 2-5 3-10z"
            fill="#DECA3E"
          />
          <path
            transform="translate(643,1140)"
            d="m0 0h3v5l-8 5-14 6h-5l1-4 6-2v-2z"
            fill="#08167E"
          />
          <path
            transform="translate(255,1135)"
            d="m0 0h5v9l-9 1v2l-16 8 2-7 2-3 12-5h2l1-4z"
            fill="#061482"
          />
          <path
            transform="translate(569,1413)"
            d="m0 0h5l3 9-1 3-8 2h-5l-1-12z"
            fill="#0A0709"
          />
          <path
            transform="translate(807,940)"
            d="m0 0h2l-1 6-10 6-16 8v-6l3-1v-2l21-10z"
            fill="#071581"
          />
          <path
            transform="translate(819,621)"
            d="m0 0 5 1 1 10-1 1-13 1-1-1v-10z"
            fill="#0C0608"
          />
          <path
            transform="translate(680,1403)"
            d="m0 0h11l2 1v9l-1 2h-11l-2-1v-10z"
            fill="#130A0B"
          />
          <path
            transform="translate(643,1118)"
            d="m0 0h3v6l-19 10-6 1 1-4 5-5z"
            fill="#09167D"
          />
          <path
            transform="translate(1151,798)"
            d="m0 0h5l-2 1v2h-2l1 3-6 3h-2l1 5-4 2 2 3-4-2-5-5-1-7 3-1h7v-2z"
            fill="#1D2C71"
          />
          <path
            transform="translate(790,623)"
            d="m0 0h10l1 1v10l-3 1h-10l-1-1v-10z"
            fill="#0B0709"
          />
          <path
            transform="translate(491 1e3)"
            d="m0 0 2 1-1 11-2 7-9 10-4 4h-3v-8l1-5 2 4 4-1 4-6 4-11z"
            fill="#0C0F22"
          />
          <path
            transform="translate(1e3 483)"
            d="m0 0 18 4-2 6-1 10h-3l-9-14z"
            fill="#DECC3E"
          />
          <path
            transform="translate(752,1414)"
            d="m0 0 9 1 5 2-2 10-9-1-5-2 1-8z"
            fill="#0A0608"
          />
          <path
            transform="translate(859,1110)"
            d="m0 0 5 1 5 4 9 11 7 8v2h2l7 8 2 4-4-2-10-9-10-11-10-13z"
            fill="#0A080B"
          />
          <path
            transform="translate(797,1429)"
            d="m0 0 6 1 7 3 1 2-4 8-6-1-8-4 2-5z"
            fill="#070608"
          />
          <path
            transform="translate(707,874)"
            d="m0 0 7 1 21 10 2 3-1 3-9-3-16-8-4-4z"
            fill="#081580"
          />
          <path
            transform="translate(887,606)"
            d="m0 0h4l3 10-10 4-4-1-2-10z"
            fill="#0B0608"
          />
          <path
            transform="translate(907,599)"
            d="m0 0h3l5 8v2l-10 4h-4l-3-10z"
            fill="#080507"
          />
          <path
            transform="translate(492,1741)"
            d="m0 0h7l5 5 1 5h-20l2-5z"
            fill="#DECE3D"
          />
          <path
            transform="translate(776,1420)"
            d="m0 0 12 4-1 5-2 5-8-1-5-3 1-5z"
            fill="#07060A"
          />
          <path
            transform="translate(656,1403)"
            d="m0 0h13l1 1v10h-13l-1-1z"
            fill="#08060A"
          />
          <path
            transform="translate(868,611)"
            d="m0 0 2 1 2 6-1 5-12 2-2-6 1-5z"
            fill="#0B0608"
          />
          <path
            transform="translate(801,964)"
            d="m0 0h4l-1 5-3 1v2l-16 7h-3v-5l4-2 3-3z"
            fill="#081580"
          />
          <path
            transform="translate(790,278)"
            d="m0 0 4 2v2l4 2 9 10 4 4 1 5-4-2-11-9-7-7-3-4v-2z"
            fill="#0A187E"
          />
          <path
            transform="translate(821,1440)"
            d="m0 0 9 3 9 5-2 2-6 3h-6l-7-5 2-6z"
            fill="#050406"
          />
          <path
            transform="translate(1178,838)"
            d="m0 0h2l-1 4 4 1-5 5-11 8h-5l-2-8 9-2 7-5z"
            fill="#071481"
          />
          <path
            transform="translate(769,428)"
            d="m0 0 6 2v2l7 1 15 10 4 3v3l-5-1-20-12-7-4-1-3z"
            fill="#08167E"
          />
          <path
            transform="translate(550,1419)"
            d="m0 0h4l3 10-12 4h-2l-2-10z"
            fill="#0B0608"
          />
          <path
            transform="translate(665,1214)"
            d="m0 0h11l1 1v10l-1 1h-8l-4-1v-10z"
            fill="#0E0B0E"
          />
          <path
            transform="translate(729,1409)"
            d="m0 0 11 1 2 1-1 10-2 1-11-3-1-5z"
            fill="#0C080A"
          />
          <path
            transform="translate(558,1435)"
            d="m0 0 3 1 2 2-36 12-5 1v-4l22-8z"
            fill="#110D1B"
          />
          <path
            transform="translate(530,1426)"
            d="m0 0h4l2 6v5l-11 3-4-8 1-3z"
            fill="#080608"
          />
          <path
            transform="translate(1160,663)"
            d="m0 0 1 2-3 7-6 5-9 4-4 3-6-1v10h-1l-2-10-4-2v-5l9 2 9-1 7-3 5-4z"
            fill="#230D10"
          />
          <path
            transform="translate(451,1350)"
            d="m0 0 6 2 10 7 10 8 12 11 1 7v2l-3-1-7-10-9-10-10-9-10-6z"
            fill="#0B197A"
          />
          <path
            transform="translate(692,1077)"
            d="m0 0 9 3 11 5v2l4 1v5l-6-1-14-8-4-3z"
            fill="#071580"
          />
          <path
            transform="translate(643,1097)"
            d="m0 0h4l-1 5-10 6-8 4h-5l1-4h2l1-3z"
            fill="#081580"
          />
          <path
            transform="translate(538,948)"
            d="m0 0 4 2v4l-12 4-12 5-4-1v-3z"
            fill="#08167F"
          />
          <path
            transform="translate(753,812)"
            d="m0 0h14v10h-14z"
            fill="#070507"
          />
          <path
            transform="translate(753,793)"
            d="m0 0h14v10h-14z"
            fill="#04040A"
          />
          <path
            transform="translate(255,1160)"
            d="m0 0h6l3 6-10 2-9 6-2-1-3-3v-2l12-7z"
            fill="#071481"
          />
          <path
            transform="translate(513,1033)"
            d="m0 0 6 2 17 9v7l-7-2-13-10-4-4z"
            fill="#08167E"
          />
          <path
            transform="translate(712,897)"
            d="m0 0 6 2 3 2 9 3 7 5v3h-6l-17-9v-2h-2l-1-3z"
            fill="#08157F"
          />
          <path
            transform="translate(757,883)"
            d="m0 0h10v10h-14v-9z"
            fill="#09080A"
          />
          <path
            transform="translate(757,848)"
            d="m0 0h10v10h-14v-9z"
            fill="#0A080A"
          />
          <path
            transform="translate(1148,847)"
            d="m0 0 7 1 3 4-5 4-5 2-6-1-2-2 1-5z"
            fill="#fff"
          />
          <path
            transform="translate(796,1224)"
            d="m0 0h6l9 3v3l8 1-1 3-10-1-18-5 4-3z"
            fill="#08167F"
          />
          <path
            transform="translate(1097,785)"
            d="m0 0 5 2 6 4v2l-6 6h-5l-5-3 1-5z"
            fill="#fff"
          />
          <path
            transform="translate(318,1441)"
            d="m0 0 3 4v7l-3 6-5 5-8 4h-8l-2-1v-2l11-2 8-6 3-6z"
            fill="#1F0F19"
          />
          <path
            transform="translate(1026,1341)"
            d="m0 0 4 2 8 8 7 3-3 3-13 5-5 3-3-1 1-3 12-8-1-4-7-7z"
            fill="#0A187B"
          />
          <path
            transform="translate(374,1292)"
            d="m0 0 4 1 4 9 6 8 5 8v3h-5l-9-17-4-5-3-6z"
            fill="#061482"
          />
          <path
            transform="translate(753,968)"
            d="m0 0h14v10l-14-1z"
            fill="#070609"
          />
          <path
            transform="translate(712,426)"
            d="m0 0 4 2-2 5-10 9-7 4-4-1 5-5z"
            fill="#071580"
          />
          <path
            transform="translate(665,1180)"
            d="m0 0h12v9l-1 1h-11l-1-1v-8z"
            fill="#170B0E"
          />
          <path
            transform="translate(798,990)"
            d="m0 0h1v15l-15-6 2-4z"
            fill="#fff"
          />
          <path
            transform="translate(482,970)"
            d="m0 0 3 1 3 9 4 8v8l-2-1-2-10-3-6-2-1-2 16-2 3-1-2v-12z"
            fill="#09080A"
          />
          <path
            transform="translate(958,928)"
            d="m0 0h4l1 2v13l-2 4-3-1-4-11 1-5z"
            fill="#fff"
          />
          <path
            transform="translate(753,867)"
            d="m0 0h14v9h-14z"
            fill="#030204"
          />
          <path
            transform="translate(753,832)"
            d="m0 0h14v9h-12l-2-1z"
            fill="#080507"
          />
          <path
            transform="translate(893,787)"
            d="m0 0h12l1 5-22 4h-6l4-4 7-1v-2h4z"
            fill="#132369"
          />
          <path
            transform="translate(833,777)"
            d="m0 0h9v1l-19 4-13 1-14-1-10-1v-1l36-2z"
            fill="#1A0A0A"
          />
          <path
            transform="translate(654,1109)"
            d="m0 0h1v77l-1 10-2 1v-13l1-22z"
            fill="#020102"
          />
          <path
            transform="translate(670,1197)"
            d="m0 0h6l1 1v9h-12l-1-1v-8z"
            fill="#11080A"
          />
          <path
            transform="translate(757,917)"
            d="m0 0h10v9h-14v-8z"
            fill="#070406"
          />
          <path
            transform="translate(991,846)"
            d="m0 0 1 3-9 25-5 16h-1v-8l5-18 5-13h2l1-4z"
            fill="#0A187A"
          />
          <path
            transform="translate(666,1233)"
            d="m0 0 11 1v9h-12l-1-1v-8z"
            fill="#0C0B0E"
          />
          <path
            transform="translate(665,1144)"
            d="m0 0h11l1 4-1 6h-11l-1-1v-8z"
            fill="#140A0D"
          />
          <path
            transform="translate(665,1057)"
            d="m0 0h10l2 1v9h-12l-1-9z"
            fill="#0A080A"
          />
          <path
            transform="translate(611,931)"
            d="m0 0 13 1 7 2v1l-10 1-2 1-29-1v-1l12-1 1-2z"
            fill="#090914"
          />
          <path
            transform="translate(285,1178)"
            d="m0 0 5 2 1 5-3 3-8 1-4-2 1-5z"
            fill="#fff"
          />
          <path
            transform="translate(267,1140)"
            d="m0 0h6l3 4-1 4-5 3-5-1-4-5 1-3z"
            fill="#fff"
          />
          <path
            transform="translate(760,900)"
            d="m0 0h7v9h-14v-8z"
            fill="#0D080A"
          />
          <path
            transform="translate(1016,816)"
            d="m0 0h2v2h2l-1 4-8 15-2 1v-4l-5 10h-2l2-6 10-19z"
            fill="#0D1C75"
          />
          <path
            transform="translate(544,1564)"
            d="m0 0 2 3 3 14v8l-2 3-3-4-1-7-2-12z"
            fill="#11206E"
          />
          <path
            transform="translate(715,920)"
            d="m0 0 6 1 14 7 3 2v3l-11-2-9-5-3-3z"
            fill="#08157F"
          />
          <path
            transform="translate(944,548)"
            d="m0 0 3 4v3l2 1h-2l-1 5-5 11-2 1-2-1 1-8z"
            fill="#0B1978"
          />
          <path
            transform="translate(37,1883)"
            d="m0 0h1l1 45 1 18h-3l-1-7v-32z"
            fill="#252742"
          />
          <path
            transform="translate(644,1239)"
            d="m0 0h2v10h-20l3-3z"
            fill="#fff"
          />
          <path
            transform="translate(260,1182)"
            d="m0 0h12v4h-8l-5 5-4 3-5-1v-3l7-6z"
            fill="#071481"
          />
          <path
            transform="translate(666,1162)"
            d="m0 0h10l1 8-1 2h-12v-9z"
            fill="#070608"
          />
          <path
            transform="translate(667,1127)"
            d="m0 0h9l1 1v8l-11 1-2-1v-8z"
            fill="#100A0C"
          />
          <path
            transform="translate(665,1110)"
            d="m0 0h12v8l-1 1h-11l-1-1v-7z"
            fill="#120B0E"
          />
          <path
            transform="translate(669,279)"
            d="m0 0 4 2-13 13-7 3-1-3 4-5 8-7z"
            fill="#08167E"
          />
          <path
            transform="translate(643,1160)"
            d="m0 0h3v5l-17 8h-6l1-4z"
            fill="#071481"
          />
          <path
            transform="translate(665,1076)"
            d="m0 0h12v9l-3 1-9-1-1-8z"
            fill="#080507"
          />
          <path
            transform="translate(886,1010)"
            d="m0 0 9 2 10 3 3 2v2l4 1v2l-9-2-15-4-3-2z"
            fill="#08167F"
          />
          <path
            transform="translate(753,936)"
            d="m0 0h14v8h-14z"
            fill="#080608"
          />
          <path
            transform="translate(333,1235)"
            d="m0 0 6 2 1 4-5 8-5-1-3-3 2-4z"
            fill="#fff"
          />
          <path
            transform="translate(520,1016)"
            d="m0 0 10 1 13 4 4 4 2 4-9-3-19-7z"
            fill="#08167E"
          />
          <path
            transform="translate(1150,869)"
            d="m0 0 9 1 3 2-1 4-5 2h-6l-4-3 2-5z"
            fill="#fff"
          />
          <path
            transform="translate(756,952)"
            d="m0 0h11v8h-14v-7z"
            fill="#0A080C"
          />
          <path
            transform="translate(666,1092)"
            d="m0 0h10l1 1v8h-12l-1-8z"
            fill="#0B080A"
          />
          <path
            transform="translate(974,686)"
            d="m0 0 4 2 17 9 15 5 17 2 1-2v4h-11l-17-4-14-6-11-7z"
            fill="#13236A"
          />
          <path
            transform="translate(1358,1981)"
            d="m0 0h7l-3 2-9 2h-26l-30-1v-1l55-1z"
            fill="#1E2554"
          />
          <path
            transform="translate(275,1158)"
            d="m0 0h9l2 5-3 3-8 1-4-3v-4z"
            fill="#fff"
          />
          <path
            transform="translate(259,1123)"
            d="m0 0 4 1 2 3v4l-9 3-5-4 1-4z"
            fill="#fff"
          />
          <path
            transform="translate(523,925)"
            d="m0 0h2l-1 7-11 6-6 4-3-1v-3l15-10z"
            fill="#08157F"
          />
          <path
            transform="translate(851,1210)"
            d="m0 0 6 1-4 2-1 3-6 2-6 4-5 1-2-3 4-4 12-5z"
            fill="#061482"
          />
          <path
            transform="translate(643,1058)"
            d="m0 0h4v5h-2v2l-9 4h-6l1-4 5-4z"
            fill="#08167F"
          />
          <path
            transform="translate(896,988)"
            d="m0 0h6l11 7 7 3 1 3-1 2-5-2-19-10z"
            fill="#08167E"
          />
          <path
            transform="translate(1188,1250)"
            d="m0 0 2 1-7 7-14 11-7 5-2-1 9-8 5-5 9-8z"
            fill="#0A187B"
          />
          <path
            transform="translate(527,998)"
            d="m0 0 22 1h4l2 2-1 2h-21l-8-2 2-1z"
            fill="#051284"
          />
          <path
            transform="translate(858,550)"
            d="m0 0 2 1-13 12-15 11-16 10-2-1 13-9 6-4 3-1v-2l9-6 8-7z"
            fill="#13236B"
          />
          <path
            transform="translate(782,999)"
            d="m0 0 7 1 10 5 4 5-9-1-10-5-2-2z"
            fill="#071580"
          />
          <path
            transform="translate(1161,887)"
            d="m0 0 9 1-1 5-3 3h-8l-2-3 1-4z"
            fill="#fff"
          />
          <path
            transform="translate(799,984)"
            d="m0 0h3l-1 5-12 6-7 1 1-4z"
            fill="#071580"
          />
          <path
            transform="translate(653,279)"
            d="m0 0h11l2 2-8 8-5 3z"
            fill="#fff"
          />
          <path
            transform="translate(77,1982)"
            d="m0 0 60 2v1h-57l-5-1z"
            fill="#282635"
          />
          <path
            transform="translate(467,1420)"
            d="m0 0h1l1 6v12l-2 8-3-4-1-4v-13l1 3h2z"
            fill="#0C1B76"
          />
          <path
            transform="translate(860,1310)"
            d="m0 0 24 10 20 11-2 2-19-10-21-10-4-2z"
            fill="#1A171C"
          />
          <path
            transform="translate(642,1078)"
            d="m0 0h4l1 5-9 4-6 2v-3l-2-1 3-3z"
            fill="#061482"
          />
          <path
            transform="translate(770,1478)"
            d="m0 0 4 1-1 5-6 11-4-1-1-2 6-12z"
            fill="#0F1E72"
          />
          <path
            transform="translate(1168,1264)"
            d="m0 0 2 1-9 8-1 3-20 15h-2l2-4 3-1v-2l16-12z"
            fill="#0F1E71"
          />
          <path
            transform="translate(719,943)"
            d="m0 0 5 1 11 5 3 3v2h-7l-8-4v-2h-3z"
            fill="#08167E"
          />
          <path
            transform="translate(740,1583)"
            d="m0 0 3 1-3 6-7 9-5 1-2 1 2-4 8-11z"
            fill="#08157F"
          />
          <path
            transform="translate(780,415)"
            d="m0 0 3 4v2l9 2 6 4v1h-9l-5-1v-2l-6-1 1-7z"
            fill="#071580"
          />
          <path
            transform="translate(909,1075)"
            d="m0 0h7v3l-13 6h-9l1-3 12-5z"
            fill="#08167E"
          />
          <path
            transform="translate(1053,767)"
            d="m0 0 4 2-9 12h-2v3h-2l-2 4-4 1 2-5 4-5 2-2 2-4z"
            fill="#051285"
          />
          <path
            transform="translate(1195,629)"
            d="m0 0h2v6l-5 8-2 2h-3v2l-4 2-14 1-6-2 3-1 8 1 10-3 8-7z"
            fill="#1C0C0C"
          />
          <path
            transform="translate(1031,528)"
            d="m0 0 6 1 14 2 2 2-13 3-4 1-5-8z"
            fill="#DFD23E"
          />
          <path
            transform="translate(254,1264)"
            d="m0 0 1 2-9 19-6 21h-1v-7l3-12 7-16z"
            fill="#110A0C"
          />
          <path
            transform="translate(825,1232)"
            d="m0 0 7 1 6 3v2l3 1v2l-8-1-10-3v-3z"
            fill="#071580"
          />
          <path
            transform="translate(1175,816)"
            d="m0 0 5 1 7 8 1 6-4-1-1-4h-2l-3-3-4-2z"
            fill="#071481"
          />
          <path
            transform="translate(1054,746)"
            d="m0 0h2l-1 5-11 12-3 4h-2l1-5 7-9 4-4z"
            fill="#09187C"
          />
          <path
            transform="translate(898,1262)"
            d="m0 0 11 1 7 4 1 4-3 1-14-7z"
            fill="#071580"
          />
          <path
            transform="translate(452,1102)"
            d="m0 0h1v11l-2 13-3 2-2-7 2-7 1-2h2v-8z"
            fill="#071481"
          />
          <path
            transform="translate(652,1040)"
            d="m0 0 4 1 12 6 11 6 3 2v2l-5-2-22-11-1 4z"
            fill="#0C0607"
          />
          <path
            transform="translate(898,464)"
            d="m0 0 3 3 13 24-1 2-8-10-6-13z"
            fill="#fff"
          />
          <path
            transform="translate(826,607)"
            d="m0 0h6l-1 3-8 2-18 2h-9v-1l23-4z"
            fill="#111016"
          />
          <path
            transform="translate(734,1610)"
            d="m0 0h10l3 2-6 4-4 2-2 2-1-4h-3l1-5z"
            fill="#061383"
          />
          <path
            transform="translate(765,1479)"
            d="m0 0 4 1-6 11-3-1-3-6v-3z"
            fill="#fff"
          />
          <path
            transform="translate(633,1035)"
            d="m0 0 7 1 5 3v2l-10 4h-3z"
            fill="#fff"
          />
          <path
            transform="translate(480,1401)"
            d="m0 0 2 2 2 6 3 12 1 1 1 12-1 6-2-2-1-6 1-8-1-4h-2l-1-8-2-4-1-6z"
            fill="#051286"
          />
          <path
            transform="translate(755,1262)"
            d="m0 0h9l23 5 5 4-12-2-25-6z"
            fill="#160A0B"
          />
          <path
            transform="translate(577,1052)"
            d="m0 0 1 3-8 15-9 11-3 2 2-5 7-10 9-15z"
            fill="#0B090C"
          />
          <path
            transform="translate(858,871)"
            d="m0 0 1 3-7 29-2-3 1-9 5-18z"
            fill="#0C0A0D"
          />
          <path
            transform="translate(443,718)"
            d="m0 0 4 1 17 12 8 6-3 1-15-10-10-7z"
            fill="#0C1B76"
          />
          <path
            transform="translate(717,778)"
            d="m0 0h6l3 3 5 2v1l-17-1-7-2 4-2z"
            fill="#182366"
          />
          <path
            transform="translate(727,1617)"
            d="m0 0h7l1 2-3 6-4 1-4-2-1-4z"
            fill="#fff"
          />
          <path
            transform="translate(1171,902)"
            d="m0 0h5l2 3-1 4-6 1-5-2-1-3z"
            fill="#fff"
          />
          <path
            transform="translate(927,577)"
            d="m0 0h3l1 3-14 6h-10l3-2z"
            fill="#152363"
          />
          <path
            transform="translate(1132,574)"
            d="m0 0h11l8 4v3l-9-3h-14l-3-2z"
            fill="#141E4F"
          />
          <path
            transform="translate(1033,1359)"
            d="m0 0 3 1-23 14-2-1 3-3 4-1-1-4-3-2 1-2 5 2 5 1z"
            fill="#13236B"
          />
          <path
            transform="translate(1397,1915)"
            d="m0 0h1v27l-4 13h-3l3-10 2-12z"
            fill="#262842"
          />
          <path
            transform="translate(1105,1312)"
            d="m0 0m-1 1 1 3-10 7-17 11-2-1 12-9z"
            fill="#11206E"
          />
          <path
            transform="translate(612,809)"
            d="m0 0 3 1-28 14-7 4-2-1 5-3h2v-2l12-6v-2l6-1z"
            fill="#13236B"
          />
          <path
            transform="translate(874,771)"
            d="m0 0 3 1-3 3-13 2h-16l4-2z"
            fill="#100809"
          />
          <path
            transform="translate(912,967)"
            d="m0 0 3 1v2l8 4 3 4v2h2l1 3-5-2-10-8-4-2z"
            fill="#071581"
          />
          <path
            transform="translate(1129,875)"
            d="m0 0h3v6l-7 10-2 1 1-8 4-8z"
            fill="#08167F"
          />
          <path
            transform="translate(662,408)"
            d="m0 0 4 1 1 2v7h-6l-2-1-1-6z"
            fill="#fff"
          />
          <path
            transform="translate(661,1553)"
            d="m0 0 5 1 2 4 5 3 1 4-2 1-9-6-2-2z"
            fill="#071580"
          />
          <path
            transform="translate(680,1489)"
            d="m0 0h3v2h2l3 4-6 1h-10l1-4z"
            fill="#12226C"
          />
          <path
            transform="translate(877,1193)"
            d="m0 0 1 2-11 7h-2v2l-17 9-7 2 3-3 22-12z"
            fill="#13236A"
          />
          <path
            transform="translate(922,1094)"
            d="m0 0h3l1 5-6 4-4 1-3 2-2-2 5-5z"
            fill="#08167F"
          />
          <path
            transform="translate(1142,812)"
            d="m0 0h6l7 3 1 2-1 2h-9l-5-5z"
            fill="#061482"
          />
          <path
            transform="translate(760,469)"
            d="m0 0 7 1 4 2 3 4v4l-4-1-9-7z"
            fill="#08167F"
          />
          <path
            transform="translate(305,1354)"
            d="m0 0 8 5 7 10-1 2-2-4-5-1-3-3v-3l-3-1z"
            fill="#142264"
          />
          <path
            transform="translate(723,968)"
            d="m0 0 7 1 10 7v3l-10-3-7-6z"
            fill="#061382"
          />
          <path
            transform="translate(1038,765)"
            d="m0 0 2 3-7 8-10 14-4 5v-4l13-18z"
            fill="#0D1C75"
          />
          <path
            transform="translate(811,609)"
            d="m0 0h8v1l-23 4-13-2v-1z"
            fill="#132369"
          />
          <path
            transform="translate(1124,577)"
            d="m0 0h4v2l-8 5-4 7-1 7h-1l-2-8 5-8 5-4z"
            fill="#131228"
          />
          <path
            transform="translate(627,1736)"
            d="m0 0 8 6 6 7-1 3-5-2-6-8z"
            fill="#0C1976"
          />
          <path
            transform="translate(706,408)"
            d="m0 0 6 1 1 4-5 5-4-1-1-3z"
            fill="#fff"
          />
          <path
            transform="translate(1092,612)"
            d="m0 0v3l-6 7-1 3v9l1 6-2-1v-2h-2v-15l8-9z"
            fill="#09070D"
          />
          <path
            transform="translate(942,1058)"
            d="m0 0h2l2 5h4v8l-4 1-3-2z"
            fill="#040409"
          />
          <path
            transform="translate(572,1617)"
            d="m0 0h4l-1 6-5 7-3-1-1-3h2l1-5z"
            fill="#08167E"
          />
          <path
            transform="translate(295,1406)"
            d="m0 0 4 1 2 5-3 3h-5l-2-2 1-5z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(250,1125)"
            d="m0 0h5l-3 2 1 4 5 2 3 1-7 3-2 1-5-7-1-5z"
            fill="#13236B"
          />
          <path
            transform="translate(640,1233)"
            d="m0 0 6 1-1 4-10 3-4-1 3-1v-3z"
            fill="#061383"
          />
          <path
            transform="translate(867,405)"
            d="m0 0 3 4-3 10-3 3-1-3 1-9z"
            fill="#0B1978"
          />
          <path
            transform="translate(588,1614)"
            d="m0 0h7l3 1v6l-6 1-4-3z"
            fill="#071481"
          />
          <path
            transform="translate(753,984)"
            d="m0 0h13l1 1v8l-14-8z"
            fill="#1C0808"
          />
          <path
            transform="translate(899,803)"
            d="m0 0h5v2l-10 4h-8l-2-2 6-2z"
            fill="#0B187A"
          />
          <path
            transform="translate(650,563)"
            d="m0 0m-6 0 5 2-4 3-9 3-3-1v-3z"
            fill="#071482"
          />
          <path
            transform="translate(817,411)"
            d="m0 0 6 1 2 3-4 4-6 1 1-7z"
            fill="#fff"
          />
          <path
            transform="translate(715,1542)"
            d="m0 0 5 2 5 6-1 3-5-2-6-4v-3h2z"
            fill="#051286"
          />
          <path
            transform="translate(916,1268)"
            d="m0 0h2l5 5 12 6-2 1-1 2-16-9z"
            fill="#0A187B"
          />
          <path
            transform="translate(767,1618)"
            d="m0 0h6l3 3-1 4-5 1-3-3-1-4z"
            fill="#fff"
          />
          <path
            transform="translate(1058,760)"
            d="m0 0h6l-4 7-4 2-5-1 6-7z"
            fill="#0D1C75"
          />
          <path
            transform="translate(795,279)"
            d="m0 0 5 1 8 13-1 2-7-7-5-7z"
            fill="#fff"
          />
          <path
            transform="translate(54,1971)"
            d="m0 0 4 1 10 6 9 4v1h-6l-13-7-4-3z"
            fill="#141421"
          />
          <path
            transform="translate(475,1022)"
            d="m0 0 2 4 6-1-2 6-4 4h-3v-8z"
            fill="#07070C"
          />
          <path
            transform="translate(1052,776)"
            d="m0 0v3l-11 13-2 3-6 2 2-5 4-2 5-6h2v-3z"
            fill="#0E1E72"
          />
          <path
            transform="translate(1179,894)"
            d="m0 0 2 1-5 5 3 1-3 2-8 1-2 2-1 2-2-1-1 5h-1v-8l6-2 3-2h4l2-4z"
            fill="#13236A"
          />
          <path
            transform="translate(1135,625)"
            d="m0 0 4 1 2 2-1 4-4 2-4-3 1-5z"
            fill="#BA2A1A"
          />
          <path
            transform="translate(243,1398)"
            d="m0 0 2 1-2 3-1 7 2 9 2 4-5-4-2-4v-10z"
            fill="#260D0D"
          />
          <path
            transform="translate(941,1126)"
            d="m0 0h2l1 3-4 5-3 5-3 3-1-4z"
            fill="#08167E"
          />
          <path
            transform="translate(752,543)"
            d="m0 0h12l-2 4-4 2-4-1-1-1-2-1z"
            fill="#0A187B"
          />
          <path
            transform="translate(284,1359)"
            d="m0 0 2 1-2 4-5 4-4 7h-1l1-8 7-7z"
            fill="#130E1A"
          />
          <path
            transform="translate(611,931)"
            d="m0 0h5l-3 3v1l-5 1h-18v-1l12-1 1-2z"
            fill="#152365"
          />
          <path
            transform="translate(693,1139)"
            d="m0 0 1 2 3 1-3 1-1 4 2 1v15l-1 18h-1l-1-41z"
            fill="#132269"
          />
          <path
            transform="translate(498,1047)"
            d="m0 0 7 6 6 5 3 4-1 3-6-5-7-8-2-2z"
            fill="#09177E"
          />
          <path
            transform="translate(974,686)"
            d="m0 0 4 2 17 9 3 1v2l-5-1-12-6-6-4z"
            fill="#0E1D73"
          />
          <path
            transform="translate(772,611)"
            d="m0 0h11l10 2-4 2h-20v-1l9-1-6-1z"
            fill="#242028"
          />
          <path
            transform="translate(883,517)"
            d="m0 0 1 2 5 2-5 6-1-4v-1h-2l-1 3-4 3-2-1z"
            fill="#13236B"
          />
          <path
            transform="translate(935,952)"
            d="m0 0 2 3 7 11h-3l-9-9 1-3h2z"
            fill="#071580"
          />
          <path
            transform="translate(341,1387)"
            d="m0 0 5 2 5 6-5-1-7-3-5-1 4-2z"
            fill="#17235F"
          />
          <path
            transform="translate(1188,1250)"
            d="m0 0 2 1-7 7-8 6-2-1 7-7 3-4z"
            fill="#08167E"
          />
          <path
            transform="translate(463,1425)"
            d="m0 0 2 3 2 2v8l-1 2 2 1-1 5-3-4-1-4z"
            fill="#142367"
          />
          <path
            transform="translate(856,1190)"
            d="m0 0h2v2l-10 6-6 4-3-1 3-3z"
            fill="#0A080C"
          />
          <path
            transform="translate(1346,45)"
            d="m0 0 13 1 6 2-4 2-17-3z"
            fill="#1F2650"
          />
          <path
            transform="translate(706,1423)"
            d="m0 0h8l12 2-2 2-14-1-4-1z"
            fill="#14090C"
          />
          <path
            transform="translate(896,1058)"
            d="m0 0h10l-3 3-11 2-1-4z"
            fill="#0A187B"
          />
          <path
            transform="translate(900,1036)"
            d="m0 0 4 1-1 3h-14l-1-2z"
            fill="#051286"
          />
          <path
            transform="translate(1190,747)"
            d="m0 0 1 4-1 7-2 4-4 2v-5h2l3-10z"
            fill="#9098B9"
          />
          <path
            transform="translate(1131,630)"
            d="m0 0 6 4 1 5-4 1-4-5z"
            fill="#0C0A0F"
          />
          <path
            transform="translate(873,528)"
            d="m0 0v3l-17 17-4 1 4-5 8-7z"
            fill="#132369"
          />
          <path
            transform="translate(777,1739)"
            d="m0 0 3 1-2 5-9 2-1-2z"
            fill="#08157F"
          />
          <path
            transform="translate(235,1400)"
            d="m0 0 4 1-2 14-2-1-1-10z"
            fill="#08157F"
          />
          <path
            transform="translate(1160,663)"
            d="m0 0 1 2-3 7-6 5-6 2 5-5 5-4z"
            fill="#090405"
          />
          <path
            transform="translate(451,1350)"
            d="m0 0 6 2 10 7 7 5-3 2-10-9-10-6z"
            fill="#0F1E72"
          />
          <path
            transform="translate(273,1186)"
            d="m0 0 8 3-1 3h-8l-1-5z"
            fill="#061383"
          />
          <path
            transform="translate(469,1095)"
            d="m0 0 3 1 2 4-1 5h-5z"
            fill="#fff"
          />
          <path
            transform="translate(735,610)"
            d="m0 0h15l7 2v1h-12l-10-2z"
            fill="#0A0A11"
          />
          <path
            transform="translate(969,596)"
            d="m0 0 3 4v2h2v14l-2-4-2-5-1-7z"
            fill="#13236B"
          />
          <path
            transform="translate(614,1618)"
            d="m0 0h5l1 4-2 3-5-2v-4z"
            fill="#fff"
          />
          <path
            transform="translate(1201,1238)"
            d="m0 0m-1 1m-1 1 1 3-8 7-7 2 5-5z"
            fill="#0E1E72"
          />
          <path
            transform="translate(698,776)"
            d="m0 0h8l11 2v1l-11 1-7-2z"
            fill="#060509"
          />
          <path
            transform="translate(848,551)"
            d="m0 0 2 1-5 5h-2v2l-9 7-3-1 16-13z"
            fill="#142368"
          />
          <path
            transform="translate(83,45)"
            d="m0 0h6l-4 3-11 2-4 1v-3l6-2z"
            fill="#2D2934"
          />
          <path
            transform="translate(44,1960)"
            d="m0 0 4 1 8 9-3 2-8-9z"
            fill="#1C244F"
          />
          <path
            transform="translate(445,1132)"
            d="m0 0 3 4-1 10-2 4-2-6 3-5-2-1z"
            fill="#0E1D74"
          />
          <path
            transform="translate(476 1e3)"
            d="m0 0h3v8l-2 9h-1z"
            fill="#0A090B"
          />
          <path
            transform="translate(1162,906)"
            d="m0 0 7 3 1 3h-4v2l-3 1-1-2z"
            fill="#071580"
          />
          <path
            transform="translate(937,1407)"
            d="m0 0 3 1v2l2 1-13 6-3-1 8-5z"
            fill="#132369"
          />
          <path
            transform="translate(1115,1305)"
            d="m0 0 4 1-12 9h-2l2-4z"
            fill="#0F1E72"
          />
          <path
            transform="translate(775,412)"
            d="m0 0 4 1 1 4-2 2-5-1v-4z"
            fill="#fff"
          />
          <path
            transform="translate(1363,49)"
            d="m0 0 6 1 10 6v2l-4-1-12-7z"
            fill="#12183D"
          />
          <path
            transform="translate(547,1579)"
            d="m0 0 2 2v8l-2 3-3-4z"
            fill="#0C1A78"
          />
          <path
            transform="translate(860,1310)"
            d="m0 0 20 8-3 2-15-7-4-2z"
            fill="#24191E"
          />
          <path
            transform="translate(385,1307)"
            d="m0 0 3 3 5 8v3h-5l-1-3-1-7z"
            fill="#13236B"
          />
          <path
            transform="translate(500,798)"
            d="m0 0 5 1v5l-7 1-1-4z"
            fill="#051286"
          />
          <path
            transform="translate(1051,768)"
            d="m0 0v3l-4 5v3h-3l-1 3h-3l2-4z"
            fill="#132369"
          />
          <path
            transform="translate(1142,630)"
            d="m0 0 3 1-2 4-5 4-1-3v-3z"
            fill="#13205F"
          />
          <path
            transform="translate(649,557)"
            d="m0 0 1 4 2 2-5 2-5-1 2-5z"
            fill="#13236B"
          />
          <path
            transform="translate(755,1432)"
            d="m0 0 11 3 6 2-2 2-11-4h-8l-5-1v-1l9 1z"
            fill="#18132A"
          />
          <path
            transform="translate(254,1264)"
            d="m0 0 1 2-8 17-2-3 7-14z"
            fill="#2E1213"
          />
          <path
            transform="translate(1042,718)"
            d="m0 0h2l8 11v2l-4-2-6-8z"
            fill="#0F1E71"
          />
          <path
            transform="translate(940,563)"
            d="m0 0 2 2v6l-3 2-2-1 1-8z"
            fill="#061482"
          />
          <path
            transform="translate(1391,1955)"
            d="m0 0 2 2-7 10-3 1 2-5z"
            fill="#2B2937"
          />
          <path
            transform="translate(796,1224)"
            d="m0 0h6l1 2-8 3-5-1 4-3z"
            fill="#13236B"
          />
          <path
            transform="translate(577,1052)"
            d="m0 0 1 3-6 11-2-1 2-5 3-6z"
            fill="#0A080B"
          />
          <path
            transform="translate(1194,841)"
            d="m0 0 2 1 1 3v8h-4v-11z"
            fill="#08167E"
          />
          <path
            transform="translate(842,412)"
            d="m0 0h5l2 5-9-1-1-3z"
            fill="#061383"
          />
          <path
            transform="translate(309,1498)"
            d="m0 0h2l4 7 2 5-1 4-7-14z"
            fill="#08167F"
          />
          <path
            transform="translate(502,1439)"
            d="m0 0h1v8l-2 5h-2l1-12z"
            fill="#0F1E72"
          />
          <path
            transform="translate(739,1429)"
            d="m0 0 10 1 6 2v2l-12-2-4-2z"
            fill="#110808"
          />
          <path
            transform="translate(1092,1321)"
            d="m0 0m-1 1 1 3-14 9-2-1 12-9z"
            fill="#13236B"
          />
          <path
            transform="translate(558,1279)"
            d="m0 0 4 1 4 2-15 2 2-4z"
            fill="#171219"
          />
          <path
            transform="translate(657,1616)"
            d="m0 0 5 1v5l-4 1-2-3z"
            fill="#fff"
          />
          <path
            transform="translate(1168,1264)"
            d="m0 0 2 1-9 8-1 3-7 2 5-5z"
            fill="#12226C"
          />
          <path
            transform="translate(979,874)"
            d="m0 0 3 2-3 12-2 2v-8z"
            fill="#0C1B76"
          />
          <path
            transform="translate(1118,583)"
            d="m0 0 1 3-3 5-1 7h-1l-2-8 2-4z"
            fill="#140F14"
          />
          <path
            transform="translate(1379,57)"
            d="m0 0 7 6 1 4-4-2-6-7z"
            fill="#1D2555"
          />
          <path
            transform="translate(386,1286)"
            d="m0 0v3l-4 5h-2l3 7 1 4-3-3-2-3-1-6z"
            fill="#13236B"
          />
          <path
            transform="translate(778,1744)"
            d="m0 0 2 1-1 5h-7l1-3z"
            fill="#fff"
          />
          <path
            transform="translate(485,1412)"
            d="m0 0h2l2 9v11h-1l-1-10-2-5z"
            fill="#152365"
          />
          <path
            transform="translate(311,1138)"
            d="m0 0 3 1-4 7h-3v-5z"
            fill="#08167F"
          />
          <path
            transform="translate(250,1125)"
            d="m0 0h5l-3 2-1 6-4-2-1-5z"
            fill="#0A187B"
          />
          <path
            transform="translate(984,864)"
            d="m0 0 1 4-4 9h-1v-7z"
            fill="#08167E"
          />
          <path
            transform="translate(1162,797)"
            d="m0 0 2 1-1 3-6 2h-5v-2z"
            fill="#061383"
          />
          <path
            transform="translate(472,737)"
            d="m0 0 9 5 6 4-3 1-13-8z"
            fill="#0F1E71"
          />
          <path
            transform="translate(761,1612)"
            d="m0 0 7 1v3l-6 1-3-3z"
            fill="#051286"
          />
          <path
            transform="translate(300,1412)"
            d="m0 0 4 4-6 4-1-3-3-2 5-2z"
            fill="#1C2558"
          />
          <path
            transform="translate(652,1040)"
            d="m0 0 4 1 6 4-1 2-6-3-1 4z"
            fill="#06060A"
          />
          <path
            transform="translate(1177,902)"
            d="m0 0 4 1v6l-6 2v-2l2-1z"
            fill="#071580"
          />
          <path
            transform="translate(860,859)"
            d="m0 0h1v7l-2 5-2 1 1-9z"
            fill="#070608"
          />
          <path
            transform="translate(871,814)"
            d="m0 0h1v7l-2 5-2 1 1-9z"
            fill="#09070A"
          />
          <path
            transform="translate(419,1488)"
            d="m0 0 3 1-13 6h-2l-1-3 8-2z"
            fill="#181720"
          />
          <path
            transform="translate(1156,1276)"
            d="m0 0 2 1-9 7h-2l2-4 4-3z"
            fill="#0C1B77"
          />
          <path
            transform="translate(1160,825)"
            d="m0 0 3 1v2l-4 3h-6v-2l6-3z"
            fill="#09177C"
          />
          <path
            transform="translate(874,771)"
            d="m0 0 3 1-3 3h-9l1-2z"
            fill="#0C0607"
          />
          <path
            transform="translate(54,1971)"
            d="m0 0 4 1 6 4-1 3-9-6z"
            fill="#0E132E"
          />
          <path
            transform="translate(767,1488)"
            d="m0 0 2 1-2 6-4-1v-3z"
            fill="#071581"
          />
          <path
            transform="translate(916,1268)"
            d="m0 0h2l5 5 6 3-3 1-10-4z"
            fill="#12226B"
          />
          <path
            transform="translate(753,1089)"
            d="m0 0 8 1 3 1 1 3-9-2z"
            fill="#09177D"
          />
          <path
            transform="translate(894,456)"
            d="m0 0 4 5 2 9-1 3-5-14z"
            fill="#172461"
          />
          <path
            transform="translate(1126,1297)"
            d="m0 0m-1 1 1 3-7 5-2-2z"
            fill="#11216E"
          />
          <path
            transform="translate(1009,831)"
            d="m0 0v3l-5 10h-2l2-6 3-6z"
            fill="#081580"
          />
          <path
            transform="translate(1016,823)"
            d="m0 0 1 3-7 12-1-2 6-12z"
            fill="#051286"
          />
          <path
            transform="translate(826,607)"
            d="m0 0h6l-1 3-7 1-4-3z"
            fill="#13193B"
          />
          <path
            transform="translate(756,280)"
            d="m0 0h4l1 2v7l-4-5z"
            fill="#071581"
          />
          <path
            transform="translate(1372,1975)"
            d="m0 0m-2 1h2v3l-4 2h-7l3-2z"
            fill="#2A2939"
          />
          <path
            transform="translate(237,1146)"
            d="m0 0 2 1-2 2-1 7h-3v-5-3z"
            fill="#11216E"
          />
          <path
            transform="translate(454,1083)"
            d="m0 0h1v15l-2 1-1-7z"
            fill="#08157F"
          />
          <path
            transform="translate(245,787)"
            d="m0 0m-1 1m-2 1 2 1-6 7-5 2 2-4z"
            fill="#0A187B"
          />
          <path
            transform="translate(829,566)"
            d="m0 0h2v2l-12 8-2-1z"
            fill="#152366"
          />
        </>
      ) : (
        <>
          <path
            transform="translate(0)"
            d="m0 0h1475v2048h-1475z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(0)"
            d="m0 0h1475v2048h-1475zm98 42-14 2-12 5-11 8-7 9-7 14-2 10v1867l2 11 8 16 6 7 13 9 10 4 5 1 1191 1h85l15-1 13-4 11-7 9-9 7-12 3-10 1-9v-1860l-2-14-8-16-12-12-16-8-14-2z"
            fill="#FEFEFE"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            transform="translate(644,853)"
            d="m0 0h17l13 3 12 5 9 6 9 7 5 5 8 10 5 6 10 20h2l8-17 6-8 9-11 11-10 10-7 14-6 14-3h14l16 4 16 7 10 8 6 5 9 11 11 17 6 13 5 18 1 6v18l-3 14-6 15-9 14-9 11-9 10-65 65-9 11-8 10-11 15-11 16-12 20-9 17-5 10-3-3-12-22-11-19-10-15-8-11-10-13-12-14-11-12-64-64-10-13-9-15-6-16-2-9v-20l5-22 7-16 10-16 11-12 8-7 11-7 10-5z"
            fill="#EB3829"
          />
          <path
            transform="translate(98,42)"
            d="m0 0h1274l14 2 16 8 12 12 8 16 2 14v1860l-2 13-5 12-7 9-7 7-10 6-13 4-15 1h-85l-1191-1-13-4-11-7-5-5-7-8-6-13-2-11v-1867l2-10 8-16 7-8 10-7 12-5zm-6 3-12 3-11 6-9 8-8 13-3 8-1 6v1868l2 11 6 12 9 10 9 7 9 4 14 2h1274l14-2 9-4 9-6 8-8 6-11 3-10 1-8v-1862l-2-11-4-9-6-9-9-9-14-7-10-2z"
            fill="#414141"
          />
          <path
            transform="translate(46,425)"
            d="m0 0h1l1 1523 3 20 6 12 9 10 10 7 11 4 10 1h1274l14-2 9-4 9-6 7-7 6-11 3-10 1-8 1-1 1-12h1v22l-4 12-7 11-9 9-10 6-13 4-15 1h-85l-1191-1-13-4-11-7-5-5-7-8-6-13-2-11v-1531z"
            fill="#323232"
          />
          <path
            transform="translate(1423,94)"
            d="m0 0h1v1860l-3-1v-1857z"
            fill="#717171"
          />
          <path
            transform="translate(46,425)"
            d="m0 0h1l1 1523 3 20 6 12 9 10 10 7 11 4 10 1v1l-13 1-12-5-11-8-8-10-6-13-2-11v-1531z"
            fill="#262626"
          />
          <path
            transform="translate(45,90)"
            d="m0 0 3 1v1857h-1l-1-1522h-1z"
            fill="#6E6E6E"
          />
          <path
            transform="translate(1308,1859)"
            d="m0 0h29l1 4-10 35-4 16-2-1-12-45z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(145,134)"
            d="m0 0 2 1 13 49 1 4h-30l2-9 9-34z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v22l-4 12-7 11-9 9-10 6-13 4-15 1h-85l-137-1 1-2 227-1 14-2 9-4 9-6 7-7 6-11 3-10 1-8 1-1z"
            fill="#323232"
          />
          <path
            transform="translate(88,43)"
            d="m0 0h157v2l-153 1-12 3-11 6-8 7-8 13-3 8-2 8-1 9h-1v-17l5-12 6-9 5-6 10-7 12-5z"
            fill="#414141"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v22l-4 12-7 11-9 9-10 6-9 3h-2l-1-3 10-3 11-7 8-8 6-11 3-10 1-8 1-1z"
            fill="#454545"
          />
          <path
            transform="translate(1384,44)"
            d="m0 0 9 3 10 6 11 11 8 16 1 4v13l-2-1-3-15-4-9-6-9-8-8-14-7-3-2z"
            fill="#3F3F3F"
          />
          <path
            transform="translate(49,1968)"
            d="m0 0h2l6 12 9 10 10 7 11 4 10 1v1l-13 1-12-5-11-8-8-10-5-10z"
            fill="#383838"
          />
          <path
            transform="translate(1423,94)"
            d="m0 0h1v53l-3 1v-52z"
            fill="#626262"
          />
          <path
            transform="translate(1409,1986)"
            d="m0 0v3l-9 8-12 6-6 1-1-3 10-3 15-9z"
            fill="#3E3E3E"
          />
          <path
            transform="translate(84,44)"
            d="m0 0 8 1v1l-12 3-11 6-5 2 2-4 10-6z"
            fill="#333"
          />
          <path
            transform="translate(50,76)"
            d="m0 0 1 4-3 11-1 9h-1v-17l2-6z"
            fill="#383838"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v19l-3 3v-9l1-1z"
            fill="#3A3A3A"
          />
          <path
            transform="translate(78 2e3)"
            d="m0 0 9 1 10 1v1l-13 1-6-2z"
            fill="#3A3A3A"
          />
          <path
            transform="translate(1420,83)"
            d="m0 0 3 1v13l-2-1-1-4z"
            fill="#464646"
          />
          <path
            transform="translate(49,1968)"
            d="m0 0h2l4 8v3h-3l-4-8z"
            fill="#323232"
          />
          <path
            transform="translate(67,1994)"
            d="m0 0 6 1 7 4-4 2-9-6z"
            fill="#2C2C2C"
          />
          <path
            transform="translate(62,56)"
            d="m0 0 3 1-6 8-4 1 2-4z"
            fill="#393939"
          />
          <path
            transform="translate(1409,1986)"
            d="m0 0v3l-8 7h-3l1-3 6-3z"
            fill="#242424"
          />
          <path
            transform="translate(1413,1981)"
            d="m0 0 1 2-4 4-6 5-2-1 8-8z"
            fill="#3D3D3D"
          />
        </>
      )}
    </svg>
  );
}
